export default {
  "brandSeo": {
    "pageTitle": "Miral AI의 {title}",
    "toolDescription": "Miral AI에서 {description}",
    "sectionTitle": "Miral AI로 만나는 {title}",
    "faqTitle": "Miral AI의 {title}",
    "toolFreeTrialCta": "Miral AI에서 이 도구 무료 체험",
    "toolProcessCta": "{action} 무료 체험",
    "imageFaqs": [
      { "q": "Miral에서 AI 이미지 생성을 무료로 체험할 수 있나요?", "a": "네. Miral AI에 가입하면 무료 크레딧을 받고 이미지 생성을 체험할 수 있습니다. 각 생성은 선택한 모델에 필요한 크레딧을 사용합니다." },
      { "q": "Miral AI로 이미지를 생성하는 이유는 무엇인가요?", "a": "Miral AI는 주요 이미지 모델을 한곳에 모아 여러 플랫폼을 옮기지 않고 기능을 비교하며 계속 제작할 수 있게 합니다." }
    ],
    "toolFaqs": [
      { "q": "이 Miral AI 도구를 무료로 체험할 수 있나요?", "a": "네. Miral AI에 로그인하면 무료 체험을 시작할 수 있습니다. 이용 가능 횟수는 계정 조건에 따라 달라지며 무제한 무료 이용을 의미하지 않습니다." },
      { "q": "Miral AI의 제작 도구를 사용하는 이유는 무엇인가요?", "a": "이미지 생성과 실용적인 편집 도구를 한 플랫폼에 결합해 제작, 처리와 결과 다운로드를 하나의 흐름에서 완료할 수 있습니다." }
    ]
  },
  "common": {
    "loading": "로딩 중...",
    "error": "오류가 발생했습니다",
    "success": "성공",
    "confirm": "확인",
    "prev": "이전",
    "next": "다음",
    "optional": "선택 사항",
    "remove": "제거",
    "generate": "생성",
    "generating": "생성 중...",
    "required": "필수",
    "generateFailedContactSupport": "생성에 실패했습니다. 다시 시도하거나 고객 지원에 문의해 주세요!",
    "localMediaTransferFailed": "네트워크 변동으로 서비스 전송 및 연동에 문제가 발생하여 생성이 중단되었습니다. 다시 생성하거나 고객 지원에 문의해 주세요.",
    "errorDetails": "오류 세부 정보",
    "tryAgainOrContactSupportTail": " 다시 시도하거나 고객 지원에 문의해 주세요!",
    "errorCategoryImageSizeInvalid": "이미지 크기가 요구 사항을 충족하지 않습니다. 유효한 이미지를 사용해 주세요",
    "errorCategoryOutputEmptyOrSensitive": "안전 규칙으로 인해 출력이 차단되었거나 결과가 생성되지 않았습니다. 프롬프트/참조 이미지를 조정해 주세요",
    "errorCategoryUpstreamBusy": "서비스가 현재 혼잡합니다（업스트림 부하가 포화 상태）",
    "errorCategoryAiNetworkError": "네트워크 연결에 문제가 있습니다. 네트워크를 확인한 후 다시 시도해 주세요",
    "errorCategoryAiTimeout": "AI 요청 시간이 초과되었습니다. 네트워크가 불안정할 수 있으니 잠시 후 다시 시도해 주세요",
    "close": "닫기",
    "leaveConfirmTitle": "안내",
    "leaveConfirmMessage": "현재 AI 작품이 생성 중입니다. 페이지를 이동해도 생성 진행에는 영향을 주지 않습니다. [내 정보 - 내 작품]에서 처리 중이거나 완료된 작품을 확인할 수 있습니다.\n페이지를 떠나시겠습니까?",
    "leaveConfirmConfirm": "떠나기",
    "leaveConfirmCancel": "머무르기"
  },
  "api": {
    "errors": {
      "requestFailed": "요청 실패",
      "badRequest": "잘못된 요청",
      "unauthorized": "인증되지 않음, 다시 로그인해 주세요",
      "forbidden": "권한 없음",
      "notFound": "리소스를 찾을 수 없습니다",
      "serverError": "내부 서버 오류",
      "timeout": "요청 시간 초과, 다시 시도해 주세요",
      "networkError": "네트워크 오류, 연결 상태를 확인해 주세요",
      "sessionExpired": "세션 만료, 다시 로그인해 주세요",
      "operationFailed": "작업 실패!"
    }
  },
  "nav": {
    "home": "홈",
    "models": "AI 모델",
    "pricing": "요금제",
    "faq": "자주 묻는 질문",
    "login": "로그인",
    "signup": "업그레이드",
    "register": "등록",
    "email": "이메일",
    "logout": "로그아웃",
    "help": "도움말",
    "profile": "프로필",
    "myWorks": "내 작품",
    "username": "사용자 이름",
    "password": "비밀번호",
    "confirmPassword": "비밀번호 확인",
    "processing": "처리 중...",
    "haveAccount": "이미 계정이 있으신가요?",
    "noAccount": "계정이 없으신가요?",
    "orContinueWith": "또는 계속하기",
    "loginFailed": "로그인 실패, 다시 시도해 주세요",
    "registerFailed": "등록 실패, 다시 시도해 주세요",
    "fillRequired": "필수 항목을 모두 입력해 주세요",
    "passwordMismatch": "비밀번호가 일치하지 않습니다",
    "passwordTooShort": "비밀번호는 최소 6자 이상이어야 합니다",
    "googleNotLoaded": "구글 로그인 서비스가 로드되지 않았습니다, 페이지를 새로고침해 주세요",
    "googleInitFailed": "구글 로그인 초기화 실패",
    "googleUserInfoFailed": "사용자 정보를 가져올 수 없습니다",
    "googleCancelled": "구글 로그인 취소됨",
    "codeLoginHint": "이메일을 입력하시면 인증 코드를 보내드립니다",
    "verificationCode": "인증 코드",
    "sendCode": "코드 전송",
    "resendCode": "재전송",
    "verifyAndLogin": "인증 및 로그인",
    "enterEmail": "이메일 주소를 입력해 주세요",
    "invalidEmail": "유효한 이메일 주소를 입력해 주세요",
    "sendCodeFailed": "인증 코드 전송 실패, 다시 시도해 주세요",
    "checkSpamFolder": "이메일을 찾을 수 없나요? 스팸/정크 폴더를 확인해 주세요",
    "enterValidCode": "6자리 인증 코드를 입력해 주세요",
    "verifyCodeFailed": "유효하지 않거나 만료된 인증 코드입니다",
    "googleLoginFailed": "구글 로그인 실패, 다시 시도해 주세요",
    "registerHint": "등록하면 ",
    "and": "및",
    "freeCreditsLabel": "무료 크레딧:",
    "freeCreditsDesc": "로그인만 하면 무료 크레딧을 받을 수 있습니다 — 결제 불필요!",
    "sidebar": {
      "navigation": "네비게이션",
      "home": "홈",
      "inspiration": "영감",
      "history": "기록",
      "allModels": "모든 모델",
      "videoAI": "비디오 AI",
      "videoGenerator": "비디오 생성기",
      "newModels": "신규 모델",
      "otherModels": "기타 모델",
      "videoEnhance": "비디오 향상",
      "musicAI": "AI 음악",
      "musicGenerator": "AI 음악",
      "imageAI": "이미지 AI",
      "imageGenerator": "이미지 생성기",
      "hotModels": "인기 모델",
      "hotTools": "인기 도구",
      "upgrade": "업그레이드"
    }
  },
  "footer": {
    "brand": "Miral",
    "siteTitle": "Miral - AI 이미지, 동영상 및 음악 제작 플랫폼",
    "desc": "이미지, 비디오 및 음악 제작을 위한 올인원 AI 플랫폼.",
    "fluxModels": "FLUX 모델",
    "aiImages": "AI 이미지",
    "aiVideos": "AI 비디오",
    "aiMusic": "AI 음악",
    "product": "제품",
    "videoModels": "AI 비디오 모델",
    "imageModels": "AI 이미지 모델",
    "musicModels": "AI 음악 모델",
    "apps": "앱",
    "company": "회사",
    "about": "회사 소개",
    "contact": "문의하기",
    "blog": "블로그",
    "tools": "도구",
    "resources": "리소스",
    "allModels": "모든 AI 모델",
    "pricing": "요금제",
    "trustSafety": "신뢰 및 안전",
    "terms": "서비스 이용 약관",
    "privacy": "개인정보 보호정책",
    "faq": "자주 묻는 질문",
    "musicGenerator": "AI 음악 생성기",
    "copyright": "© 2025 Miral. 모든 권리 보유.",
    "langZh": "简体中文",
    "langEn": "English"
  },
  "about": {
    "tag": "Miral 소개",
    "title": "회사 소개",
    "subtitle": "이미지, 영상, 음악을 한곳에서 만드세요.",
    "paragraphs": [
      "Miral은 크리에이터, 디자이너, 비즈니스를 위한 AI 창작 플랫폼입니다. 이미지·영상 생성, AI 음악, 워터마크 제거와 문서 도구를 제공합니다.",
      "브라우저에서 아이디어부터 완성까지 이어지도록 주요 모델과 안정적인 경로를 계속 확장합니다.",
      "데이터 관련 내용은 신뢰와 안전 페이지를 확인하거나 지원팀에 문의하세요."
    ]
  },
  "contact": {
    "tag": "지원",
    "title": "문의하기",
    "subtitle": "질문과 피드백에 빠르게 답변드리겠습니다.",
    "emailLabel": "지원 이메일",
    "hint": "결제, 크레딧, 생성 관련 문의는 이메일로 보내 주세요. 영업일 기준 답변드립니다.",
    "cta": "이메일 보내기"
  },
  "models": {
    "image": {
      "nano-banana": {
        "name": "Nano Banana Pro",
        "desc": "시네마급 리얼리즘. 피부결, 재질 텍스처, 조명 디테일까지 자연스럽게 표현"
      },
      "nano-banana-31": {
        "name": "Nano Banana 3.1",
        "desc": "멀티 해상도 이미지 생성, v2.5 및 v3.1 모드 지원"
      },
      "seedream-4": {
        "name": "Seedream 4",
        "desc": "아티스틱 스타일"
      },
      "seedream-5": {
        "name": "Seedream 5",
        "desc": "아티스틱 스타일"
      },
      "midjourney": {
        "name": "Midjourney",
        "desc": "아티스틱 스타일"
      },
      "gpt-image-1": {
        "name": "GPT-Image-1",
        "desc": "다용도"
      },
      "gpt-image-1-5": {
        "name": "GPT-Image-1-5",
        "desc": "다용도"
      },
      "flux-pro-1-1-ultra": {
        "name": "Flux Pro 1.1 Ultra",
        "desc": "고품질 텍스트-이미지"
      },
      "flux-schnell": {
        "name": "Flux Schnell",
        "desc": "빠른 텍스트-이미지"
      },
      "flux-2": {
        "name": "FLUX.2",
        "desc": "차세대 텍스트-이미지"
      },
      "flux-kontext": {
        "name": "Flux Kontext",
        "desc": "고품질 텍스트-이미지 및 편집"
      },
      "qwen-image-2-0-pro": {
        "name": "Qwen Image 2.0 Pro",
        "desc": "고해상도 텍스트-이미지 생성 및 세부 디테일"
      },
      "z-image-turbo": {
        "name": "Z Image Turbo",
        "desc": "고해상도 텍스트-이미지 생성"
      },
      "sd-3-5": {
        "name": "Stable Diffusion 3.5",
        "desc": "Stable Diffusion 3.5 텍스트-이미지 생성"
      }
    },
    "video": {
      "pollodance": {
        "name": "Pollo Dance",
        "desc": "모션 제어·참조·시네마틱 스타일"
      },
      "seegen": {
        "name": "SeeGen",
        "desc": "텍스트·이미지에서 비디오, 다중 해상도"
      },
      "seedance": {
        "name": "Seedance AI",
        "desc": "네이티브 오디오-비주얼 동기화"
      },
      "wan-2-5": {
        "name": "Wan 2.5",
        "desc": "애니메이션 스타일"
      },
      "wan-2-6": {
        "name": "Wan 2.6",
        "desc": "향상된 품질"
      },
      "veo-3-1": {
        "name": "Veo 3.1",
        "desc": "멀티 이미지 레퍼런스"
      },
      "veo-3-1-fast": {
        "name": "Veo 3.1 Fast",
        "desc": "빠름, 테일 프레임 지원"
      },
      "kling-2-6": {
        "name": "Kling 2.6",
        "desc": "립 싱크"
      },
      "kling-3": {
        "name": "Kling 3",
        "desc": "립 싱크"
      },
      "sora-2": {
        "name": "Sora 2",
        "desc": "4초 / 8초 / 12초"
      },
      "kling-2-5": {
        "name": "Kling 2.5",
        "desc": "표준"
      },
      "wan-2-2": {
        "name": "Wan 2.2",
        "desc": "클래식"
      },
      "vidu-q3-pro": {
        "name": "Vidu Q3 Pro",
        "desc": "텍스트/이미지 동영상, 다중 해상도"
      },
      "veo-3-0": {
        "name": "Veo 3.0",
        "desc": "텍스트/이미지에서 비디오로"
      },
      "hailuo-2-3": {
        "name": "Hailuo 2.3",
        "desc": "창의적 비디오"
      },
      "runway": {
        "name": "Runway",
        "desc": "워크벤치"
      },
      "wan-animate": {
        "name": "Wan Animate",
        "desc": "참조 이미지와 동영상으로 캐릭터 애니메이션. 표준/프로 품질, 선택적 워터마크."
      }
    }
  },
  "tools": {
    "demoTitle": "데모",
    "page": {
      "tag": "AI 도구 상자",
      "title": "전문적인 AI 도구 상자",
      "subtitle": "워터마크 제거, 사진 복원, HD 업스케일링, 비디오 향상 등 포스트 프로덕션에 필요한 전문 도구.",
      "allTools": "모든 도구"
    },
    "detail": {
      "useNow": "지금 사용",
      "clickUpload": "클릭하거나 드래그하여 업로드 ",
      "support": "지원",
      "reupload": "재업로드",
      "scale": "스케일",
      "process": "처리",
      "processing": "처리 중...",
      "before": "이전",
      "after": "이후",
      "download": "결과 다운로드",
      "processNew": "새 파일 처리",
      "howToUse": "사용 방법",
      "moreTools": "더 많은 도구",
      "notFound": "도구를 찾을 수 없음",
      "backToList": "도구 목록으로 돌아가기",
      "loginRequired": "로그인 필요",
      "loginRequiredDesc": "이 도구를 사용하려면 로그인하세요",
      "loginNow": "지금 로그인",
      "demo": "데모",
      "uploadOriginalFailed": "원본 이미지 업로드에 실패했습니다. 다시 시도해 주세요"
    },
    "steps": {
      "upload": {
        "title": "파일 업로드",
        "desc": "처리할 이미지 또는 비디오 파일을 선택하거나 드래그 앤 드롭하세요."
      },
      "adjust": {
        "title": "설정 조정",
        "desc": "스케일 팩터 및 출력 형식 등의 처리 매개변수를 구성하세요."
      },
      "process": {
        "title": "원클릭 처리",
        "desc": "AI가 자동으로 처리하며, 일반적으로 몇 초에서 몇 분 내에 완료됩니다."
      },
      "download": {
        "title": "결과 다운로드",
        "desc": "결과를 미리보기하고 고품질 출력물을 다운로드하세요."
      }
    },
    "fileTypes": {
      "image": "이미지",
      "video": "비디오"
    },
    "watermarkRemover": {
      "name": "워터마크 제거기",
      "desc": "AI로 이미지 워터마크를 원클릭 제거",
      "fullDesc": "이미지 품질을 유지하면서 AI 기반 워터마크 제거. 일괄 처리, 자동 워터마크 감지 및 원본 이미지를 손상시키지 않고 정확하게 제거를 지원합니다."
    },
    "backgroundRemover": {
      "name": "배경 제거",
      "desc": "AI로 이미지 배경을 원클릭 제거",
      "fullDesc": "AI 원클릭 배경 제거. 피사체 윤곽을 정확히 감지하고 머리카락 등 세부 사항을 유지하여 투명 배경 이미지로 출력합니다."
    },

    "photoRestore": {
      "name": "사진 복원",
      "desc": "AI 기술로 오래되었거나 흐릿하거나 손상된 사진을 복원합니다",
      "fullDesc": "AI 기술로 오래되었거나 흐릿하거나 손상된 사진을 복원합니다. 노이즈 제거, 선명도 조절 및 누락된 부분 채우기를 지원하여 소중한 추억을 되살립니다."
    },
    "imageEnhancer": {
      "name": "이미지 향상기",
      "desc": "AI로 이미지 선명도를 원클릭 향상",
      "fullDesc": "이미지를 4K 해상도로 업스케일하고 세부 정보를 향상시킵니다. 고급 AI 알고리즘을 사용하여 세부 정보를 강조하고 흐릿한 이미지를 선명하고 깨끗하게 만듭니다."
    },
    "videoEnhancer": {
      "name": "비디오 향상기",
      "desc": "비디오를 4K 해상도로 업스케일하고 선명도를 향상시킵니다",
      "fullDesc": "비디오를 4K 해상도로 업스케일하고 선명도를 향상시킵니다. 다양한 비디오 형식을 지원하며 AI 기반 프레임 보간을 통해 놀라운 HD 품질을 제공합니다."
    },
    "watermark-remover": {
      "name": "워터마크 제거기",
      "desc": "이미지 품질을 유지하면서 AI 기반 워터마크 제거",
      "fullDesc": "이미지 품질을 유지하면서 AI 기반 워터마크 제거. 일괄 처리, 자동 워터마크 감지 및 원본 이미지를 손상시키지 않고 정확하게 제거를 지원합니다.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 이하의 파일(JPG, PNG, WebP)을 사용해 주세요.",
      "notImageFile": "이미지 파일을 업로드해주세요.",
      "noImageInResponse": "결과 이미지가 반환되지 않았습니다. 나중에 다시 시도해 주세요.",
      "downloadName": "watermark-removed.png",
      "aiRepair": "워터마크 제거",
      "uploadLabel": "이미지 업로드",
      "uploadHint": "최대 15MB의 JPG, PNG 또는 WebP 이미지를 지원합니다.",
      "featuresKicker": "빠르고 정확함",
      "featuresTitle": "온라인 사진에서 다양한 워터마크 제거",
      "featuresIntro": "JPG, PNG 또는 WebP 이미지를 업로드하면 AI가 워터마크 영역을 감지하고 수동 브러싱 없이 배경을 재구성할 수 있습니다.",
      "features": [
        {
          "title": "전체 이미지 워터마크 지우기",
          "desc": "전체 이미지를 덮고 있는 반복되는 반투명 텍스트나 패턴 워터마크를 제거하면 더욱 깔끔한 결과를 얻을 수 있습니다.",
          "cta": "AI 워터마크 리무버를 무료로 사용해 보세요"
        },
        {
          "title": "타임스탬프 및 날짜 표시 제거",
          "desc": "사진 모서리의 날짜, 타임스탬프, 카메라 표시를 지우고 배경을 재구성합니다.",
          "cta": "온라인으로 이미지 워터마크 삭제"
        },
        {
          "title": "브랜드 로고 지우기",
          "desc": "편집 권한이 있는 이미지에서 브랜드 로고, 코너 배지, 홍보 표시를 제거하세요.",
          "cta": "지금 사진 워터마크 제거"
        },
        {
          "title": "깨끗한 텍스트 및 초안 표시",
          "desc": "미리보기, 디자인 초안, 사진에서 텍스트 오버레이를 제거하여 더욱 깔끔한 시각적 콘텐츠를 만듭니다.",
          "cta": "지금 워터마크 제거제를 사용해 보세요"
        }
      ],
      "useCasesKicker": "사용 사례",
      "useCasesTitle": "AI 이미지 워터마크 제거제는 무엇을 청소할 수 있나요?",
      "audienceLabels": [
        "전자상거래 판매자",
        "마케팅 팀",
        "디자이너 및 크리에이터",
        "패션 및 의류 매장"
      ],
      "audienceCases": [
        {
          "title": "3배 더 빠르게 제품 비주얼 준비",
          "desc": "세련된 제품 목록 이미지를 만들기 전에 승인된 제품 사진, 공급업체 이미지 또는 초안 자산을 먼저 정리하세요. 쇼핑객이 제품에 집중할 수 있도록 방해가 되는 표시를 제거하세요."
        },
        {
          "title": "수동 정리 작업을 60% 줄이고 캠페인 자산을 더 빠르게 생성하세요",
          "desc": "소유 또는 라이센스가 있는 시각적 개체를 광고, 배너 및 브랜드 그래픽으로 전환하기 전에 원치 않는 워터마크를 제거하십시오. 깨끗한 자산은 캠페인 프로모션, 제품 출시, 제품 포스터로 더 빠르게 이동할 수 있습니다."
        },
        {
          "title": "깨끗한 이미지를 새롭고 창의적인 컨셉으로 더 빠르게 전환하세요",
          "desc": "처음부터 다시 구축하지 않고도 깔끔한 소스 이미지로 시작하여 새로운 디자인 방향을 탐색할 수 있습니다. 정리된 초안을 AI 스케치, 컨셉 아트 또는 포스터 스타일 비주얼에 대한 참조로 사용하세요."
        },
        {
          "title": "재촬영 없이 제품 카탈로그 이미지 새로 고침",
          "desc": "카탈로그 업데이트, 시즌 출시 또는 AI 가상 시착 영상을 준비하기 전에 쇼핑객이 핏, 소재, 제품 세부 사항에 집중할 수 있도록 승인된 의류 사진을 정리하세요."
        }
      ],
      "useCases": [
        {
          "title": "제품 사진 워터마크 제거",
          "desc": "귀하의 자산을 재배치하기 전에 제품 사진의 텍스트, 로고 및 홍보 표시를 정리하십시오."
        },
        {
          "title": "소셜 사진의 워터마크 제거",
          "desc": "더 깔끔한 게시 버전을 위해 자신의 사진에서 플랫폼 표시나 타임스탬프를 제거하세요."
        },
        {
          "title": "여러 워터마크 지우기",
          "desc": "하나의 이미지에 여러 개의 워터마크가 포함되어 있는 경우 AI는 덮여 있는 여러 영역을 감지하고 청소할 수 있습니다."
        }
      ],
      "howToKicker": "세 가지 간단한 단계",
      "howToTitle": "온라인에서 무료로 이미지의 워터마크를 제거하는 방법",
      "howToIntro": "소프트웨어 설치가 필요하지 않습니다. 이미지를 업로드하고, AI 워터마크 제거 프로그램을 실행하고, 정리된 결과를 다운로드하세요.",
      "howToCta": "지금 온라인으로 워터마크 제거",
      "steps": {
        "upload": {
          "title": "워터마크가 있는 이미지 업로드",
          "desc": "15MB 미만의 JPG, PNG 또는 WebP 이미지를 선택하세요. 편집 및 사용 권한이 있는지 확인하세요."
        },
        "remove": {
          "title": "AI로 워터마크 제거",
          "desc": "처리를 시작하면 AI가 로고, 텍스트, 타임스탬프 또는 전체 이미지 워터마크를 감지하고 배경을 재구성합니다."
        },
        "download": {
          "title": "미리보기 및 다운로드",
          "desc": "전후 결과를 비교한 후, 정리된 이미지를 다운로드하거나 다른 이미지를 업로드하세요."
        }
      },
      "faqTitle": "AI 워터마크 리무버 FAQ",
      "faqs": [
        {
          "q": "AI 워터마크 제거기란 무엇인가요?",
          "a": "AI 워터마크 제거기는 워터마크 영역을 감지하고 근처 색상, 질감 및 이미지 콘텐츠를 사용하여 가려진 배경을 재구성합니다."
        },
        {
          "q": "온라인에서 사진의 워터마크를 무료로 제거하는 방법은 무엇입니까?",
          "a": "가입하고 Miral AI 워터마크 제거기에 이미지를 업로드한 후 처리를 시작하여 정리된 결과를 미리 봅니다."
        },
        {
          "q": "어떤 이미지 형식이 지원되나요?",
          "a": "이 도구는 현재 15MB 미만의 JPG, PNG 및 WebP 이미지를 지원합니다. 이 페이지는 비디오의 워터마크를 제거하지 않습니다."
        },
        {
          "q": "전체 이미지 워터마크, 로고, 타임스탬프를 제거할 수 있나요?",
          "a": "그렇습니다. AI는 반복되는 전체 이미지 워터마크, 브랜드 로고, 날짜 스탬프, 텍스트 및 초안 표시를 처리할 수 있습니다. 결과는 불투명도, 덮힌 영역 및 배경의 복잡성에 따라 달라집니다."
        },
        {
          "q": "한 사진에서 여러 로고나 타임스탬프를 제거하려면 어떤 도구를 사용할 수 있나요?",
          "a": "Miral AI 워터마크 제거기는 로고 및 타임스탬프를 포함한 여러 워터마크 영역을 처리할 수 있습니다. 큰 표시가 사람이나 복잡한 질감을 덮는 경우 미리보기를 확인하세요."
        },
        {
          "q": "이미지에서 워터마크를 제거하는 것이 합법적인가요?",
          "a": "귀하가 소유하고 편집 권한이 있거나 합법적으로 사용할 수 있는 이미지만 처리하십시오. 허가 없이 저작권 워터마크를 제거하는 것은 소유자의 권리를 침해할 수 있습니다."
        },
        {
          "q": "워터마크를 제거한 후 흐릿한 부분을 수정하는 방법은 무엇입니까?",
          "a": "사용 가능한 최고 품질의 소스 이미지로 시작하고 다운로드하기 전에 미리보기를 확인하세요. AI는 원본 구도, 해상도, 디테일을 보존하려고 시도하지만, 큰 워터마크로 가려진 콘텐츠는 재구성해야 하므로 로컬 결과가 원본과 다를 수 있습니다."
        }
      ]
    },
    "full-watermark-remover": {
      "name": "AI 워터마크 제거",
      "desc": "AI로 이미지의 워터마크를 제거합니다",
      "fullDesc": "AI로 이미지의 워터마크를 감지하고 제거하면서 원본 내용, 세부 묘사, 품질을 보존합니다.",
      "audienceLabels": ["이커머스 판매자", "마케팅 팀", "디자이너 및 크리에이터", "패션·의류 매장"],
      "audienceCases": [
        { "title": "상품 비주얼 준비 속도 3배 향상", "desc": "완성도 높은 상품 목록 이미지를 만들기 전에 사용 권한이 있는 상품 사진, 공급업체 이미지 또는 초안 소재를 먼저 정리하세요. 방해되는 표시를 제거해 구매자가 상품 자체에 집중할 수 있습니다." },
        { "title": "수작업 정리를 60% 줄이고 캠페인 소재를 빠르게 제작", "desc": "보유하거나 사용 허가를 받은 비주얼을 광고, 배너, 브랜드 그래픽으로 제작하기 전에 불필요한 워터마크를 제거하세요. 깨끗한 소재를 캠페인 홍보, 신제품 출시, 상품 포스터에 더 빠르게 활용할 수 있습니다." },
        { "title": "깨끗한 이미지를 새로운 크리에이티브로 빠르게 전환", "desc": "처음부터 다시 만들 필요 없이 정돈된 원본 이미지에서 새로운 디자인 방향을 탐색하세요. 워터마크를 제거한 초안을 AI 스케치, 콘셉트 아트 또는 포스터 스타일 비주얼의 참고 자료로 활용할 수 있습니다." },
        { "title": "재촬영 없이 상품 카탈로그 이미지 새단장", "desc": "카탈로그 업데이트, 시즌 신상품 또는 AI 가상 피팅 이미지를 준비하기 전에 사용 권한이 있는 의류 사진을 정리해 구매자가 핏, 원단, 상품 디테일에 집중하도록 하세요." }
      ],
      "notImageFile": "유효한 이미지 파일을 업로드해 주세요.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 이하의 이미지를 선택해 주세요.",
      "downloadName": "전체-워터마크-제거.png"
    },
    "ai-text-remover": {
      "name": "AI 텍스트 제거",
      "desc": "AI로 이미지의 불필요한 텍스트를 제거합니다",
      "fullDesc": "AI로 이미지의 불필요한 텍스트를 제거하면서 배경, 질감, 자연스러운 세부 묘사를 최대한 보존합니다.",
      "notImageFile": "유효한 이미지 파일을 업로드해 주세요.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 이하의 이미지를 선택해 주세요.",
      "downloadName": "텍스트-제거.png"
    },
    "ai-logo-remover": {
      "name": "AI 로고 제거",
      "desc": "AI로 이미지의 불필요한 로고를 제거합니다",
      "fullDesc": "AI로 이미지의 불필요한 로고를 제거하면서 배경, 질감, 자연스러운 세부 묘사를 최대한 보존합니다.",
      "notImageFile": "유효한 이미지 파일을 업로드해 주세요.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 이하의 이미지를 선택해 주세요.",
      "downloadName": "로고-제거.png"
    },
    "ai-passersby-remover": {
      "name": "AI 행인 제거",
      "desc": "AI로 이미지의 행인을 제거합니다",
      "fullDesc": "AI로 이미지의 행인을 감지하고 제거하면서 피사체, 배경 질감, 자연스러운 이미지 세부 묘사를 보존합니다.",
      "notImageFile": "유효한 이미지 파일을 업로드해 주세요.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 이하의 이미지를 선택해 주세요.",
      "downloadName": "행인-제거.png"
    },
    "background-remover": {
      "name": "배경 제거",
      "desc": "AI 원클릭 배경 제거, 피사체 유지",
      "heroTitle": "무료 AI 배경 제거로 투명 PNG 만들기",
      "fullDesc": "JPG, PNG 또는 WebP 이미지를 업로드하면 AI가 인물, 제품과 피사체 경계를 자동 감지합니다. 머리카락 같은 세부 윤곽을 살리고 Photoshop 없이 투명 PNG를 다운로드하세요.",
      "uploadLabel": "배경을 제거할 이미지 업로드",
      "uploadHint": "클릭하거나 이미지를 끌어다 놓으세요",
      "uploadSpec": "15MB 이하 JPG, PNG, WebP 지원. 결과는 투명 PNG로 다운로드됩니다.",
      "processButton": "이미지 배경 제거",
      "previewAlt": "AI 배경 제거 전 이미지 미리보기",
      "demoBeforeAlt": "배경 제거 전 인물 사진",
      "demoAfterAlt": "AI로 배경을 제거한 인물 사진",
      "processingAlt": "AI가 이미지 배경을 제거하는 중",
      "processingLabel": "누끼 처리 중",
      "resultLabel": "투명 배경 준비 완료",
      "resultBeforeAlt": "배경 제거 전 원본 이미지",
      "resultAfterAlt": "AI 배경 제거 후 투명 PNG",
      "productBeforeAlt": "배경 제거 전 제품 사진",
      "productAfterAlt": "투명 배경 제품 PNG",
      "featuresKicker": "정밀한 피사체 감지",
      "featuresTitle": "인물과 제품 사진을 위한 온라인 AI 배경 제거",
      "featuresIntro": "복잡한 인물 경계부터 쇼핑몰 제품 누끼까지, 브러시나 패스 작업 없이 AI가 피사체와 배경을 자동 분리합니다.",
      "features": [
        { "title": "머리카락을 살린 인물 배경 제거", "desc": "인물, 의상, 미세한 머리카락 경계를 감지해 프로필 사진, 증명사진 소재, 포스터와 SNS 이미지를 깔끔하게 분리합니다.", "cta": "인물 배경 무료 제거" },
        { "title": "제품 사진 원클릭 누끼", "desc": "테이블, 벽과 촬영 배경을 제거해 흰 배경 상품 이미지, 상세 페이지와 광고 디자인에 쓸 투명 소재를 만듭니다.", "cta": "제품 배경 온라인 제거" },
        { "title": "투명 배경 PNG 다운로드", "desc": "투명 채널을 유지해 새 배경, 배너, 프레젠테이션, 썸네일과 디자인에 바로 사용할 수 있습니다.", "cta": "이미지 배경 투명하게" }
      ],
      "featureAlts": { "portraitBefore": "인물 사진 배경 제거 전", "portraitAfter": "머리카락을 살린 인물 누끼", "productBefore": "제품 사진 배경 제거 전", "productAfter": "투명 배경 제품 누끼", "ecommerceBefore": "쇼핑몰 제품 이미지 배경 제거 전", "ecommerceAfter": "쇼핑몰 제품용 투명 PNG" },
      "useCasesKicker": "주요 활용 사례",
      "useCasesTitle": "AI 원클릭 누끼에 적합한 이미지",
      "useCasesIntro": "독립된 피사체나 투명 이미지 소재가 필요한 일상 디자인과 상업 작업에 활용하세요.",
      "useCases": [
        { "title": "쇼핑몰 제품 이미지", "desc": "카탈로그, 스토어와 마케팅용 투명 제품 소재를 제작합니다." },
        { "title": "인물과 프로필 사진", "desc": "머리카락과 의상 경계를 살리며 복잡한 배경을 제거합니다." },
        { "title": "SNS 디자인", "desc": "인물이나 제품을 커버, 게시물과 썸네일에 배치합니다." },
        { "title": "증명사진과 비즈니스 사진", "desc": "인물을 분리한 뒤 필요한 단색 배경을 추가합니다." },
        { "title": "로고와 그래픽 소재", "desc": "불필요한 바탕색을 제거해 웹과 포스터에서 재사용합니다." },
        { "title": "광고와 그래픽 디자인", "desc": "자유롭게 배치할 투명 PNG를 빠르게 준비합니다." }
      ],
      "howToKicker": "간단한 3단계",
      "howToTitle": "온라인에서 이미지 배경을 무료로 제거하는 방법",
      "howToIntro": "이미지를 업로드하고 AI 자동 누끼를 실행한 다음 투명 PNG를 다운로드하세요.",
      "steps": [
        { "title": "JPG, PNG 또는 WebP 업로드", "desc": "15MB 이하의 선명한 인물, 제품 또는 디자인 이미지를 선택합니다." },
        { "title": "AI로 배경 자동 제거", "desc": "AI가 중요한 경계를 유지하며 피사체와 배경을 분리합니다." },
        { "title": "투명 PNG 확인 및 다운로드", "desc": "전후 결과를 비교하고 투명 이미지를 저장합니다." }
      ],
      "faqTitle": "AI 배경 제거 자주 묻는 질문",
      "faqs": [
        { "q": "온라인에서 이미지 배경을 무료로 제거하려면?", "a": "JPG, PNG 또는 WebP를 업로드하고 배경 제거를 시작하세요. AI가 피사체를 감지해 투명 PNG를 만듭니다." },
        { "q": "머리카락과 미세한 경계도 보존할 수 있나요?", "a": "AI는 머리카락, 의상과 작은 경계를 최대한 유지합니다. 피사체와 배경 대비가 뚜렷할수록 자연스러운 결과를 얻기 쉽습니다." },
        { "q": "제품 사진 배경도 제거할 수 있나요?", "a": "예. 피사체가 선명한 제품 사진은 쇼핑몰과 광고용 투명 소재 제작에 적합합니다." },
        { "q": "처리 후 어떤 파일 형식으로 받나요?", "a": "투명 채널을 지원하는 PNG로 다운로드합니다." },
        { "q": "지원 형식과 파일 크기는?", "a": "15MB 이하 JPG, PNG, WebP 이미지를 지원합니다." },
        { "q": "Photoshop을 설치해야 하나요?", "a": "아니요. 브라우저에서 AI가 자동으로 배경을 제거합니다." }
      ],
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 JPG, PNG, WebP를 사용해 주세요.",
      "notImageFile": "이미지 파일을 업로드해 주세요.",
      "noImageInResponse": "결과 이미지를 가져오지 못했습니다. 나중에 다시 시도해 주세요.",
      "downloadName": "배경제거결과.png"
    },
    "image-eraser": {
      "name": "이미지 지우개",
      "desc": "AI로 이미지에서 객체, 인물, 워터마크를 제거",
      "fullDesc": "AI 기반 이미지 지우개. 사진에서 원치 않는 객체, 인물, 워터마크, 텍스트 위를 브러시로 칠하면 AI가 자연스럽게 지우고 해당 영역을 자연스러운 콘텐츠로 채웁니다. 사진 정리와 방해 요소 제거에 적합.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 파일을 사용해 주세요 (JPG, PNG, WebP).",
      "notImageFile": "이미지 파일을 업로드해 주세요.",
      "noImageInResponse": "결과 이미지를 가져오지 못했습니다. 나중에 다시 시도해 주세요.",
      "downloadName": "image-erased.png"
    },
    "object-remover": {
      "name": "오브젝트 제거",
      "desc": "AI로 사진에서 불필요한 객체를 제거",
      "fullDesc": "AI 기반 오브젝트 제거 도구. 사진에서 원치 않는 객체 위를 브러시로 칠하면 AI가 자연스럽게 지우고 해당 영역을 자연스러운 콘텐츠로 채웁니다. 사진 정리와 방해 요소 제거에 적합.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 파일을 사용해 주세요 (JPG, PNG, WebP).",
      "notImageFile": "이미지 파일을 업로드해 주세요.",
      "noImageInResponse": "결과 이미지를 가져오지 못했습니다. 나중에 다시 시도해 주세요.",
      "downloadName": "object-removed.png",
      "uploadLabel": "이미지 업로드",
      "uploadHint": "이미지를 업로드하려면 클릭하거나 드래그하세요.",
      "uploadSpec": "JPG, PNG 또는 WebP 이미지를 지원합니다.",
      "maskHint": "AI가 제거할 개체의 모든 부분을 브러시로 칠합니다.",
      "processButton": "개체 제거",
      "demoBeforeAlt": "원하지 않는 물체를 제거하기 전의 사진",
      "demoAfterAlt": "원하지 않는 물체를 제거한 후의 사진",
      "processingAlt": "표시된 사진을 AI로 처리",
      "resultBeforeAlt": "물체 제거 전 원본 사진",
      "resultAfterAlt": "물체 제거 후 깨끗한 사진",
      "featureImageLabels": {
        "object": "원하지 않는 물체 제거 예",
        "person": "사람 제거 예",
        "distraction": "배경 방해 요소 제거 예"
      },
      "featuresKicker": "정확한 사진 정리",
      "featuresTitle": "온라인 사진에서 원하지 않는 개체 제거",
      "featuresIntro": "배경을 수동으로 다시 구성하지 않고도 청소할 정확한 영역을 표시하고 AI 개체 제거를 사용하여 일상적인 사진 촬영에 방해가 됩니다.",
      "features": [
        {
          "title": "불필요한 개체를 제거합니다.",
          "desc": "조정 가능한 브러시를 사용하여 어수선한 것, 표지판, 소품 또는 기타 물체를 표시하십시오. AI는 선택한 영역을 제거하고 주변 이미지 세부정보로 채웁니다.",
          "cta": "무료로 개체 제거"
        },
        {
          "title": "사진 배경에서 사람 제거",
          "desc": "사진 폭탄 테러범, 관광객, 행인이 여행 사진이나 인물 사진에서 주요 피사체에 집중하지 못하게 하세요.",
          "cta": "깨끗한 사진 배경 무료"
        },
        {
          "title": "작은 배경 방해 요소 지우기",
          "desc": "전선, 상자, 거리의 어수선한 부분, 표시 또는 분리된 시각적 방해 요소를 제거하여 더욱 깔끔한 구성을 만듭니다.",
          "cta": "방해가 되는 사진을 무료로 삭제하세요"
        }
      ],
      "useCasesKicker": "인기 있는 사용 사례",
      "useCasesTitle": "AI 개체 제거기로 무엇을 제거할 수 있나요?",
      "useCasesIntro": "원하지 않는 영역을 명확하게 브러시하고 사진의 나머지 부분은 변경하지 않고 유지할 수 있는 집중 편집용으로 설계되었습니다.",
      "useCases": [
        {
          "title": "여행 사진 정리",
          "desc": "휴가 사진에서 행인, 표지판, 쓰레기통, 거리의 잡동사니를 제거하세요."
        },
        {
          "title": "제품 사진 정리",
          "desc": "제품 주변의 소품, 라벨, 케이블, 방해가 되는 물건을 제거하세요."
        },
        {
          "title": "인물 배경 정리",
          "desc": "피사체의 관심을 끄는 배경의 사람과 작은 물체를 제거하세요."
        },
        {
          "title": "부동산 사진",
          "desc": "방이나 건물 이미지에서 임시로 어수선한 물건과 분리된 개체를 정리합니다."
        },
        {
          "title": "소셜 미디어 이미지",
          "desc": "게시하기 전에 프레임에서 눈에 띄는 방해 요소를 제거하여 사진을 다듬으세요."
        },
        {
          "title": "창의적인 사진 편집",
          "desc": "레이아웃이나 시각적 프로젝트에서 이미지를 재사용하기 전에 선택한 영역을 지웁니다."
        }
      ],
      "howToKicker": "세 가지 간단한 단계",
      "howToTitle": "온라인으로 사진에서 개체를 제거하는 방법",
      "howToIntro": "사진을 업로드하고 원하지 않는 개체를 브러시한 후 AI로 정리된 결과를 다운로드하세요.",
      "steps": [
        {
          "title": "사진 업로드",
          "desc": "지우고 싶은 사람, 항목, 방해 요소가 포함된 이미지를 선택하세요."
        },
        {
          "title": "개체 위로 브러시",
          "desc": "브러시를 조정하고 원하지 않는 부분을 완전히 덮으십시오. 실행 취소 또는 지우개를 사용하여 마스크를 다듬습니다."
        },
        {
          "title": "제거 및 다운로드",
          "desc": "AI 처리를 시작하고 전후 이미지를 비교한 후 정리된 사진을 다운로드합니다."
        }
      ],
      "faqTitle": "AI 개체 제거기 FAQ",
      "faqs": [
        {
          "q": "온라인으로 사진에서 원하지 않는 물체를 제거하는 방법은 무엇입니까?",
          "a": "사진을 업로드하고 원하지 않는 개체 전체를 브러시로 칠한 후 처리를 시작합니다. AI는 주변 색상, 질감, 장면 세부정보를 사용하여 선택한 영역을 재구성합니다."
        },
        {
          "q": "사진 배경에서 사람을 제거하려면 어떤 도구를 사용할 수 있나요?",
          "a": "브러시를 사용하여 사람을 덮고 그림자나 들고 있는 물건과 같은 세부 사항을 포함합니다. 일반적으로 주변 배경이 보일 때 결과가 더 좋습니다."
        },
        {
          "q": "AI가 표지판, 전선, 쓰레기통, 거리의 어수선한 것들을 제거할 수 있나요?",
          "a": "그렇습니다. 원하지 않는 부분을 명확하게 표시하고, 보관하고 싶은 주변 피사체를 가리지 마세요. 작고 고립된 방해 요소는 일반적으로 재구성하기가 더 쉽습니다."
        },
        {
          "q": "보다 자연스러운 이물질 제거 결과를 얻으려면 어떻게 해야 합니까?",
          "a": "선명한 고품질 소스 이미지를 사용하고 개체 가장자리보다 약간 높게 브러시를 사용합니다. 여러 물체가 겹칠 때 어려운 부분을 별도로 처리합니다."
        },
        {
          "q": "물체 제거제를 사용하면 사진 전체가 바뀌나요?",
          "a": "제거 요청은 브러시드 마스크를 기반으로 합니다. AI가 가장자리 주변의 픽셀을 재구성해야 하지만 도구는 선택한 영역에 초점을 맞춥니다."
        },
        {
          "q": "어떤 이미지 형식을 업로드할 수 있나요?",
          "a": "업로드 컨트롤은 JPG, PNG 및 WebP를 포함한 일반적인 이미지 형식을 허용합니다."
        }
      ]
    },
    "ai-person-remover": {
      "name": "AI 인물 제거",
      "desc": "AI로 사진에서 불필요한 인물을 제거",
      "fullDesc": "AI 기반 인물 제거 도구. 사진에서 원치 않는 인물 위를 브러시로 칠하면 AI가 자연스럽게 지우고 해당 영역을 자연스러운 콘텐츠로 채웁니다. 사진에 우연히 찍힌 지나가는 사람과 낯선 사람 제거에 적합.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 파일을 사용해 주세요 (JPG, PNG, WebP).",
      "notImageFile": "이미지 파일을 업로드해 주세요.",
      "noImageInResponse": "결과 이미지를 가져오지 못했습니다. 나중에 다시 시도해 주세요.",
      "downloadName": "person-removed.png"
    },
    "background-blur": {
      "name": "배경 블러",
      "desc": "AI 원클릭 배경 블러로 피사체 강조",
      "fullDesc": "AI가 전경 피사체(사람/사물)를 자동 인식해 피사체는 선명하게 유지하고 배경에 가우시안 블러를 적용하여 인물 사진 모드와 같은 아웃포커스 효과를 만듭니다. 인물 사진, 상품 클로즈업에 적합.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 JPG, PNG, WebP를 사용해 주세요.",
      "notImageFile": "이미지 파일을 업로드해 주세요.",
      "noImageInResponse": "결과 이미지를 가져오지 못했습니다. 나중에 다시 시도해 주세요.",
      "downloadName": "배경블러결과.png"
    },
    "white-background": {
      "name": "흰색 배경 교체",
      "desc": "AI 원클릭 흰색 배경 교체",
      "fullDesc": "AI 원클릭 흰색 배경 교체. 피사체 윤곽을 정확히 감지하고 머리카락 등 세부 사항을 유지하여 흰색 배경 이미지로 출력합니다. 상품 사진, 증명사진에 적합.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 JPG, PNG, WebP를 사용해 주세요.",
      "notImageFile": "이미지 파일을 업로드해 주세요.",
      "noImageInResponse": "결과 이미지를 가져오지 못했습니다. 나중에 다시 시도해 주세요.",
      "downloadName": "흰색배경결과.png"
    },
    "blue-background": {
      "name": "파란색 배경 교체",
      "desc": "AI 원클릭 파란색 배경 교체",
      "fullDesc": "AI 원클릭 파란색 배경 교체. 피사체 윤곽을 정확히 감지하고 머리카락 등 세부 사항을 유지하여 파란색 배경 이미지로 출력합니다. 증명사진, 여권 사진에 적합.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 JPG, PNG, WebP를 사용해 주세요.",
      "notImageFile": "이미지 파일을 업로드해 주세요.",
      "noImageInResponse": "결과 이미지를 가져오지 못했습니다. 나중에 다시 시도해 주세요.",
      "downloadName": "파란색배경결과.png"
    },
    "face-swap": {
      "name": "사진 얼굴 교체",
      "desc": "AI로 사진의 얼굴을 원클릭 교체",
      "fullDesc": "AI 기반 얼굴 교체. 대상 사진과 소스 얼굴 사진을 업로드하면 얼굴을 대상 이미지에 자연스럽게 합성합니다. 다인물 장면을 지원하며 현실적인 결과를 제공합니다.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 JPG, PNG, WebP를 사용해 주세요.",
      "notImageFile": "이미지 파일을 업로드해 주세요.",
      "targetImage": "대상 사진",
      "sourceImage": "소스 얼굴",
      "effectImageLabel": "결과",
      "downloadName": "얼굴교체결과.png",
      "step1Title": "사진 업로드",
      "step1Desc": "대상 사진과 소스 얼굴 사진을 업로드",
      "step2Title": "AI 얼굴 교체",
      "step2Desc": "처리를 클릭하면 AI가 자동으로 얼굴을 교체합니다",
      "step3Title": "다운로드",
      "step3Desc": "결과를 미리보고 다운로드",
      "processButton": "얼굴 교환",
      "targetPreviewAlt": "AI 얼굴 교환을 위한 대상 사진 미리보기",
      "sourcePreviewAlt": "AI 얼굴 교환을 위한 소스 얼굴 미리보기",
      "processingAlt": "AI 얼굴 교환 처리 미리보기",
      "resultBeforeAlt": "얼굴 교환 전 대상 사진",
      "resultAfterAlt": "AI 얼굴 교환 후 사진",
      "featuresKicker": "자연스러운 얼굴 교체",
      "featuresTitle": "AI로 사진 간 얼굴 교환",
      "featuresIntro": "포즈와 구도에 대상 사진을 사용한 다음 초점이 맞춰진 사진 얼굴 교환을 위해 명확한 원본 얼굴을 제공하세요.",
      "features": [
        {
          "title": "자연스러운 얼굴 스왑 만들기",
          "desc": "AI는 포즈, 프레임, 조명 및 전반적인 시각적 스타일을 따르면서 소스 아이덴티티를 대상 사진에 혼합합니다.",
          "cta": "무료로 사진 얼굴 교환 만들기"
        },
        {
          "title": "대상 사진 구도 유지",
          "desc": "배경과 구도를 유지하면서 인물, 셀카, 캐릭터 이미지 또는 창의적인 장면을 대상으로 사용하세요.",
          "cta": "사진 얼굴 교환을 무료로 사용해 보세요"
        },
        {
          "title": "명확한 원본 면 사용",
          "desc": "모델이 보다 일관된 교체를 생성하는 데 도움이 되도록 눈에 띄는 얼굴 세부 정보가 포함된 정면의 조명이 밝은 소스 이미지를 업로드하세요.",
          "cta": "무료 업로드 및 교환"
        }
      ],
      "useCasesKicker": "창의적인 사진 아이디어",
      "useCasesTitle": "온라인 사진 얼굴 교환의 인기 있는 용도",
      "useCasesIntro": "하나의 대상 이미지와 하나의 원본 얼굴 이미지를 사용하여 재미있고 창의적인 사진 편집을 만들어 보세요.",
      "useCases": [
        {
          "title": "셀카 및 프로필 사진 얼굴 교환",
          "desc": "대상 포즈, 배경, 프레임을 유지하면서 셀카나 인물 사진의 얼굴을 교체하세요. 명확한 원본 얼굴이 포함된 프로필 사진 컨셉과 개인 인물 사진 아이디어를 살펴보세요.",
          "cta": "무료로 인물 얼굴 교체 만들기",
          "imageAlt": "셀카와 프로필 사진을 위한 AI 얼굴 교환 예시"
        },
        {
          "title": "밈과 사회적 반응 이미지",
          "desc": "친숙한 사진을 개인화된 밈, 재미있는 반응 이미지, 공유 가능한 소셜 콘텐츠로 바꿔보세요. 명확한 대상 표현은 최종 이미지를 쉽게 알아볼 수 있도록 유지하는 데 도움이 됩니다.",
          "cta": "밈 얼굴 교환을 무료로 만드세요",
          "imageAlt": "창의적인 밈 및 사회적 반응 이미지 사용 사례"
        },
        {
          "title": "코스프레, 캐릭터, 창의적인 이야기",
          "desc": "의상, 판타지 초상화, 일러스트 캐릭터 또는 테마 장면의 얼굴을 시험해 보세요. 얼굴 교환을 사용하여 캐릭터 컨셉을 탐색하고 편집할 수 있는 이미지로 시각적 스토리를 만드세요.",
          "cta": "캐릭터 얼굴 교환을 무료로 사용해 보세요",
          "imageAlt": "코스프레 및 캐릭터 얼굴 교환 사용 사례"
        }
      ],
      "howToKicker": "세 가지 간단한 단계",
      "howToTitle": "AI를 사용하여 온라인에서 사진 속 얼굴을 바꾸는 방법",
      "howToIntro": "대상 사진을 선택하고, 명확한 원본 얼굴을 추가하고, AI가 얼굴 교체 결과를 생성하도록 하세요.",
      "faqTitle": "사진 얼굴 교환 FAQ",
      "faqs": [
        {
          "q": "온라인에서 두 장의 사진 간에 얼굴을 바꾸는 방법은 무엇입니까?",
          "a": "대상으로 유지하려는 포즈와 구도가 있는 사진을 업로드한 다음 원본 얼굴로 사용할 ID를 업로드하고 처리를 시작하세요."
        },
        {
          "q": "대상 사진과 원본 얼굴의 차이점은 무엇입니까?",
          "a": "대상 사진은 포즈, 배경, 구도를 제공합니다. 원본 얼굴은 교체에 사용되는 얼굴 ID를 제공합니다."
        },
        {
          "q": "얼굴 교체에 적합한 소스 이미지를 선택하려면 어떻게 해야 합니까?",
          "a": "얼굴이 가려지지 않은 깨끗하고 조명이 밝은 이미지를 사용하세요. 대상과 유사한 소스 각도와 표현을 사용하면 보다 일관된 결과를 얻을 수 있습니다."
        },
        {
          "q": "셀카, 밈, 코스프레 사진에 AI 얼굴 교환을 사용할 수 있나요?",
          "a": "그렇습니다. 이는 업로드된 이미지를 소유하거나 편집할 수 있는 권한이 있는 경우 일반적으로 창의적인 용도로 사용됩니다."
        },
        {
          "q": "얼굴 교환이 때때로 덜 현실적으로 보이는 이유는 무엇입니까?",
          "a": "얼굴 각도, 조명, 표현, 해상도 또는 과도한 폐색의 차이가 크면 블렌딩이 더 어려워질 수 있습니다. 더욱 선명하고 호환성이 뛰어난 원본 사진을 사용해 보세요."
        },
        {
          "q": "어떤 이미지 형식과 파일 크기가 지원되나요?",
          "a": "JPG, PNG, WebP 이미지가 지원되며, 이미지당 최대 파일 크기는 15MB입니다."
        },
        {
          "q": "이 페이지의 동영상에서 얼굴을 바꿀 수 있나요?",
          "a": "아니요. 이 페이지는 정지 이미지를 처리하고 이미지 결과를 반환합니다."
        }
      ]
    },
    "photo-restore": {
      "name": "사진 복원",
      "desc": "AI 기술로 오래되었거나 흐릿하거나 손상된 사진을 복원합니다",
      "fullDesc": "AI 기술로 오래되었거나 흐릿하거나 손상된 사진을 복원합니다. 노이즈 제거, 선명도 조절 및 누락된 부분 채우기를 지원하여 소중한 추억을 되살립니다.",
      "notImageFile": "유효한 이미지 파일을 업로드해 주세요.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 이미지를 선택해 주세요.",
      "downloadName": "사진복원결과.png"
    },
    "blurry-photo-repair": {
      "name": "흐릿한 이미지 복구",
      "desc": "AI로 흐릿한 이미지를 복구하고 더 선명한 디테일을 되살립니다",
      "fullDesc": "AI로 흐릿한 이미지를 복구합니다. 선명도를 높이고 얼굴과 질감 디테일을 복원하여 흐릿한 사진을 더 또렷하게 만듭니다.",
      "notImageFile": "유효한 이미지 파일을 업로드해 주세요.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 이미지를 선택해 주세요.",
      "downloadName": "흐릿한이미지복구결과.png"
    },
    "cartoon-digital-human": {
      "name": "AI 카툰 캐릭터 생성기",
      "desc": "인물 사진을 카툰 스타일로 변환",
      "fullDesc": "인물 사진에서 애니메이션 스타일의 카툰 디지털 휴먼을 생성합니다. 알아볼 수 있는 특징을 유지하면서 깔끔한 선과 선명한 색상의 아바타로 만듭니다.",
      "notImageFile": "유효한 이미지 파일을 업로드해 주세요.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 이미지를 선택해 주세요.",
      "downloadName": "카툰디지털휴먼결과.png"
    },
    "manga-digital-human": {
      "name": "AI 만화 스타일 캐릭터 생성기",
      "desc": "인물 사진을 만화 스타일로 변환",
      "fullDesc": "인물 사진에서 만화 스타일의 디지털 휴먼을 생성합니다. 알아볼 수 있는 특징을 유지하면서 표현력 있는 선과 정돈된 명암의 만화 느낌으로 만듭니다.",
      "notImageFile": "유효한 이미지 파일을 업로드해 주세요.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 이미지를 선택해 주세요.",
      "downloadName": "만화디지털휴먼결과.png"
    },
    "oil-painting-digital-human": {
      "name": "AI 유화 초상화 생성기",
      "desc": "인물 사진을 유화 스타일로 변환",
      "fullDesc": "인물 사진에서 유화 스타일 디지털 휴먼을 생성합니다. 알아볼 수 있는 특징을 유지하면서 풍부한 색감과 붓 터치 질감의 초상화를 만듭니다.",
      "notImageFile": "유효한 이미지 파일을 업로드해 주세요.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 이하의 이미지를 선택해 주세요.",
      "downloadName": "유화-디지털-휴먼.png"
    },
    "id-photo-generator": {
      "name": "증명사진 생성기",
      "desc": "인물 사진으로 규격 증명사진 생성",
      "fullDesc": "인물 사진에서 깔끔하고 전문적인 증명사진 스타일 이미지를 생성합니다. AI가 피사체를 정돈된 문서 사진 느낌으로 보정합니다.",
      "notImageFile": "유효한 이미지 파일을 업로드해 주세요.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 이미지를 선택해 주세요.",
      "downloadName": "증명사진결과.png"
    },
  "ai-change-clothes": {
    "name": "AI 옷 교체",
    "desc": "의상·인물 이미지 업로드, 원클릭 의상 변경",
    "fullDesc": "먼저 의상 이미지를 업로드하고, 다음으로 인물 이미지를 업로드합니다. AI가 선택한 의상을 인물 사진에 적용하면서 인물, 포즈, 자연스러운 이미지 세부 묘사를 보존합니다.",
    "demoTitle": "데모",
    "notImageFile": "유효한 이미지 파일을 업로드해 주세요.",
    "fileTooLarge": "이미지가 너무 큽니다. 15MB 이하의 이미지를 선택해 주세요.",
    "firstImageLabel": "의상 이미지",
    "uploadFirstImage": "의상 이미지 업로드",
    "changeFirstImage": "의상 이미지 변경",
    "secondImageLabel": "인물 이미지",
    "uploadSecondImage": "인물 이미지 업로드",
    "changeSecondImage": "인물 이미지 변경",
    "uploadingSecondImage": "인물 이미지 업로드 중...",
    "downloadName": "AI-의상-변경.png"
  },
  "image-enhancer": {
      "name": "이미지 향상기",
      "desc": "이미지를 4K 해상도로 업스케일하고 세부 정보를 향상시킵니다",
      "fullDesc": "이미지를 4K 해상도로 업스케일하고 세부 정보를 향상시킵니다. 고급 AI 알고리즘을 사용하여 세부 정보를 강조하고 흐릿한 이미지를 선명하고 깨끗하게 만듭니다.",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 미만의 JPG, PNG, WebP를 사용해 주세요.",
      "notImageFile": "이미지 파일을 업로드해 주세요.",
      "downloadName": "이미지향상결과.png",
      "targetResolution": "목표 해상도",
      "outputFormat": "출력 형식",
      "resolutions": {
        "2k": "2K",
        "4k": "4K",
        "8k": "8K"
      },
      "formats": {
        "JPEG": "JPEG",
        "PNG": "PNG",
        "WEBP": "WEBP"
      },
      "processFailed": "처리에 실패했습니다. 다른 이미지나 출력 형식을 선택해 보세요."
    },
    "video-enhancer": {
      "name": "비디오 향상기",
      "desc": "비디오를 4K 해상도로 업스케일하고 선명도를 향상시킵니다",
      "fullDesc": "비디오를 4K 해상도로 업스케일하고 선명도를 향상시킵니다. 다양한 비디오 형식을 지원하며 AI 기반 프레임 보간을 통해 놀라운 HD 품질을 제공합니다.",
      "notVideoFile": "동영상 파일을 업로드해 주세요(예: MP4, MOV, AVI).",
      "fileTooLarge": "동영상이 너무 큽니다. 100MB 미만의 파일을 사용해 주세요."
    },
    "cartoon-video-style-converter": {
      "name": "카툰 스타일 변환기",
      "desc": "동영상을 카툰 스타일로 변환",
      "fullDesc": "동영상을 업로드하면 AI가 주요 움직임과 구도를 유지하면서 카툰 스타일의 동영상으로 변환합니다.",
      "notVideoFile": "유효한 동영상 파일을 업로드해 주세요.",
      "fileTooLarge": "동영상이 너무 큽니다. 100MB 미만의 동영상을 선택해 주세요.",
      "downloadName": "cartoon-style-video.mp4"
    },
    "anime-video-style-converter": {
      "name": "애니메이션 스타일 변환기",
      "desc": "동영상을 애니메이션 스타일로 변환",
      "fullDesc": "동영상을 업로드하면 AI가 피사체 움직임과 장면 리듬을 유지하면서 애니메이션 스타일의 동영상으로 변환합니다.",
      "notVideoFile": "유효한 동영상 파일을 업로드해 주세요.",
      "fileTooLarge": "동영상이 너무 큽니다. 100MB 미만의 동영상을 선택해 주세요.",
      "downloadName": "anime-style-video.mp4"
    },
    "oil-painting-video-style-converter": {
      "name": "유화 스타일 변환기",
      "desc": "동영상을 유화 스타일로 변환",
      "fullDesc": "동영상을 업로드하면 AI가 풍부한 색감과 회화적 질감의 유화 스타일 동영상으로 변환합니다.",
      "notVideoFile": "유효한 동영상 파일을 업로드해 주세요.",
      "fileTooLarge": "동영상이 너무 큽니다. 100MB 미만의 동영상을 선택해 주세요.",
      "downloadName": "oil-painting-style-video.mp4"
    },
    "cyberpunk-video-style-converter": {
      "name": "사이버펑크 스타일 변환기",
      "desc": "동영상을 사이버펑크 스타일로 변환",
      "fullDesc": "동영상을 업로드하면 AI가 네온 분위기와 미래적인 고대비 사이버펑크 스타일 동영상으로 변환합니다.",
      "notVideoFile": "유효한 동영상 파일을 업로드해 주세요.",
      "fileTooLarge": "동영상이 너무 큽니다. 100MB 미만의 동영상을 선택해 주세요.",
      "downloadName": "cyberpunk-style-video.mp4"
    },
    "doc-crop-enhance": {
      "name": "이미지 자르기 및 교정",
      "desc": "AI로 문서 테두리 자르기와 왜곡 교정",
      "fullDesc": "문서 이미지 자르기, 교정 및 향상. 가장자리 배경 제거, 왜곡 교정 및 밝게 하기, 선명하게 하기, 흑백, 그레이스케일  그림자 제거 등 다양한 향상 모드를 지원합니다.",
      "enhanceMode": "향상 모드",
      "enhanceModes": {
        "disabled": "향상 비활성화",
        "brighten": "밝게 하기",
        "sharpen": "향상 및 선명하게",
        "blackWhite": "흑백",
        "grayscale": "그레이스케일",
        "deshadow": "그림자 제거",
        "bitmap": "비트맵"
      },
      "cropImage": "자르기",
      "dewarpImage": "교정",
      "notImageFile": "유효한 이미지 파일을 업로드해 주세요",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 이하의 이미지를 선택해 주세요",
      "noImageInResponse": "처리 실패, 다시 시도해 주세요",
      "downloadName": "doc-crop-enhanced.png",
      "featuresKicker": "문서 스캔 향상",
      "featuresTitle": "문서 사진을 깔끔하고 적절하게 정렬된 스캔으로 변환",
      "featuresIntro": "일반적인 모바일 캡처 및 스캔 향상 요구 사항에 맞게 문서 가장자리, 기울어짐, 원근감, 구부러진 페이지, 그림자 및 텍스트 선명도를 처리합니다.",
      "features": [
        {
          "title": "문서 가장자리를 자동으로 감지하고 자르기",
          "desc": "종이와 배경 사이의 경계를 찾은 다음 책상, 가장자리 그림자 및 관련 없는 영역을 제거하여 깔끔한 페이지를 만듭니다.",
          "cta": "무료로 문서 자르기"
        },
        {
          "title": "기울어진 문서를 바로잡고 관점을 교정하세요",
          "desc": "계약서, 양식 및 시험지의 기울어진 휴대폰 사진으로 인해 발생한 사다리꼴 왜곡, 기울어진 페이지 및 비율을 수정합니다.",
          "cta": "문서 사진 수정"
        },
        {
          "title": "곡선 페이지 및 스캔 문서 디워프",
          "desc": "책 제본, 말린 종이, 접힌 페이지 근처의 왜곡을 수정하여 교과서와 책 사진을 더 쉽게 읽을 수 있도록 합니다.",
          "cta": "곡선 문서 디워프"
        },
        {
          "title": "문서 스캔에서 그림자 제거",
          "desc": "휴대폰, 손가락, 책등, 불균일한 조명으로 인한 그림자를 줄여 영수증, 워크시트 및 스캔한 페이지를 더욱 깔끔하게 만듭니다.",
          "cta": "문서 그림자 제거"
        },
        {
          "title": "문서를 밝게 하고 텍스트를 선명하게",
          "desc": "보다 쉽게 읽고, 인쇄하고, 구성할 수 있도록 대비가 낮은 문서의 밝기와 인쇄된 텍스트 가장자리를 개선합니다.",
          "cta": "스캔한 텍스트 선명하게 하기"
        },
        {
          "title": "흑백, 회색조 또는 비트맵 스캔 생성",
          "desc": "인쇄 및 보관을 위해 컬러 문서 사진을 흑백, 회색조 또는 비트맵 강화 이미지로 변환합니다.",
          "cta": "문서 이미지 향상"
        }
      ],
      "useCasesKicker": "일반적인 사용 사례",
      "useCasesTitle": "어떤 문서 이미지를 자르고 향상할 수 있나요?",
      "useCasesIntro": "고르지 못한 프레임, 그림자, 왜곡 또는 불분명한 텍스트가 있는 휴대폰이나 스캐너로 캡처한 개별 문서 이미지용으로 설계되었습니다.",
      "useCases": [
        {
          "title": "스캔할 휴대폰 사진",
          "desc": "책상 배경을 제거하고 카메라 각도를 수정하여 휴대폰 사진을 스캔본처럼 보이게 만드세요."
        },
        {
          "title": "계약서 및 양식",
          "desc": "깨끗한 가장자리와 페이지 비율을 복원하기 위해 계약서, 애플리케이션 및 양식을 자릅니다."
        },
        {
          "title": "영수증 및 송장",
          "desc": "그림자를 줄이고 희미하게 인쇄된 텍스트를 선명하게 하여 더 명확하게 보고 보관할 수 있습니다."
        },
        {
          "title": "곡선 책 페이지",
          "desc": "교과서, 책, 학습서 제본 근처의 곡률을 수정합니다."
        },
        {
          "title": "시험지 및 워크시트",
          "desc": "재사용이나 인쇄를 위해 시험지를 펴고, 그림자를 제거하고, 인쇄된 텍스트를 선명하게 만듭니다."
        },
        {
          "title": "흑백 아카이브",
          "desc": "문서 사진을 일관된 흑백 또는 회색조 스캔 스타일로 변환합니다."
        }
      ],
      "faqTitle": "AI 문서 자르기 및 수정 FAQ",
      "faqs": [
        {
          "q": "AI 문서 자르기 및 수정이란?",
          "a": "문서 영역을 감지하고 주변 배경을 제거하며 설정에 따라 기울어짐, 원근감 또는 곡선 페이지 왜곡을 수정할 수 있습니다."
        },
        {
          "q": "온라인에서 스캔한 문서 이미지를 자동으로 자르려면 어떻게 해야 합니까?",
          "a": "가장자리 자르기를 활성화한 다음 스캔한 문서 이미지를 업로드하세요. 도구는 용지 경계를 감지하고 문서 외부 영역을 제거하려고 시도합니다."
        },
        {
          "q": "온라인으로 스캔한 문서의 기울기를 조정할 수 있나요?",
          "a": "그렇습니다. 기울어진 스캔에는 직선화를 사용하고 기울어진 휴대폰 사진에는 원근 교정을 사용합니다. 페이지 자체가 구부러진 경우에만 왜곡 보정을 사용하십시오."
        },
        {
          "q": "디섀도 모드와 선명 모드의 차이점은 무엇입니까?",
          "a": "Deshadow는 고르지 못한 페이지 조명을 개선하고, Sharpen은 텍스트와 선 가장자리를 강화합니다. 소스 문제와 일치하는 모드를 선택하십시오."
        },
        {
          "q": "스캔한 시험지, 계약서, 영수증을 향상시키기 위해 어떤 도구를 사용할 수 있나요?",
          "a": "고르지 못한 조명을 위한 디섀도우, 희미한 텍스트를 위한 선명도, 인쇄할 문서를 준비할 때 흑백 또는 회색조가 포함된 이 문서 자르기 및 향상 도구를 사용하세요."
        },
        {
          "q": "휴대폰 사진을 스캔 문서로 바꿀 수 있나요?",
          "a": "자르기, 수정 및 향상을 통해 스캔과 유사한 이미지를 생성할 수 있지만 이 도구는 PDF를 생성하거나 OCR 텍스트를 추출하지 않습니다."
        },
        {
          "q": "어떤 이미지 형식과 파일 크기가 지원되나요?",
          "a": "JPG, PNG 및 WebP 이미지가 지원되며 최대 파일 크기는 15MB입니다."
        },
        {
          "q": "처리 과정에서 원본 문서 내용이 변경됩니까?",
          "a": "이 도구는 프레임, 기하학, 밝기 및 선명도를 조정합니다. 텍스트를 편집하거나 문서 내용을 추출하지 않습니다."
        }
      ],
      "education": {
        "kicker": "교육 문서",
        "title": "시험지, 숙제, 교과서 사진을 선명한 스캔으로 변환",
        "intro": "교육용 문서 가장자리를 자동으로 감지하고 기울어짐, 원근감, 구부러진 페이지 및 그림자를 수정하여 더 깔끔한 인쇄, 보관 및 교실 사용을 가능하게 합니다.",
        "items": [
          {
            "title": "시험지 사진 자르기",
            "desc": "테스트 용지 가장자리를 감지하고 책상 배경을 제거하여 깨끗하고 적절한 프레임의 페이지를 만듭니다."
          },
          {
            "title": "숙제 이미지 수정",
            "desc": "숙제 사진의 기울어짐과 원근감을 수정하여 더 쉽게 검토하고 제출하고 인쇄할 수 있습니다."
          },
          {
            "title": "디워프 교과서 페이지",
            "desc": "책 제본 근처의 구부러진 페이지를 수정하고 인쇄된 콘텐츠를 읽기 어렵게 만드는 그림자를 줄입니다."
          },
          {
            "title": "교실용 워크시트를 선명하게 하세요",
            "desc": "깨끗한 흑백 또는 회색조 스캔 효과로 워크시트나 학습 자료를 밝고 선명하게 만듭니다."
          }
        ],
        "relatedTitle": "시험지에서 손으로 쓴 답을 삭제해야 합니까?",
        "relatedDesc": "이 도구는 자르기, 기하학적 수정 및 이미지 향상을 처리합니다. 필기 지우개를 사용하여 학생 답변, 계산 또는 교사 주석을 제거하세요.",
        "relatedCta": "필기 지우개 열기"
      }
    },
    "handwritten-erase": {
      "name": "손글씨 지우기",
      "desc": "AI로 문서 손글씨를 자동 삭제",
      "fullDesc": "문서에서 손글씨를 자동으로 감지하고 지웁니다. 인쇄된 내용은 유지합니다. 시험지  노트  계약서 등에 적합하며 자르기  교정  회전을 지원합니다.",
      "docDirection": "회전",
      "docDirections": {
        "none": "회전 없음",
        "rotate90": "시계 방향 90°",
        "rotate180": "시계 방향 180°",
        "rotate270": "시계 방향 270°",
        "auto": "자동 감지"
      },
      "crop": "자르기",
      "dewarp": "교정",
      "notImageFile": "유효한 이미지 파일을 업로드해 주세요",
      "fileTooLarge": "이미지가 너무 큽니다. 15MB 이하의 이미지를 선택해 주세요",
      "noImageInResponse": "처리 실패, 다시 시도해 주세요",
      "downloadName": "handwritten-erased.png",
      "featuresKicker": "문서 필기 제거",
      "featuresTitle": "필기 제거 및 깨끗한 문서 복원",
      "featuresIntro": "인쇄된 텍스트와 원본 레이아웃을 유지하면서 손으로 쓴 답변, 계약서 수정본, 검토 메모, 스캔한 문서 표시를 깔끔하게 정리하세요.",
      "features": [
        {
          "title": "시험지에서 학생 답변 제거",
          "desc": "완성된 시험지의 필기 답변, 계산, 주석을 자동으로 감지합니다.",
          "cta": "깨끗한 시험지 답변 무료"
        },
        {
          "title": "계약서에서 필기체 지우기",
          "desc": "인쇄된 조항, 표 및 레이아웃을 유지하면서 손으로 쓴 추가 사항, 원, 변경된 금액, 화살표 및 검토 메모를 정리하세요.",
          "cta": "클린 계약서 온라인 작성"
        },
        {
          "title": "교육용 시험 준비 및 재인쇄",
          "desc": "수업, 시험 준비, 문서 보관을 위한 학생 답변과 교사 주석을 정리하세요.",
          "cta": "교사용 시험지 클리너를 사용해 보세요"
        },
        {
          "title": "스캔한 문서에서 손으로 쓴 표시 지우기",
          "desc": "스캔한 양식, 검사 보고서 및 사무 문서에서 체크, 화살표, 원, 여백 메모 및 검토 표시를 제거합니다.",
          "cta": "스캔한 문서 표시 청소"
        }
      ],
      "useCasesKicker": "학생과 교사를 위한",
      "useCasesTitle": "AI 필기 제거를 위한 교육 사용 사례",
      "useCases": [
        {
          "title": "테스트 답안 제거",
          "desc": "시험지에서 학생의 답과 계산을 삭제합니다."
        },
        {
          "title": "실수 검토",
          "desc": "다음 연습을 위해 완성된 서류를 복원하십시오."
        },
        {
          "title": "통합 문서 청소",
          "desc": "숙제와 워크시트에서 손으로 쓴 내용을 제거하세요."
        },
        {
          "title": "교육 및 시험 준비",
          "desc": "수업, 재인쇄, 보관을 위한 깨끗한 논문을 만드세요."
        },
        {
          "title": "스캔한 용지 수정",
          "desc": "기울어지거나 구부러진 문서 이미지를 회전하고, 자르고, 변형합니다."
        },
        {
          "title": "계약서 및 메모 청소",
          "desc": "일반 문서에서 필기 및 주석을 제거합니다."
        }
      ],
      "howToKicker": "세 가지 간단한 단계",
      "howToTitle": "온라인 시험지에서 필기 답변을 제거하는 방법",
      "howToIntro": "시험지나 문서를 업로드하고 회전, 자르기, 왜곡 보정 옵션을 설정한 다음 정리된 결과를 다운로드하세요.",
      "steps": {
        "upload": {
          "title": "시험지 또는 문서 업로드",
          "desc": "JPG, PNG 또는 WebP 시험지, 숙제 시트 또는 15MB 미만의 스캔 문서를 업로드하세요."
        },
        "process": {
          "title": "필기 구성 및 제거",
          "desc": "문서 방향을 선택하고 필요에 따라 자르기 또는 뒤틀림 제거를 활성화한 다음 처리를 시작하세요."
        },
        "download": {
          "title": "검토 및 다운로드",
          "desc": "전후 이미지를 비교하고, 깨끗한 문서를 다운로드하거나, 다른 이미지를 가공해보세요."
        }
      },
      "faqTitle": "AI 시험지 정답 리무버 FAQ",
      "faqs": [
        {
          "q": "시험지에서 손으로 쓴 답을 제거하려면 어떤 도구를 사용할 수 있나요?",
          "a": "Miral AI 필기 제거기는 인쇄된 질문과 가능한 경우 원본 레이아웃을 유지하면서 필기 답변, 계산 및 주석을 감지합니다."
        },
        {
          "q": "AI가 인쇄된 텍스트를 보존하면서 필기 내용을 제거할 수 있나요?",
          "a": "필기 내용이 인쇄된 내용과 크게 겹치지 않는 경우 인쇄된 텍스트를 보존하면서 깨끗한 종이로 복원할 수 있습니다."
        },
        {
          "q": "교사가 시험지를 청소하고 다시 인쇄할 수 있나요?",
          "a": "그렇습니다. 수업 준비, 수업 설명, 시험 작성, 문서 보관에 적합합니다."
        },
        {
          "q": "학생들이 수정을 위해 답안지를 재설정할 수 있나요?",
          "a": "그렇습니다. 청소된 시험지와 워크시트는 실수 검토 및 추가 연습을 위해 재사용할 수 있습니다."
        },
        {
          "q": "손으로 쓴 메모, 펜 자국, 빨간색 잉크 주석을 어떻게 지우나요?",
          "a": "문서 이미지를 업로드하고 필기 제거 프로그램을 실행하세요. 결과는 선명도에 따라 달라지고 인쇄된 텍스트와 겹치더라도 다양한 필기 색상과 쓰기 도구를 처리할 수 있습니다."
        },
        {
          "q": "필기를 제거하기 전에 기울어지거나 구부러진 스캔을 어떻게 수정합니까?",
          "a": "먼저 기울어진 스캔을 기울이거나 회전시키십시오. 필기를 처리하기 전에 배경이 너무 많은 경우 자르기를 사용하고 실제로 구부러진 페이지에 대해서만 뒤틀림 제거를 사용합니다."
        },
        {
          "q": "어떤 이미지 형식이 지원되나요?",
          "a": "15MB 이하의 JPG, PNG, WebP 이미지가 지원됩니다. 이 페이지에서는 PDF 파일이 지원되지 않습니다."
        }
      ]
    },
    "category": {
      "image": "이미지 처리",
      "video": "비디오 처리",
      "document": "문서 처리"
    },
    "categoryModal": {
      "title": "도구 카테고리 선택"
    },
    "convert": {
      "success": "변환 완료!",
      "zipHint": "결과가 여러 이미지가 포함된 ZIP 파일로 패키지됩니다",
      "fileTooLarge": "파일이 너무 큽니다. 50MB 이하의 파일을 선택해 주세요",
      "demoTitle": "변환 미리보기",
      "sourceLabel": "원본 형식",
      "targetLabel": "출력 형식"
    },
    "pdf-to-word": {
      "name": "PDF를 Word로",
      "desc": "PDF 파일을 편집 가능한 Word 문서로 변환",
      "fullDesc": "PDF 파일을 편집 가능한 Word 문서로 스마트하게 변환합니다. 레이아웃, 표, 이미지 등을 정확하게 보존합니다."
    },
    "image-to-word": {
      "name": "이미지를 Word로",
      "desc": "이미지 속 텍스트를 Word 문서로 변환",
      "fullDesc": "이미지 속 텍스트, 표 등을 스마트하게 인식하여 Word 문서로 변환합니다. 원본 레이아웃을 보존합니다."
    },
    "pdf-to-excel": {
      "name": "PDF를 Excel로",
      "desc": "PDF 표를 편집 가능한 Excel 파일로 변환",
      "fullDesc": "PDF 파일의 표 내용을 스마트하게 인식하여 편집 가능한 Excel 파일로 변환합니다."
    },
    "pdf-to-ppt": {
      "name": "PDF를 PPT로",
      "desc": "PDF 파일을 편집 가능한 PPT 프레젠테이션으로 변환",
      "fullDesc": "PDF 파일을 편집 가능한 PPT 프레젠테이션으로 스마트하게 변환합니다."
    },
    "pdf-to-image": {
      "name": "PDF를 이미지로",
      "desc": "PDF 각 페이지를 고화질 이미지로 변환",
      "fullDesc": "PDF 파일의 각 페이지를 고화질 이미지로 변환합니다. 다중 페이지 PDF 일괄 변환을 지원합니다."
    },
    "word-to-pdf": {
      "name": "Word를 PDF로",
      "desc": "Word 문서를 PDF 파일로 변환",
      "fullDesc": "Word 문서를 PDF 파일로 빠르게 변환합니다. 원본 레이아웃, 글꼴, 이미지를 보존합니다."
    },
    "excel-to-pdf": {
      "name": "Excel을 PDF로",
      "desc": "Excel 스프레드시트를 PDF 파일로 변환",
      "fullDesc": "Excel 스프레드시트를 PDF 파일로 변환합니다. 표 구조와 데이터 레이아웃을 보존합니다."
    },
    "image-to-pdf": {
      "name": "이미지를 PDF로",
      "desc": "여러 이미지를 하나의 PDF 파일로 병합",
      "fullDesc": "여러 이미지를 하나의 PDF 파일로 병합합니다. JPG, PNG, BMP 등 일반 이미지 형식을 지원합니다."
    },
    "word-to-image": {
      "name": "Word를 이미지로",
      "desc": "Word 문서 각 페이지를 이미지로 변환",
      "fullDesc": "Word 문서의 각 페이지를 고화질 이미지로 변환합니다. 다중 페이지 일괄 변환을 지원합니다."
    }
  },
  "plans": {
    "basic": {
      "name": "기본",
      "features": [
        "모든 크레딧이 한 번에 지급됨",
        "최대 2,600개의 AI 이미지 생성",
        "520개의 AI 비디오 생성",
        "최대 480곡의 AI 음악 생성",
        "워터마크 없음",
        "상업적 라이선스"
      ]
    },
    "pro": {
      "name": "프로",
      "features": [
        "모든 크레딧이 한 번에 지급됨",
        "최대 10,600개의 AI 이미지 생성",
        "최대 2,120개의 AI 비디오 생성",
        "최대 1,920곡의 AI 음악 생성",
        "모든 프리미엄 모델",
        "우선 대기열",
        "우선 지원",
        "개인 정보 모드 및 DPA 규정 준수"
      ]
    },
    "ultimate": {
      "name": "울티메이트",
      "features": [
        "모든 크레딧이 한 번에 지급됨",
        "최대 36,600개의 AI 이미지 생성",
        "최대 7,320개의 AI 비디오 생성",
        "최대 6,720곡의 AI 음악 생성",
        "모든 프리미엄 모델",
        "전담 지원",
        "개인 정보 모드 및 DPA 규정 준수"
      ]
    }
  },
  "faq": {
    "categories": {
      "all": "모두",
      "general": "일반",
      "pricing": "가격",
      "models": "모델",
      "features": "기능"
    },
    "items": [
      {
        "q": "Miral이란 무엇인가요?",
        "a": "Miral은 29개 이상의 최고 수준의 AI 모델을 통합한 올인원 AI 창작 플랫폼으로, 이미지 생성, 비디오 제작, 음악 생산 및 전문 편집 도구를 지원합니다. 플랫폼 간 전환 없이 하나의 계정으로 FLUX, 미드저니, 소라, 베오, 클링 등 주요 모델에 접근할 수 있습니다."
      },
      {
        "q": "어떤 AI 모델이 지원되나요?",
        "a": "29개 이상의 최고 수준의 AI 모델을 지원합니다. 이미지 모델(FLUX 2 맥스, 미드저니, 시드림, GPT-이미지-1, 나노 바나나 등), 비디오 모델(베오 3.1, 소라 2, 클링 2.6, 시댄스, 완 2.5 등), AI 음악 생성 모델을 포함합니다. 모든 모델은 지속적으로 업데이트됩니다."
      },
      {
        "q": "크레딧 시스템은 어떻게 작동하나요?",
        "a": "통합 크레딧 시스템을 사용합니다. 이미지 생성은 2크레딧부터 시작하며, 비디오 생성은 10크레딧, 음악은 트랙당 10크레딧입니다. 프리미엄 모델은 더 많은 크레딧을 소비할 수 있습니다. 구독자는 더 낮은 크레딧 요율을 즐길 수 있으며 크레딧 팩을 별도로 구매할 수도 있습니다."
      },
      {
        "q": "이미지, 비디오 및 음악을 생성할 수 있나요?",
        "a": "네! Miral은 텍스트-이미지, 이미지 편집, 스타일 전달, 텍스트-비디오, 이미지-비디오, AI 음악 생성 등을 지원하여 개인 프로젝트에서 상업적 작업에 이르기까지 모든 창의적 요구를 충족합니다."
      },
      {
        "q": "생성 속도는 얼마나 빠른가요?",
        "a": "대부분의 이미지 생성은 30초 이내에 완료되며, 비디오 생성은 약 1~6분 정도 걸립니다. 우리는 빠르고 안정적인 생성을 보장하기 위해 인프라를 지속적으로 최적화하고 있습니다."
      },
      {
        "q": "Miral을 상업적 용도로 사용할 수 있나요?",
        "a": "네. 모든 유료 플랜에는 상업적 라이선스가 포함되어 있어 생성된 콘텐츠를 상업적 프로젝트, 마케팅 자료, 소셜 미디어 등에 사용할 수 있습니다."
      },
      {
        "q": "API 접근이 가능한가요?",
        "a": "네, 울티메이트 플랜에는 API 접근이 포함됩니다. 포괄적인 API를 통해 애플리케이션에 직접 AI 이미지, 비디오 및 음악 생성을 통합할 수 있습니다."
      },
      {
        "q": "AI로 음악을 생성할 수 있나요?",
        "a": "물론입니다! 우리의 AI 음악 생성기는 다양한 음악 스타일을 지원합니다. 생성하고 싶은 것을 설명하면 원본 음악이 생성되며, 비디오 사운드트랙, 팟캐스트 배경음악 등에 적합합니다."
      },
      {
        "q": "데이터 개인정보 보호 및 보안은 어떻게 처리되나요?",
        "a": "우리는 GDPR 규정 준수 기준을 엄격히 따릅니다. 모든 데이터는 암호화되며 AI 학습에 사용되지 않습니다. 사용자는 언제든지 계정과 모든 데이터를 삭제할 수 있습니다."
      },
      {
        "q": "다른 사람이 저의 작업을 볼 수 있나요?",
        "a": "기본적으로 귀하의 작업은 귀하만 볼 수 있습니다. 프로 및 울티메이트 사용자는 개인 정보 모드를 활성화하여 완전한 개인정보 보호를 보장할 수 있습니다."
      },
      {
        "q": "계정 및 데이터를 삭제하려면 어떻게 해야 하나요?",
        "a": "계정 설정에서 언제든지 계정 삭제를 요청할 수 있습니다. 우리는 30일 이내에 모든 데이터와 생성된 콘텐츠를 삭제합니다."
      },
      {
        "q": "문제가 발생하면 지원을 받을 수 있나요?",
        "a": "물론입니다! miral_support@miralvis.com로 지원팀에 문의할 수 있습니다. 프로 사용자는 우선 지원을 받으며, 울티메이트 사용자는 전담 지원을 받습니다."
      }
    ]
  },
  "testimonials": {
    "items": [
      {
        "name": "Alex Chen",
        "role": "디지털 마케팅 디렉터",
        "tag": "90% 시간 절약",
        "content": "Miral은 우리의 시각 콘텐츠 허브가 되었습니다. 미드저니로 제품 이미지를 생성하고, 베오로 프로모션 비디오를 만들며, 모든 것을 Miral에서 편집합니다 - 플랫폼 전환 없이 말입니다."
      },
      {
        "name": "Sarah Rodriguez",
        "role": "이커머스 소유자",
        "tag": "40% 전환율 증가",
        "content": "한 장소에서 29개 이상의 모델에 접근하는 것은 놀랍습니다. 시드림으로 제품 사진을 만들고, 시댄스로 비디오 광고를 만들며, 카탈로그용 업스케일링 도구를 사용합니다. 전환율이 40% 증가했습니다!"
      },
      {
        "name": "David Kim",
        "role": "콘텐츠 크리에이터",
        "tag": "50만 팔로워",
        "content": "FLUX와 나노 바나나로 이미지를 만들고, 클링과 소라로 바이럴 비디오를 만듭니다. 크레딧 시스템은 공정합니다 - 사용한 만큼 지불합니다. 팔로워들은 다양한 콘텐츠를 좋아합니다!"
      },
      {
        "name": "Emma Thompson",
        "role": "그래픽 디자이너",
        "tag": "전문가 수준",
        "content": "디자이너로서 저는 AI 플랫폼에 대해 회의적이었습니다. 하지만 Miral의 풍부한 모델 라이브러리와 정밀한 편집 도구는 정말 인상적입니다 - 개념 스케치부터 최종 제품까지 모두 쉽게 할 수 있습니다."
      },
      {
        "name": "James Wilson",
        "role": "비디오 프로듀서",
        "tag": "10배 빠른 워크플로우",
        "content": "여기의 비디오 모델은 놀랍습니다 - 베오는 시네마틱하고, 시댄스는 빠르며, 완의 캐릭터 애니메이션은 자연스럽습니다. 모든 모델은 하나의 크레딧 시스템을 공유합니다 - 시간과 돈을 절약합니다."
      },
      {
        "name": "Lisa Park",
        "role": "크리에이티브 에이전시 소유자",
        "tag": "팀의 최고 선택",
        "content": "우리 전체 팀이 Miral로 전환했습니다. API 통합은 원활하며, 모델의 다양성 덕분에 항상 적절한 도구를 찾을 수 있습니다. 이것은 최고의 AI 플랫폼입니다."
      }
    ]
  },
  "langModal": {
    "title": "언어 선택"
  },
  "home": {
    "generate": "생성",
    "chatDisabledGenerateHint": "프롬프트를 입력해 주세요",
    "compactChatPlaceholder": "프롬프트를 입력해 멋진 AI 이미지와 동영상, 오리지널 음악을 생성하세요",
    "hero": {
      "title": "Miral – 이미지·비디오·음악을 위한 올인원 AI 제작 플랫폼",
      "subtitle": "다양한 AI 모델로 구동되는 Miral은 이미지 편집, 비디오 생성, AI 음악 제작을 하나로 제공합니다. 사진을 편집하고 시네마틱 인물 영상을 만들며 개인 및 상업용 맞춤 배경 음악을 제작하세요.",
      "createVideo": "비디오 생성",
      "createImage": "이미지 생성"
    },
    "stats": {
      "models": "탑 AI 모델",
      "works": "생성된 작품",
      "tools": "전문 도구",
      "platforms": "파트너 플랫폼"
    },
    "generatorNew": {
      "promptPlaceholder": "생성할 동영상을 설명해 주세요...",
      "promptPlaceholderImage": "생성할 이미지를 설명해 주세요...",
      "generating": "생성 중...",
      "noHistory": "생성 결과가 여기에 표시됩니다",
      "generationFailed": "생성 실패",
      "historyTitle": "기록",
      "myAssets": "내 자산"
    },
    "quickTools": {
      "title": "빠른 AI 도구"
    },
    "exploreMore": {
      "title": "더 많은 AI 기능 둘러보기"
    },
    "platform": {
      "tag": "플랫폼",
      "title": "창작을 단순하게 만드는 AI 도구 상자",
      "subtitle": "업계를 선도하는 AI 모델을 기반으로 한 올인원 이미지 생성, 비디오 제작, 음악 제작 및 전문 도구.",
      "tabs": {
        "image": "AI 이미지",
        "video": "AI 비디오",
        "music": "AI 음악",
        "tools": "AI 도구 상자"
      },
      "image": {
        "title": "글로벌 최고의 AI 모델로 놀라운 이미지 생성 및 편집",
        "desc": "텍스트-이미지, 정밀 편집, 스타일 전달 및 HD 업스케일링. FLUX, 미드저니, 시드림, GPT-이미지-1 및 나노 바나나 기반.",
        "explore": "이미지 모델 탐색 →"
      },
      "video": {
        "title": "AI로 시네마틱 비디오 생성",
        "desc": "텍스트-비디오에서 이미지 애니메이션까지, 베오, 소라, 클링, 시댄스 및 완 모델 기반. 동기화된 오디오와 전문적인 카메라 작업으로 비디오 생성.",
        "explore": "비디오 모델 탐색 →"
      },
      "music": {
        "title": "AI 기반의 오리지널 음악 생성",
        "desc": "설명에서 오리지널 음악을 생성하며, 다양한 스타일과 길이를 지원합니다. 비디오 사운드트랙, 팟캐스트 배경음악 등에 완벽합니다.",
        "explore": "AI 음악 탐색 →"
      },
      "tools": {
        "title": "전문 AI 도구 상자",
        "desc": "워터마크 제거, 사진 복원, HD 업스케일링, 비디오 향상 등 포스트 프로덕션에 필요한 전문 도구.",
        "explore": "모든 도구 보기 →"
      }
    },
    "models": {
      "tag": "모델",
      "title": "글로벌 최고 AI 모델의 원스톱 통합",
      "subtitle": "모든 주류 AI 모델을 통합하는 하나의 플랫폼. 이제 여러 계정과 구독 간 전환할 필요 없습니다.",
      "imageModels": "이미지 모델",
      "videoModels": "비디오 모델",
      "musicModels": "AI 음악",
      "musicDesc": "설명에서 오리지널 음악 생성",
      "filterAll": "모두",
      "credits": "크레딧",
      "viewAll": "모두 보기 →"
    },
    "features": {
      "tag": "핵심 기능",
      "title": "놀라운 이미지, 비디오 및 음악 생성",
      "subtitle": "텍스트-이미지, 텍스트-비디오, AI 음악 생성부터 정밀 편집 및 HD 업스케일링까지 — 올인원 창작.",
      "items": {
        "textToImage": {
          "tag": "텍스트에서 이미지",
          "title": "텍스트에서 이미지",
          "desc": "설명을 입력하면 마법을 경험할 수 있습니다. 하이퍼 리얼리즘 포트레이트든 판타지 풍경이든, 미드저니, 시드림, 나노 바나나 등의 모델을 사용하여 간단한 프롬프트로 시각적 걸작을 생성합니다.",
          "cta": "이미지 생성",
          "imageAlt": "Midjourney, Seedream, Nano Banana 등 모델로 간단한 프롬프트로 시각적 걸작을 생성"
        },
        "imageEdit": {
          "tag": "이미지 편집 및 스타일 전달",
          "title": "이미지 편집 및 스타일 전달",
          "desc": "AI를 사용하여 이미지를 정밀하게 재구성합니다. 스타일 변경, 개체 수정, 배경 교체 또는 텍스트 편집 여부에 관계없이 모두 고일관성을 유지합니다.",
          "cta": "이미지 편집",
          "beforeAlt": "이미지 편집 및 스타일 전환 전",
          "afterAlt": "이미지 편집 및 스타일 전환 후"
        },
        "textToVideo": {
          "tag": "텍스트에서 비디오",
          "title": "텍스트에서 비디오",
          "desc": "프롬프트를 입력하면 동기화된 오디오, 전문적인 카메라 작업 및 현실적인 모션으로 시네마틱 비디오를 생성합니다. 베오, 소라, 클링, 시댄스 및 완 모델 중 선택하세요.",
          "cta": "비디오 생성"
        },
        "imageToVideo": {
          "tag": "이미지에서 비디오",
          "title": "이미지에서 비디오",
          "desc": "정적 이미지를 시네마틱 비디오로 변환합니다. 제품 사진, 일러스트레이션 또는 AI 생성 이미지 여부에 관계없이 자연스러운 모션과 보이스오버로 생동감 있게 만듭니다.",
          "cta": "이미지 애니메이션"
        },
        "upscale": {
          "tag": "HD 업스케일링",
          "title": "HD 업스케일링",
          "desc": "AI를 사용하여 이미지와 비디오 품질을 향상시킵니다. 무손실 HD 업스케일링을 지원하며 비디오 해상도를 4K 전문 수준으로 향상시킬 수 있습니다.",
          "cta": "지금 업스케일",
          "imageAlt": "AI로 이미지 및 영상 화질 향상"
        },
        "templates": {
          "tag": "40개 이상의 이미지 템플릿",
          "title": "40개 이상의 이미지 템플릿",
          "desc": "靈감을 주는 방대한 템플릿: 3D 모델, 지브리 스타일, 디자이너 토이, 밈 생성기, 매거진 커버 등 — 사진을 업로드하면 즉시 결과를 얻을 수 있습니다.",
          "cta": "템플릿 둘러보기",
          "imageAlt": "이미지 템플릿 예시"
        }
      }
    },
    "gallery": {
      "tag": "갤러리",
      "title": "무한한 가능성 탐색",
      "subtitle": "Miral로 크리에이터들이 만들어낸 것을 확인해보세요 — 하이퍼 리얼리즘 이미지에서 시네마틱 비디오까지, 손끝에서 영감을 받을 수 있습니다.",
      "images": {
        "alt1": "Midjourney 생성 이미지 예시",
        "alt2": "Seedream 생성 이미지 예시",
        "alt3": "GPT-Image-1 생성 이미지 예시",
        "alt4": "Flux 생성 이미지 예시",
        "alt5": "Flux Pro 생성 이미지 예시",
        "alt6": "Midjourney 생성 이미지 예시",
        "alt7": "Seedream 생성 이미지 예시",
        "alt8": "GPT-Image-1 생성 이미지 예시"
      }
    },
    "whyChoose": {
      "tag": "왜 Miral을 선택해야 하나요",
      "title": "올인원 창작, 필요한 모든 것",
      "subtitle": "세계 최고의 AI 이미지, 비디오 및 음악 창작 모델을 한곳에 모은 원스톱 플랫폼.",
      "items": {
        "allModels": {
          "title": "모든 모델 통합, 하나면 충분",
          "desc": "OpenAI, 구글, 알리바바, 바이트댄스 등에서 제공하는 29개 이상의 최고 AI 모델에 원스톱 접근. 도구 간 전환하거나 여러 구독을 관리할 필요 없습니다."
        },
        "fast": {
          "title": "초고속",
          "desc": "대부분의 이미지 생성은 30초 이내에 완료되며, 비디오 생성은 약 1~6분 정도 걸립니다. 최적화된 인프라는 긴 대기 없음을 보장합니다."
        },
        "credits": {
          "title": "간단한 크레딧 시스템",
          "desc": "사용한 만큼 지불, 투명한 가격. 무료 크레딧으로 시작 — 구독 없이 창작을 시작할 수 있습니다."
        },
        "api": {
          "title": "개발자 API",
          "desc": "포괄적인 API를 통해 애플리케이션에 직접 AI 이미지, 비디오 및 음악 생성을 통합할 수 있습니다. 최고 AI 모델 위에 제품을 구축하세요."
        }
      }
    },
    "testimonials": {
      "tag": "사용자 스토리",
      "title": "전 세계 크리에이터들의 신뢰",
      "subtitle": "이미지 생성, 비디오 제작 및 창의적 워크플로우를 위해 Miral을 사용하는 수천 명의 전문가 및 크리에이터에 합류하세요."
    },
    "faq": {
      "tag": "지원",
      "title": "자주 묻는 질문",
      "subtitle": "플랫폼, 지원되는 모델, 요금제 및 기능에 대한 포괄적인 안내."
    },
    "cta": {
      "title": "지금 AI 창작 여정을 시작하세요",
      "subtitle": "세계 최고의 AI 모델을 활용하여 창의력을 실현하는 수천 명의 크리에이터, 디자이너 및 기업에 합류하세요.",
      "createImage": "이미지 생성 →",
      "createVideo": "비디오 생성 →",
      "note": "신규 사용자는 등록 시 무료 크레딧을 받습니다. 신용카드 필요 없음."
    },
    "apps": {
      "title": "앱",
      "quickTitle": "빠른 AI 앱",
      "more": "더보기",
      "keywords": {
        "viralVideo": "바이럴 숏폼",
        "tiktokAds": "TikTok 광고",
        "productShowcase": "제품 쇼케이스",
        "aiAvatar": "AI 아바타",
        "homeModernKitchen": "모던 키친 디자인"
      },
      "social": "소셜 미디어",
      "posters": "포스터",
      "interior": "홈",
      "entertainment": "엔터테인먼트",
      "lifestyle": "라이프스타일",
      "comic": "코믹",
      "items": {
        "viralVideo": "바이럴 영상",
        "celebrityVideo": "셀럽 영상",
        "productShowcase": "제품 쇼케이스",
        "tiktokAds": "틱톡 광고",
        "aiMeme": "AI 밈",
        "aiAvatar": "AI 아바타",
        "logoAnimation": "로고 애니메이션",
        "socialShorts": "SNS 쇼츠",
        "brandStory": "브랜드 스토리",
        "tutorialClip": "튜토리얼",
        "musicVideo": "AI 뮤직 비디오",
        "animeScene": "애니메이션 씬",
        "movieTrailer": "영화 예고편",
        "gameCinematic": "게임 시네마틱",
        "visualPoetry": "비주얼 포에트리",
        "natureDoc": "자연 다큐멘터리",
        "cyberpunkCity": "사이버펑크 시티",
        "underwaterWorld": "수중 세계",
        "timelapseArt": "타임랩스 아트",
        "dailyVlog": "데일리 브이로그",
        "cookingShow": "요리 쇼",
        "fitnessCoach": "피트니스 코치",
        "travelDiary": "여행 일기",
        "fashionShow": "패션쇼",
        "petParadise": "펫 파라다이스",
        "weddingMoment": "웨딩 모먼트",
        "yogaFlow": "요가 플로우",
        "homeDecor": "홈 데코",
        "sunsetRun": "선셋 러닝",
        "instagramReels": "인스타그램 릴스",
        "youtubeIntro": "유튜브 인트로",
        "linkedinPromo": "링크드인 프로모",
        "aiThumbnail": "AI 썸네일",
        "podcastClip": "팟캐스트 클립",
        "horrorShort": "호러 숏",
        "danceVideo": "댄스 영상",
        "aiComic": "AI 코믹",
        "magicShow": "매직쇼",
        "fantasyWorld": "판타지 월드",
        "diyCraft": "DIY 크래프트",
        "morningRoutine": "모닝 루틴",
        "babyGrowth": "아기 성장",
        "streetFood": "스트리트 푸드",
        "bookTrailer": "북 트레일러",
        "socialLuxuryBag": "럭셔리 백 드롭",
        "socialFashionVote": "패션 투표",
        "socialSneakerDrop": "어반 럭스 스니커즈",
        "socialTropicalCocktail": "주말 칵테일",
        "socialCityBillboard": "시티 빌보드 광고",
        "socialStreetwearDrop": "스트릿웨어 드롭",
        "socialBoxingGloves": "복싱 글러브 광고",
        "homeEclecticLiving": "일레틱 거실",
        "homeFarmhouseKitchen": "팜하우스 주방",
        "homeModernKitchen": "모던 미니멀 주방",
        "homeVictorianStairs": "빅토리안 계단",
        "homeScandiLiving": "스칸디나비안 거실",
        "homeMediterraneanPatio": "지중해식 파티오",
        "homeBohoSunroom": "보헤미안 선룸",
        "homeEclecticBedroom": "일레틱 침실",
        "comicPortrait": "슈퍼히어로 코믹",
        "animeCharacter": "메카 애니메이션",
        "mangaScene": "비 내리는 밤 코믹",
        "comicOilPainting": "일상 코믹",
        "comicCover": "에너지 히어로 코믹",
        "animePortrait": "옥상 도약 코믹",
        "comicCouple": "소년 히어로 코믹",
        "mangaWarrior": "마법사 코믹"
      }
    }
  },
  "musicTags": {
    "pop": "팝",
    "electronic": "일렉트로닉",
    "classical": "클래식",
    "jazz": "재즈"
  },
  "music": {
    "breadcrumb": {
      "home": "홈",
      "aiMusic": "AI 음악"
    },
    "model": {
      "label": "모델",
      "aiMusicName": "AI 음악",
      "desc": "설명에서 오리지널 음악을 생성하며, 다양한 스타일과 지속 시간을 지원합니다.",
      "tagMusic": "음악 생성",
      "tagLyrics": "가사 작성"
    },
    "mode": {
      "describe": "설명",
      "lyrics": "가사 작성"
    },
    "form": {
      "musicDesc": "음악 설명",
      "musicDescPlaceholder": "원하는 음악 스타일, 감정 및 장면을 설명하세요...\n\n예: 미래 지향적인 신스 멜로디가 있는 경쾌한 일렉트로닉 음악, 기술 제품 홍보 비디오에 적합",
      "optimize": "최적화",
      "songTitle": "노래 제목",
      "songTitlePlaceholder": "노래 제목을 입력하세요...",
      "lyricsDescLabel": "가사 설명",
      "lyricsDescPlaceholder": "가사 설명을 여기에 작성하세요...\n\n예:\n[Intro]\n...\n[Verse]\n...\n[Chorus]\n...",
      "styleTags": "스타일 태그",
      "styleTagsPlaceholder": "아래 태그를 클릭하여 추가(다중 선택)"
    },
    "tags": {
      "sections": [
        {
          "label": "Verse",
          "value": "[Verse]\n"
        },
        {
          "label": "Chorus",
          "value": "[Chorus]\n"
        },
        {
          "label": "Bridge",
          "value": "[Bridge]\n"
        },
        {
          "label": "Intro",
          "value": "[Intro]\n"
        },
        {
          "label": "Outro",
          "value": "[Outro]\n"
        }
      ],
      "styles": [
        {
          "label": "Pop",
          "value": "Pop"
        },
        {
          "label": "Rock",
          "value": "Rock"
        },
        {
          "label": "Jazz",
          "value": "Jazz"
        },
        {
          "label": "Classical",
          "value": "Classical"
        },
        {
          "label": "Electronic",
          "value": "Electronic"
        },
        {
          "label": "R&B",
          "value": "R&B"
        },
        {
          "label": "Hip-Hop",
          "value": "Hip-Hop"
        },
        {
          "label": "Country",
          "value": "Country"
        },
        {
          "label": "Folk",
          "value": "Folk"
        },
        {
          "label": "Ambient",
          "value": "Ambient"
        },
        {
          "label": "Cinematic",
          "value": "Cinematic"
        },
        {
          "label": "Lo-fi",
          "value": "Lo-fi"
        },
        {
          "label": "Metal",
          "value": "Metal"
        },
        {
          "label": "Reggae",
          "value": "Reggae"
        },
        {
          "label": "Blues",
          "value": "Blues"
        },
        {
          "label": "Soul",
          "value": "Soul"
        },
        {
          "label": "Funk",
          "value": "Funk"
        },
        {
          "label": "Indie",
          "value": "Indie"
        }
      ]
    },
    "options": {
      "duration": "지속 시간",
      "instrumental": "악기 연주",
      "instrumentalDescOn": "보컬 없이 반주만 생성",
      "instrumentalDescOff": "보컬 성능 포함"
    },
    "errors": {
      "titleRequired": "노래 제목은 필수입니다",
      "lyricsDescRequired": "가사 설명은 필수입니다"
    },
    "footer": {
      "creditsRequired": "필요 크레딧:",
      "creditsLeft": "남은 크레딧:",
      "generate": "음악 생성"
    },
    "preview": {
      "generating": "음악 생성 중...",
      "generatedTitle": "생성된 음악",
      "emptyTitle": "AI 음악 생성기",
      "emptySubtitle": "AI로 오리지널 음악을 만드세요. 스타일을 설명하거나 가사를 입력하면 몇 초 만에 곡을 생성할 수 있습니다.",
      "emptyTags": [
        "Pop",
        "Jazz",
        "Cinematic",
        "Lo-fi",
        "Rock"
      ],
      "track": "트랙",
      "play": "재생",
      "pause": "일시정지",
      "mute": "음소거",
      "unmute": "음소거 해제",
      "download": "다운로드",
      "showLyrics": "가사 표시",
      "hideLyrics": "가사 숨기기",
      "generateFailed": "생성 실패",
      "requestFailed": "요청 실패, 다시 시도해 주세요",
      "downloadMp3": "MP3 다운로드",
      "downloadWav": "WAV 다운로드",
      "regenerate": "재생성",
      "noHistory": "아직 기록 없음"
    },
    "intro": {
      "title": "AI 음악 생성기",
      "desc": "고급 AI 기술을 사용하여 설명이나 가사를 입력하면 고품질의 오리지널 음악을 생성할 수 있습니다. 다양한 음악 스타일을 지원하며, 비디오 사운드트랙, 광고, 팟캐스트 등에 적합합니다.",
      "tagMusic": "음악 생성",
      "tagLyrics": "가사 작성",
      "tagStyles": "다양한 스타일",
      "tagCommercial": "상업적 라이선스"
    },
    "features": {
      "badge": "핵심 기능",
      "title": "AI 음악 생성기가 당신에게 할 수 있는 것은?",
      "items": {
        "styles": {
          "icon": "🎵",
          "title": "다양한 스타일",
          "desc": "팝, 록, 일렉트로닉, 재즈, 클래식, 힙합 등 수십 가지 음악 스타일을 지원하여 다양한 창의적 요구를 충족합니다."
        },
        "lyrics": {
          "icon": "📝",
          "title": "가사 작성",
          "desc": "가사를 입력하면 섹션 마커(1절, 후렴 등)를 포함한 완전한 곡을 AI가 자동으로 편곡 및 제작합니다."
        },
        "vocals": {
          "icon": "🎤",
          "title": "보컬 합성",
          "desc": "다양한 음색의 남녀 보컬을 지원하며, AI는 자연스럽고 매끄럽게 가사를 부릅니다."
        },
        "instrumental": {
          "icon": "🎹",
          "title": "악기 연주 모드",
          "desc": "고품질의 악기 연주 반주를 생성하며, 비디오 사운드트랙, 팟캐스트 배경음악 등에 적합합니다."
        },
        "fast": {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "고급 AI 모델은 빠른 음악 제작을 보장하며, 대부분의 음악은 30초 이내에 생성할 수 있습니다."
        },
        "commercial": {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "모든 생성된 음악은 상업적 목적(YouTube 비디오, 광고, 팟캐스트 등)으로 사용할 수 있습니다."
        }
      }
    },
    "faq": {
      "title": "자주 묻는 질문",
      "items": {
        "howItWorks": {
          "q": "AI 음악 생성기는 어떻게 작동하나요?",
          "a": "AI 음악 생성기는 텍스트 설명이나 가사에 따라 오리지널 음악을 생성하기 위해 고급 딥러닝 모델을 사용합니다. 음악 스타일, 감정, 장면 설명을 입력하면 AI가 자동으로 완전한 음악을 작곡합니다."
        },
        "commercial": {
          "q": "생성된 음악을 상업적 용도로 사용할 수 있나요?",
          "a": "네, 당사 플랫폼을 사용하여 생성된 모든 음악은 YouTube 비디오, 광고, 팟캐스트, 게임 등 상업적 목적에 사용할 수 있습니다."
        },
        "styles": {
          "q": "어떤 음악 스타일을 지원하나요?",
          "a": "팝, 록, 일렉트로닉, 재즈, 클래식, 힙합, R&B, 컨트리, 메탈, 포크 등 수십 가지 음악 스타일을 지원합니다. 또한 여러 스타일을 혼합하여 독특한 음악을 만들 수 있습니다."
        },
        "credits": {
          "q": "각 생성은 몇 크레딧이 소요되나요?",
          "a": "선택한 모델에 따라 각 생성은 8~10 크레딧이 소요됩니다. 구독 플랜을 통해 더 좋은 크레딧 요율을 얻을 수 있습니다."
        },
        "download": {
          "q": "생성된 음악을 다운로드할 수 있나요?",
          "a": "네, 생성된 음악은 MP3 및 WAV 형식으로 다운로드를 지원합니다. 필요에 따라 적절한 형식을 선택할 수 있습니다."
        }
      }
    },
    "demoTracks": {
      "summerBreeze": {
        "title": "여름의 바람",
        "style": "팝 / 경쾌함",
        "duration": "2:00"
      },
      "spaceJourney": {
        "title": "우주 여행",
        "style": "일렉트로닉 / 미래지향적",
        "duration": "1:30"
      },
      "rainWalk": {
        "title": "비 속을 걷다",
        "style": "재즈 / 느긋함",
        "duration": "2:30"
      },
      "mountainDawn": {
        "title": "산의 여명",
        "style": "클래식 / 평온",
        "duration": "3:00"
      }
    }
  },
  "pricing": {
    "title": "무한한 영감, 가장 적합한 플랜 선택",
    "subtitle": "모든 AI 모델을 잠금 해제하고 이미지, 비디오 및 음악을 일괄 생성하세요.",
    "promo": "한정 기간 오퍼 — 연간 플랜 30% 할인",
    "monthly": "월간",
    "yearly": "연간",
    "yearlyNote": "연간 플랜 — 크레딧은 한 번에 지급되며, 단일 결제가 더 경제적입니다",
    "popular": "가장 인기",
    "currentPlan": "현재 플랜",
    "currentPlanBtn": "현재 플랜",
    "upgrade": "업그레이드",
    "unavailable": "사용 불가",
    "upgradeSuccess": "업그레이드 성공!",
    "upgradeFailed": "업그레이드 실패",
    "upgradeModal": {
      "title": "업그레이드 확인",
      "item1": "차액을 귀하의 카드에 청구합니다.",
      "item2": "결제 성공 후 추가 잔액이 자동으로 추가됩니다.",
      "item3": "새 플랜은 결제 성공 후 즉시 적용됩니다.",
      "tip": "팁: 결제 방법이 유효한지 확인하세요. 결제 성공 후 잔액이 몇 초 내에 증가합니다.",
      "cancel": "취소",
      "confirm": "업그레이드 확인"
    },
    "subscribe": "지금 구독",
    "processing": "처리 중...",
    "creditsPer": "크레딧 /",
    "extraCredits": "추가 크레딧",
    "creditsRate": "100 크레딧 = $",
    "perMonth": "월",
    "perYear": "년",
    "yearlyBilling": "연간 청구",
    "saveVsMonthly": "월간 대비 절약:",
    "planDesc": {
      "basic": "시작하기에 완벽",
      "pro": "크리에이터 및 전문가에게 최적",
      "ultimate": "팀 및 파워 사용자용"
    },
    "creditsPack": {
      "title": "크레딧 팩 구매",
      "subtitle": "일회성 구매, 구독 없음",
      "buy": "크레딧 구매",
      "oneTime": "일회성 구매",
      "permanent": "크레딧은 만료되지 않음",
      "tip": "팁: 구독이 더 나은 가치",
      "tipItems": [
        "낮은 크레딧 요율 (40-60% 절약)",
        "모든 크레딧 팩 15% 할인"
      ]
    },
    "security": {
      "noTraining": "AI 학습에 사용되지 않음",
      "encrypted": "암호화 저장",
      "gdpr": "GDPR 규정 준수",
      "delete": "자가 서비스 계정 삭제"
    },
    "dataSafety": "우리의 데이터 보안 약속 알아보기 →",
    "allPlansInclude": "모든 플랜 포함",
    "includes": {
      "models": "프리미엄 AI 모델",
      "fast": "빠른 생성",
      "privacy": "100% 개인정보",
      "commercial": "상업적 사용"
    },
    "creditsInfo": {
      "title": "크레딧 가이드",
      "subtitle": "모든 모델의 크레딧 소비량 보기",
      "model": "모델",
      "type": "유형",
      "cost": "크레딧 비용",
      "speed": "속도",
      "image": "이미지",
      "video": "비디오"
    },
    "questions": "질문이 있으신가요?",
    "contact": "도움이 필요하신가요?",
    "contactUs": "문의하기",
    "faq": {
      "items": [
        {
          "q": "크레딧으로 무엇을 만들 수 있나요?",
          "a": "크레딧은 AI 이미지, 비디오 및 음악 생성에 사용할 수 있습니다. 이미지 생성은 2 크레딧부터 시작하며, 비디오 생성은 10 크레딧, 음악은 트랙당 10 크레딧입니다. 프리미엄 모델은 더 많은 크레딧을 소비할 수 있습니다."
        },
        {
          "q": "언제든지 취소할 수 있나요?",
          "a": "네, 언제든지 구독을 취소할 수 있습니다. 현재 청구 기간이 끝날 때까지 서비스를 계속 사용할 수 있습니다."
        },
        {
          "q": "크레딧이 부족하면 어떻게 하나요?",
          "a": "언제든지 일회성 크레딧 팩을 구매할 수 있습니다(구독 필요 없음). 구독자는 크레딧 팩에 15% 할인을 받습니다. 또한 더 나은 요율을 위해 플랜을 업그레이드할 수 있습니다."
        },
        {
          "q": "환불 정책이 있나요?",
          "a": "네. 일회성 팩 또는 첫 구독의 경우, 크레딧 사용률이 3% 미만일 경우 7일 이내에 환불을 요청할 수 있습니다."
        }
      ]
    }
  },
  "modelDetail": {
    "breadcrumb": {
      "home": "홈",
      "models": "모델"
    },
    "model": "모델",
    "modelVersion": "모델 버전",
    "standard": "표준",
    "pro": "프로",
    "standardDesc": "표준 품질, 빠른 생성",
    "proDesc": "고품질, 고해상도 지원",
    "credits": "크레딧",
    "imagePrompt": "이미지 프롬프트",
    "imagePromptPlaceholder": "생성하고 싶은 이미지를 설명하세요...",
    "videoPrompt": "비디오 프롬프트",
    "videoPromptPlaceholder": "생성하고 싶은 비디오를 설명하세요...",
    "referenceImage": "참고 이미지",
    "aspectRatio": "종횡비",
    "thinkingLevel": "사고 수준",
    "thinkingMinimal": "저지연",
    "thinkingHigh": "고충실도",
    "characters": "문자",
    "imageSize": "이미지 크기",
    "auto": "자동",
    "resolution": "해상도",
    "duration": "지속 시간",
    "seconds": "초",
    "creditsRequired": "필요 크레딧:",
    "remaining": "남은 크레딧:",
    "getMoreCredits": "크레딧 구매",
    "generate": "생성",
    "generating": "생성 중...",
    "demoPrompt": "데모 프롬프트",
    "modelLabel": "모델:",
    "version": "버전:",
    "size": "크기:",
    "download": "다운로드",
    "regenerate": "재생성",
    "noHistory": "생성 기록 없음",
    "features": {
      "badge": "핵심 기능",
      "title": "이 모델은 무엇을 할 수 있나요?",
      "items": {
        "realistic": {
          "icon": "📷",
          "title": "리얼리즘 스타일",
          "desc": "자연광과 세부 정보를 갖춘 사진 같은 이미지를 생성합니다."
        },
        "artistic": {
          "icon": "🎨",
          "title": "아티스틱 스타일",
          "desc": "다양한 그림 스타일로 아티스틱 이미지를 생성합니다."
        },
        "portrait": {
          "icon": "👤",
          "title": "포트레이트",
          "desc": "자연스러운 피부 톤의 전문 포트레이트 사진."
        },
        "landscape": {
          "icon": "🏔️",
          "title": "풍경",
          "desc": "인상적인 풍경 및 자연 사진."
        },
        "product": {
          "icon": "📦",
          "title": "제품",
          "desc": "전자상거래를 위한 고품질 제품 사진."
        },
        "fast": {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "대부분의 이미지는 10~30초 이내에 생성됩니다."
        },
        "highRes": {
          "icon": "🖼️",
          "title": "고해상도",
          "desc": "최대 4K 해상도 출력 지원."
        },
        "cinematic": {
          "icon": "🎬",
          "title": "시네마틱",
          "desc": "전문적인 카메라 작업으로 시네마틱 비디오 생성."
        },
        "audioSync": {
          "icon": "🔊",
          "title": "오디오 동기화",
          "desc": "비디오용 네이티브 오디오-비주얼 동기화."
        },
        "lipSync": {
          "icon": "👄",
          "title": "립 싱크",
          "desc": "캐릭터 비디오용 정확한 립 싱크."
        },
        "animation": {
          "icon": "🎭",
          "title": "애니메이션",
          "desc": "부드러운 캐릭터 애니메이션 및 모션."
        },
        "longVideo": {
          "icon": "⏱️",
          "title": "긴 비디오",
          "desc": "더 긴 비디오 지속 시간 지원."
        },
        "privacy": {
          "icon": "🔒",
          "title": "개인정보 보안",
          "desc": "모든 데이터는 암호화되어 전송되며 AI 학습에 사용되지 않습니다. 귀하의 콘텐츠는 완전히 귀하의 것입니다."
        }
      }
    },
    "whyChoose": {
      "items": [
        "{name} AI 모델 기반의 지능형 창작",
        "복잡한 창작 작업을 빠르고 효율적으로 완료",
        "생성된 콘텐츠는 상업적 용도로 사용 가능",
        "지속적인 업데이트로 기능이 계속 향상됨",
        "통합 크레딧 시스템, 필요에 따라 사용"
      ]
    },
    "faq": {
      "title": "자주 묻는 질문",
      "imageType": "이미지",
      "videoType": "비디오",
      "imageFormats": "PNG, JPEG 및 WebP 출력 형식을 지원합니다. 필요에 따라 적절한 형식을 선택할 수 있습니다.",
      "videoFormats": "비디오는 MP4 형식으로 출력되며, 480p 및 720p 해상도와 다양한 종횡비를 지원합니다.",
      "items": [
        {
          "q": "{name}은 어떻게 작동하나요?",
          "a": "참조 이미지를 업로드하거나 텍스트 설명을 직접 입력하면 {name} 모델이 지시 사항을 기반으로 고품질 {type} 콘텐츠를 생성합니다. 프로세스는 간단하고 직관적이며 전문 기술이 필요하지 않습니다."
        },
        {
          "q": "생성된 {type}을 상업적 용도로 사용할 수 있나요?",
          "a": "네, {name}을 사용하여 생성된 모든 콘텐츠는 마케팅 자료, 소셜 미디어, 제품 쇼케이스 등 상업적 용도로 사용할 수 있습니다."
        },
        {
          "q": "각 생성에는 몇 크레딧이 소요되나요?",
          "a": "{name} 사용은 생성당 {credits} 크레딧이 소요됩니다. 구독 플랜을 통해 더 좋은 크레딧 요율을 얻을 수 있습니다."
        },
        {
          "q": "생성 속도는 얼마나 빠른가요?",
          "a": "{name}의 평균 생성 속도는 {speed}입니다. 우리는 빠르고 안정적인 생성을 보장하기 위해 인프라를 지속적으로 최적화하고 있습니다."
        },
        {
          "q": "어떤 출력 형식을 지원하나요?",
          "a": ""
        }
      ]
    },
    "qwenImage20Pro": {
      "negativePromptLabel": "네거티브 프롬프트(선택)",
      "negativePromptPlaceholder": "원하지 않는 내용을 설명하세요(예: 저화질, 변형된 손 등)",
      "customWidth": "가로",
      "customHeight": "세로",
      "sizeHint": "범위: 512×512 ~ 2048×2048",
      "sizeErrorRequired": "가로와 세로를 입력하세요",
      "sizeErrorInteger": "가로와 세로는 정수여야 합니다",
      "sizeErrorRange": "해상도는 512×512 ~ 2048×2048 사이여야 합니다",
      "promptEnhanceTitle": "프롬프트 강화",
      "promptEnhanceDesc": "더 풍부한 결과를 위해 프롬프트 디테일을 강화하세요",
      "watermarkTitle": "워터마크",
      "watermarkDesc": "생성된 이미지에 워터마크를 추가합니다",
      "demoPromptText": "눈 덮인 산 사이로 스키복과 고글을 착용한 소년이 스키를 타며 즐겁게 미끄러지고, 미끄러진 자국을 따라 눈송이가 흩어지며 뒤편에는 끝없이 이어지는 설산 능선이 펼쳐진다.",
      "faqSizeSupportQ": "어떤 해상도가 지원되나요?",
      "faqSizeSupportA": "입력한 가로/세로는 512~2048 사이여야 합니다(예: 2048*2048).",
      "faqMaxCountQ": "한 번에 최대 몇 장까지 생성할 수 있나요?",
      "faqMaxCountA": "최대 4장(n=1..4)입니다.",
      "faqLinkUsageQ": "생성 후 이미지 링크는 어떻게 쓰나요?",
      "faqLinkUsageA": "DashScope에서 반환된 임시 URL을 먼저 다운로드한 뒤, 우리 서버에 업로드하여 장기간 접근 가능한 URL을 반환합니다."
    },
    "zImageTurbo": {
      "promptExtendTitle": "프롬프트 강화",
      "promptExtendDesc": "더 풍부한 결과를 위해 프롬프트 디테일을 강화하세요",
      "customWidth": "가로",
      "customHeight": "세로",
      "sizeHint": "범위: 512×512 ~ 2048×2048",
      "sizeErrorRequired": "가로와 세로를 입력하세요",
      "sizeErrorInteger": "가로와 세로는 정수여야 합니다",
      "sizeErrorRange": "해상도는 512×512 ~ 2048×2048 사이여야 합니다",
      "seedLabel": "시드",
      "seedErrorRequired": "시드를 입력하세요",
      "seedErrorInteger": "시드는 정수여야 합니다",
      "seedErrorRange": "시드 범위는 0 ~ 2147483647 입니다",
      "tagQuality": "고품질",
      "tagOfficial": "공식 직결",
      "tagHighRes": "고해상도",
      "tagSeed": "시드 제어",
      "tagPromptExtend": "프롬프트 강화",
      "feature1Title": "고품질 출력",
      "feature1Desc": "고해상도 이미지를 생성하고 장기 접근 가능한 URL로 업로드합니다.",
      "feature2Title": "사용자 지정 해상도",
      "feature2Desc": "가로/세로를 512~2048 범위로 입력할 수 있습니다.",
      "feature3Title": "생성 제어",
      "feature3Desc": "시드와 프롬프트 강화를 통해 재현성과 튜닝을 지원합니다.",
      "demoPromptText": "고운 황금빛 모래사장 위로 또렷한 발자국이 화면 깊숙이 이어지고, 발자국 가장자리에는 촉촉한 모래 입자의 질감이 살아 있으며, 햇살 아래 모래 표면은 잔잔한 광택을 내고 멀리 등대로 시선을 이끈다.",
      "faqSizeSupportQ": "어떤 해상도가 지원되나요?",
      "faqSizeSupportA": "입력한 가로/세로는 512~2048 사이여야 합니다(예: 1024*1536).",
      "faqSeedQ": "시드는 무엇에 쓰나요?",
      "faqSeedA": "같은 프롬프트와 파라미터에서 시드는 비슷한 결과를 재현하는 데 도움을 줍니다.",
      "faqPromptExtendQ": "프롬프트 강화란 무엇인가요?",
      "faqPromptExtendA": "활성화하면 더 풍부한 결과를 위해 프롬프트 디테일을 강화합니다."
    },
    "creditsRemaining": "Remaining:"
  },
  "modelIntro": {
    "common": {
      "videoMode": "비디오 모드",
      "textToVideo": "텍스트 to 비디오",
      "imageToVideo": "이미지 to 비디오",
      "referenceImage": "참고 이미지",
      "referenceAudio": "참고 오디오",
      "negativePrompt": "네거티브 프롬프트",
      "duration": "재생 시간",
      "resolution": "해상도",
      "aspectRatio": "화면 비율",
      "seed": "시드",
      "generateAudio": "오디오 생성",
      "watermark": "워터마크 추가",
      "endFrame": "엔드 프레임",
      "promptEnhance": "프롬프트 강화",
      "promptExtend": "프롬프트 확장",
      "imageSize": "이미지 크기",
      "imageCount": "생성 수",
      "style": "스타일",
      "sizeMode": "사이즈 모드",
      "width": "너비",
      "height": "높이",
      "optional": "선택",
      "uploading": "업로드 중...",
      "clickToUpload": "클릭하여 업로드",
      "quality": "화질",
      "qualityAuto": "자동",
      "qualityLow": "저화질",
      "qualityMedium": "중간 품질",
      "qualityHigh": "고화질",
      "multipleOf64Hint": "너비와 높이는 64의 배수여야 합니다."
    },
    "seegen": {
      "aspectAdaptive": "자동",
      "genMode": "생성 모드",
      "modeStand": "표준",
      "modeSpeed": "빠름"
    },
    "pollodance": {
      "variantLabel": "모델 변형",
      "card20": "2.0",
      "card20Fast": "2.0 FAST",
      "card20Ref": "2.0 REF",
      "card20FastRef": "2.0 FAST REF",
      "opt20Desc": "고급 모션 제어, 영화급 스타일 변환, 산업급 영상 생성.",
      "opt20FastDesc": "고속 생성 및 저지연 처리.",
      "opt20RefDesc": "영상 간 참조, 스타일 전환, 피사체 추적.",
      "opt20FastRefDesc": "고속 생성과 정밀 참조 제어.",
      "refImages": "참조 이미지(여러 장)",
      "refVideo": "참조 비디오",
      "refAudio": "참조 오디오",
      "webSearch": "웹 검색"
    },
    "nanoBanana": {
      "version": "모델 버전",
      "title": "나노 바나나 프로 AI 이미지 생성기",
      "desc": "나노 바나나는 리얼리즘 스타일 이미지 생성을 지원하는 고성능 AI 이미지 생성 모델로, 포트레이트와 자연 풍경에서 뛰어난 성능을 발휘합니다. 표준 및 프로 버전으로 제공되어 다양한 요구에 부합합니다.",
      "v25Type": "저지연",
      "v25TypeBadge": "빠름",
      "v25TypeDesc": "고정 1024px 해상도, 빠른 생성 속도",
      "v31Type": "고충실도",
      "v31TypeBadge": "고품질",
      "v31TypeDesc": "1K/2K/4K 다중 해상도 지원",
      "demoPrompt": "시네마틱 인물 사진, 골든 아워 조명, 자연스러운 피부 질감, 부드러운 보케 배경",
      "multiSize": "다양한 크기",
      "multiSizeDesc": "자동, 1:1, 4:3, 3:4, 16:9, 9:16, 3:2, 2:3 등의 이미지 크기를 지원합니다.",
      "featuresDesc": "나노 바나나는 다양한 크기와 해상도 옵션으로 고품질 이미지 생성 기능을 제공합니다.",
      "flexiblePricing": "유연한 가격",
      "flexiblePricingDesc": "표준 5 크레딧, 프로 20 크레딧, 필요에 따라 선택.",
      "commercial": "상업적 라이선스",
      "commercialDesc": "생성된 모든 이미지는 상업적 용도로 사용할 수 있습니다.",
      "enterPrompt": "프롬프트를 입력하세요",
      "generateFailed": "생성 실패",
      "requestFailed": "요청 실패, 다시 시도해 주세요",
      "faq": [
        {
          "q": "표준 버전과 프로 버전의 차이점은 무엇인가요?",
          "a": "표준 버전은 표준 품질 이미지를 빠르게 생성하기에 적합하며, 5 크레딧이 소요됩니다. 프로 버전은 더 높은 해상도(1K/2K/4K)와 더 나은 이미지 품질을 지원하며, 20 크레딧이 소요됩니다."
        },
        {
          "q": "나노 바나나는 어떻게 작동하나요?",
          "a": "간단히 텍스트 설명을 입력하면 나노 바나나 모델이 프롬프트를 기반으로 고품질 리얼리즘 스타일 이미지를 생성합니다."
        },
        {
          "q": "어떤 이미지 크기를 지원하나요?",
          "a": "자동, 1:1(정사각형), 4:3, 3:4, 16:9(가로), 9:16(세로), 3:2, 2:3 등을 지원합니다."
        },
        {
          "q": "생성된 이미지를 상업적으로 사용할 수 있나요?",
          "a": "네, 나노 바나나를 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "nanoBanana2": {
      "genType": "생성 버전"
    },
    "seedream": {
      "title": "시드림 4 AI 이미지 생성기",
      "desc": "시드림 4는 아티스틱하고 창의적인 이미지를 전문으로 하는 고급 AI 이미지 생성 모델입니다. 일러스트레이션, 컨셉 아트 및 스타일화된 비주얼에 완벽합니다.",
      "webSearch": "웹 검색",
      "webSearchDesc": "더 정확한 참조 정보를 위해 웹 검색 활성화",
      "watermark": "워터마크 추가",
      "watermarkDesc": "생성 이미지에 워터마크 추가",
      "sizeModeResolution": "해상도 기준",
      "sizeModeCustom": "사용자 지정 크기",
      "customWidth": "너비",
      "customHeight": "높이",
      "sizeHint": "면적 1024×1024～4096×4096, 종횡비 1/16～16",
      "sizeErrorArea": "면적은 1024×1024에서 4096×4096 사이여야 합니다",
      "sizeErrorRatio": "종횡비는 1/16에서 16 사이여야 합니다",
      "demoPromptExample": "오후 측광이 캠핑 텐트를 비추고 텐트 천의 거친 질감이 선명하게 보인다. 독일 셰퍼드가 안에 누워 있고 주인이 쪼그려 앉아 악수한다.",
      "features": [
        {
          "icon": "🎨",
          "title": "아티스틱 스타일",
          "desc": "다양한 그림 및 일러스트레이션 스타일로 놀라운 아티스틱 이미지를 생성합니다."
        },
        {
          "icon": "🖼️",
          "title": "고해상도",
          "desc": "상세한 아트워크를 위한 최대 4K 해상도 지원."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "대부분의 이미지는 15초 이내에 생성됩니다."
        },
        {
          "icon": "🎭",
          "title": "스타일 전달",
          "desc": "다양한 아티스틱 스타일을 창작물에 적용합니다."
        },
        {
          "icon": "📐",
          "title": "다양한 크기",
          "desc": "다양한 종횡비로 다양한 요구 사항 지원."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 이미지는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "시드림 4는 어떤 분야에 가장 적합한가요?",
          "a": "시드림 4는 일러스트레이션, 컨셉 아트 및 스타일화된 비주얼을 포함한 아티스틱하고 창의적인 이미지 생성에 특화되어 있습니다."
        },
        {
          "q": "각 생성에는 몇 크레딧이 소요되나요?",
          "a": "시드림 4 사용은 생성당 8 크레딧이 소요됩니다. 구독 플랜을 통해 더 좋은 크레딧 요율을 얻을 수 있습니다."
        },
        {
          "q": "어떤 스타일을 지원하나요?",
          "a": "시드림 4는 오일 페인팅, 수채화, 디지털 아트, 애니메이션 등 다양한 아티스틱 스타일을 지원합니다."
        },
        {
          "q": "생성된 이미지를 상업적으로 사용할 수 있나요?",
          "a": "네, 시드림 4를 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "midjourney": {
      "title": "미드저니 AI 이미지 생성기",
      "desc": "미드저니는 뛰어난 아티스틱 품질과 창의적 능력으로 알려진 선도적인 AI 이미지 생성 모델입니다. 전문적인 아트워크와 창의적 프로젝트에 완벽합니다.",
      "referenceBoxTitle": "참조 이미지 추가(이미지-이미지)",
      "referenceBoxSubtitle": "PNG, JPEG, WEBP 지원(최대 100KB). 최대 5장. 이미지가 적을수록 결과가 더 정확합니다.",
      "demoPrompt": "하늘에 떠 있는 신비로운 섬, 빛나는 수정으로 덮인 고대 폐허, 구름 아래로 쏟아지는 폭포, 몽환적인 조명, 판타지 아트 스타일",
      "referenceImages": "참조 이미지",
      "referenceImagesCount": "최대 5장",
      "refImageMaxSize": "각 이미지는 100KB를 초과할 수 없습니다",
      "style": "스타일",
      "styleRealistic": "사실적",
      "styleAnime": "애니메",
      "generationSpeed": "생성 속도",
      "fastDesc": "표준 속도 생성",
      "turboDesc": "빠른 생성, 우선 처리",
      "creative": "창의적",
      "highQuality": "고품질",
      "fastTurbo": "빠름/터보",
      "creativeGeneration": "창의적 생성",
      "speed": "속도",
      "features": [
        {
          "icon": "🎨",
          "title": "아티스틱 뛰어남",
          "desc": "산업을 선도하는 아티스틱 품질과 창의적 산출물."
        },
        {
          "icon": "🖼️",
          "title": "고해상도",
          "desc": "전문적인 사용에 적합한 고품질 이미지 생성."
        },
        {
          "icon": "🎭",
          "title": "독특한 스타일",
          "desc": "독특한 아티스틱 스타일로 작업을 돋보이게 합니다."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "대부분의 이미지는 20초 이내에 생성됩니다."
        },
        {
          "icon": "📐",
          "title": "다양한 크기",
          "desc": "다양한 종횡비와 해상도 지원."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 이미지는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "빠름과 터보의 차이점은 무엇인가요?",
          "a": "빠른 모드는 생성당 10 크레딧이 소요되며 표준 속도입니다. 터보 모드는 생성당 20 크레딧이 소요되며 더 빠른 생성과 우선 처리를 제공합니다."
        },
        {
          "q": "미드저니는 어떻게 작동하나요?",
          "a": "간단히 텍스트 설명을 입력하면 미드저니가 프롬프트를 기반으로 아티스틱 이미지를 생성합니다."
        },
        {
          "q": "어떤 이미지 크기를 지원하나요?",
          "a": "1:1(정사각형), 4:3, 3:4, 16:9(가로), 9:16(세로), 3:2, 2:3 등을 지원합니다."
        },
        {
          "q": "생성된 이미지를 상업적으로 사용할 수 있나요?",
          "a": "네, 미드저니를 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "gptImage": {
      "title": "GPT-이미지-1 AI 이미지 생성기",
      "desc": "GPT-이미지-1은 OpenAI의 다용도 이미지 생성 모델로, 텍스트 설명에서 다양한 이미지를 생성할 수 있습니다. 일반적인 이미지 생성에 적합합니다.",
      "demoPromptExample": "황혼의 토스카나 들판, 금빛 밀밭이 이어지는 구릉, 멀리 사이프러스 나무와 오래된 석조 농가, 석양이 하늘을 따뜻한 붉은빛으로 물들임, 힐링, 풍경 사진, 골든 아워.",
      "imageCount": "이미지 수",
      "promptEnhance": "프롬프트 향상",
      "promptEnhanceDesc": "더 나은 생성 결과를 위해 프롬프트를 자동으로 최적화",
      "count": "수량",
      "multiPurpose": "다용도",
      "batchGeneration": "일괄 생성",
      "size1024Square": "1024×1024(정사각형)",
      "size1536Landscape": "1536×1024(가로)",
      "size1024Portrait": "1024×1536(세로)",
      "threeSizes": "세 가지 고정 크기",
      "tagQuality": "고품질",
      "tagCommercialShort": "상업 이용",
      "features": [
        {
          "icon": "🎨",
          "title": "다양한 생성",
          "desc": "모든 용도에 맞는 다양한 이미지를 생성합니다."
        },
        {
          "icon": "🖼️",
          "title": "고품질",
          "desc": "정확한 세부 정보를 갖춘 고품질 이미지 생성."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "대부분의 이미지는 15초 이내에 생성됩니다."
        },
        {
          "icon": "📝",
          "title": "텍스트 이해",
          "desc": "복잡한 텍스트 설명에 대한 탁월한 이해."
        },
        {
          "icon": "📐",
          "title": "세 가지 고정 크기",
          "desc": "1024×1024(정사각형), 1536×1024(가로), 1024×1536(세로)."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 이미지는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "GPT-이미지-1은 어떻게 작동하나요?",
          "a": "간단히 텍스트 설명을 입력하면 GPT-이미지-1이 프롬프트를 기반으로 고품질 이미지를 생성합니다."
        },
        {
          "q": "어떤 이미지 크기를 지원하나요?",
          "a": "1024×1024(정사각형), 1536×1024(가로), 1024×1536(세로) 세 가지 고정 크기를 지원합니다."
        },
        {
          "q": "생성된 이미지를 상업적으로 사용할 수 있나요?",
          "a": "네, GPT-이미지-1을 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "gptImage15": {
      "title": "GPT-이미지-1.5 AI 이미지 생성기",
      "desc": "GPT-이미지-1.5은 OpenAI의 다용도 이미지 생성 모델로, 텍스트 설명에서 다양한 이미지를 생성할 수 있습니다. 일반적인 이미지 생성에 적합합니다.",
      "demoPromptExample": "황혼의 토스카나 들판, 금빛 밀밭이 이어지는 구릉, 멀리 사이프러스 나무와 오래된 석조 농가, 석양이 하늘을 따뜻한 붉은빛으로 물들임, 힐링, 풍경 사진, 골든 아워.",
      "imageCount": "이미지 수",
      "promptEnhance": "프롬프트 향상",
      "promptEnhanceDesc": "더 나은 생성 결과를 위해 프롬프트를 자동으로 최적화",
      "count": "수량",
      "multiPurpose": "다용도",
      "batchGeneration": "일괄 생성",
      "size1024Square": "1024×1024(정사각형)",
      "size1536Landscape": "1536×1024(가로)",
      "size1024Portrait": "1024×1536(세로)",
      "threeSizes": "세 가지 고정 크기",
      "tagQuality": "고품질",
      "tagCommercialShort": "상업 이용",
      "features": [
        {
          "icon": "🎨",
          "title": "다양한 생성",
          "desc": "모든 용도에 맞는 다양한 이미지를 생성합니다."
        },
        {
          "icon": "🖼️",
          "title": "고품질",
          "desc": "정확한 세부 정보를 갖춘 고품질 이미지 생성."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "대부분의 이미지는 15초 이내에 생성됩니다."
        },
        {
          "icon": "📝",
          "title": "텍스트 이해",
          "desc": "복잡한 텍스트 설명에 대한 탁월한 이해."
        },
        {
          "icon": "📐",
          "title": "세 가지 고정 크기",
          "desc": "1024×1024(정사각형), 1536×1024(가로), 1024×1536(세로)."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 이미지는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "GPT-이미지-1.5은 어떻게 작동하나요?",
          "a": "간단히 텍스트 설명을 입력하면 GPT-이미지-1.5이 프롬프트를 기반으로 고품질 이미지를 생성합니다."
        },
        {
          "q": "어떤 이미지 크기를 지원하나요?",
          "a": "1024×1024(정사각형), 1536×1024(가로), 1024×1536(세로) 세 가지 고정 크기를 지원합니다."
        },
        {
          "q": "생성된 이미지를 상업적으로 사용할 수 있나요?",
          "a": "네, GPT-이미지-1.5을 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "fluxKontext": {
      "title": "Flux Kontext AI 이미지 생성기",
      "desc": "Flux Kontext의 최상위 AI 그림 실력을 경험하세요. 최대 2K 해상도의 압도적인 사실감 이미지, 전문가급 미감과 질감.",
      "imageCount": "이미지 수",
      "count": "수량",
      "demoPrompt1": "골든 아워, 옥상에 앉은 젊은 여성, 오버사이즈 데님 재킷, 목에 흰색 헤드폰, 투명 플라스틱 컵으로 아이스 커피를 마신다. 짧은 곱슬머리가 바람에 살짝 흔들리고 멀리 도시 불빛이 켜지기 시작한다.",
      "demoPrompt2": "20대 초반 남성이 어수선한 미술 스튜디오 바닥에 앉아 미완성 캔버스와 물감 튜브에 둘러싸여 있다. 얼룩진 흰 민소매와 찢어진 청바지를 입고 있다.",
      "demoPrompt3": "피크닉 담요에 앉아 아기 비니를 고쳐 주는 젊은 어머니. 크림색 스웨터와 긴 코듀로이 스커트, 맨발로 풀밭 위.",
      "highQuality": "고품질",
      "fastGen": "빠른 생성",
      "multiSize": "다양한 크기",
      "outputStyle": "출력 스타일",
      "outputStyleDesc": {
        "auto": "기본값 — 모델이 스타일을 자동으로 판단하며 강제하지 않습니다",
        "photographic": "사진/실사 — 실제 사진 같은 질감, 자연스러운 빛과 그림자",
        "digital_art": "디지털 아트/일러스트 — CG 느낌, 선명하고 풍부한 색감",
        "anime": "애니/2D — 일본식 애니메이션/만화 스타일, 깔끔한 라인"
      },
      "outputStyleLabel": {
        "auto": "기본값",
        "photographic": "사진/실사",
        "digital_art": "아트",
        "anime": "이차원"
      },
      "features": [
        {
          "icon": "✨",
          "title": "고품질 출력",
          "desc": "디테일이 풍부하고 충실한 이미지를 생성합니다."
        },
        {
          "icon": "🎨",
          "title": "텍스트-이미지",
          "desc": "텍스트 설명에서 정확하게 이미지를 생성합니다."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "대부분의 이미지가 약 15초 안에 완성됩니다."
        },
        {
          "icon": "📐",
          "title": "다양한 크기",
          "desc": "1:1, 3:2, 2:3 비율을 지원합니다."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성 이미지는 상업적으로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "Flux Kontext는 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력하면 Flux Kontext가 고품질 이미지를 생성합니다. 요청당 한 장 또는 여러 장을 지원합니다."
        },
        {
          "q": "어떤 이미지 크기를 지원하나요?",
          "a": "1:1(정사각형), 3:2(가로), 2:3(세로)."
        },
        {
          "q": "한 번에 여러 장을 생성할 수 있나요?",
          "a": "네, 1~3장을 선택할 수 있으며 각각 별도로 과금됩니다."
        },
        {
          "q": "생성 이미지를 상업적으로 사용할 수 있나요?",
          "a": "네, Flux Kontext로 생성한 콘텐츠는 상업적으로 사용할 수 있습니다."
        }
      ]
    },
    "fluxPro11Ultra": {
      "title": "Flux Pro 1.1 Ultra AI 이미지 생성기",
      "desc": "Flux Pro 1.1 Ultra는 고품질 텍스트-이미지. 다양한 종횡비와 일괄 생성을 지원합니다.",
      "imageCount": "이미지 수",
      "count": "수량",
      "demoPrompt1": "골든 아워, 옥상에 앉은 젊은 여성, 오버사이즈 데님 재킷, 목에 흰색 헤드폰, 투명 플라스틱 컵으로 아이스 커피를 마신다. 짧은 곱슬머리가 바람에 살짝 흔들리고 멀리 도시 불빛이 켜지기 시작한다.",
      "demoPrompt2": "20대 초반 남성이 어수선한 미술 스튜디오 바닥에 앉아 미완성 캔버스와 물감 튜브에 둘러싸여 있다. 얼룩진 흰 민소매와 찢어진 청바지를 입고 있다.",
      "demoPrompt3": "피크닉 담요에 앉아 아기 비니를 고쳐 주는 젊은 어머니. 크림색 스웨터와 긴 코듀로이 스커트, 맨발로 풀밭 위.",
      "highQuality": "고품질",
      "fastGen": "빠른 생성",
      "multiSize": "다양한 크기",
      "outputStyle": "출력 스타일",
      "outputStyleDesc": {
        "auto": "기본값 — 모델이 스타일을 자동으로 판단하며 강제하지 않습니다",
        "photographic": "사진/실사 — 실제 사진 같은 질감, 자연스러운 빛과 그림자",
        "digital_art": "디지털 아트/일러스트 — CG 느낌, 선명하고 풍부한 색감",
        "anime": "애니/2D — 일본식 애니메이션/만화 스타일, 깔끔한 라인"
      },
      "outputStyleLabel": {
        "auto": "기본값",
        "photographic": "사진/실사",
        "digital_art": "아트",
        "anime": "이차원"
      },
      "features": [
        {
          "icon": "✨",
          "title": "고품질 출력",
          "desc": "디테일이 풍부하고 충실한 이미지를 생성합니다."
        },
        {
          "icon": "🎨",
          "title": "텍스트-이미지",
          "desc": "텍스트 설명에서 정확하게 이미지를 생성합니다."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "대부분의 이미지가 약 15초 안에 완성됩니다."
        },
        {
          "icon": "📐",
          "title": "다양한 크기",
          "desc": "21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성 이미지는 상업적으로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "Flux Pro 1.1 Ultra는 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력해 고품질 이미지를 생성합니다. 요청당 1~4장."
        },
        {
          "q": "어떤 이미지 크기를 지원하나요?",
          "a": "21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "q": "한 번에 여러 장을 생성할 수 있나요?",
          "a": "네, 1~4장, 각각 별도 과금."
        },
        {
          "q": "생성 이미지를 상업적으로 사용할 수 있나요?",
          "a": "네, 상업적으로 사용할 수 있습니다."
        }
      ]
    },
    "fluxSchnell": {
      "title": "Flux Schnell AI 이미지 생성기",
      "desc": "Flux Schnell은 빠른 텍스트-이미지. 다양한 종횡비와 일괄 생성을 지원합니다.",
      "imageCount": "이미지 수",
      "count": "수량",
      "demoPrompt1": "골든 아워, 옥상에 앉은 젊은 여성, 오버사이즈 데님 재킷, 목에 흰색 헤드폰, 투명 플라스틱 컵으로 아이스 커피를 마신다. 짧은 곱슬머리가 바람에 살짝 흔들리고 멀리 도시 불빛이 켜지기 시작한다.",
      "demoPrompt2": "20대 초반 남성이 어수선한 미술 스튜디오 바닥에 앉아 미완성 캔버스와 물감 튜브에 둘러싸여 있다. 얼룩진 흰 민소매와 찢어진 청바지를 입고 있다.",
      "demoPrompt3": "피크닉 담요에 앉아 아기 비니를 고쳐 주는 젊은 어머니. 크림색 스웨터와 긴 코듀로이 스커트, 맨발로 풀밭 위.",
      "highQuality": "고품질",
      "fastGen": "빠른 생성",
      "multiSize": "다양한 크기",
      "outputStyle": "출력 스타일",
      "outputStyleDesc": {
        "auto": "기본값 — 모델이 스타일을 자동으로 판단하며 강제하지 않습니다",
        "photographic": "사진/실사 — 실제 사진 같은 질감, 자연스러운 빛과 그림자",
        "digital_art": "디지털 아트/일러스트 — CG 느낌, 선명하고 풍부한 색감",
        "anime": "애니/2D — 일본식 애니메이션/만화 스타일, 깔끔한 라인"
      },
      "outputStyleLabel": {
        "auto": "기본값",
        "photographic": "사진/실사",
        "digital_art": "아트",
        "anime": "이차원"
      },
      "features": [
        {
          "icon": "✨",
          "title": "고품질 출력",
          "desc": "디테일이 풍부하고 충실한 이미지를 생성합니다."
        },
        {
          "icon": "🎨",
          "title": "텍스트-이미지",
          "desc": "텍스트 설명에서 정확하게 이미지를 생성합니다."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "대부분의 이미지가 약 15초 안에 완성됩니다."
        },
        {
          "icon": "📐",
          "title": "다양한 크기",
          "desc": "21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성 이미지는 상업적으로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "Flux Schnell은 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력해 빠르게 고품질 이미지를 생성합니다. 요청당 1~4장."
        },
        {
          "q": "어떤 이미지 크기를 지원하나요?",
          "a": "21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16, 9:21."
        },
        {
          "q": "한 번에 여러 장을 생성할 수 있나요?",
          "a": "네, 1~4장, 각각 별도 과금."
        },
        {
          "q": "생성 이미지를 상업적으로 사용할 수 있나요?",
          "a": "네, 상업적으로 사용할 수 있습니다."
        }
      ]
    },
    "flux2": {
      "title": "FLUX.2 AI 이미지 생성기",
      "desc": "FLUX.2는 엔터프라이즈급 효율성과 전문가 수준의 정밀도로 포토리얼한 디테일, 정확한 손·얼굴·텍스처를 생성합니다.",
      "variantLabel": "모델 버전",
      "variantDesc": {
        "klein-04": "실시간",
        "klein-09": "밸런스",
        "max": "최고 품질",
        "pro": "프로덕션",
        "flex": "커스터마이징"
      },
      "promptUpsampling": "프롬프트 업샘플링",
      "promptUpsamplingHint": "프롬프트 디테일을 향상시켜 더 풍부한 출력을 생성합니다 (Klein 모델 제외).",
      "steps": "스텝 수",
      "stepsHint": "스텝이 높을수록 디테일이 늘어나지만 속도가 느려집니다. Flex 버전 전용.",
      "guidance": "가이던스",
      "guidanceHint": "출력이 프롬프트에 얼마나 밀접하게 따르는지 제어합니다. Flex 버전 전용.",
      "tagPhotorealism": "포토리얼리즘",
      "tagMultilingual": "다국어",
      "tagVariants": "5개 버전",
      "demoPrompt1": "A young woman sitting on a rooftop at golden hour, wearing an oversized denim jacket, white headphones around her neck, sipping iced coffee from a clear plastic cup. Her short curly hair blows slightly in the wind as city lights begin to glow in the distance.",
      "features": [
        { "icon": "✨", "title": "포토리얼한 디테일", "desc": "손, 얼굴, 직물, 로고, 작은 물체를 최대 4MP 해상도로 정확하게 재현." },
        { "icon": "🎨", "title": "타이포그래피와 디자인", "desc": "명확하고 읽기 쉬운 타이포그래피를 렌더링하고 복잡한 레이아웃 지시를 따릅니다." },
        { "icon": "🌍", "title": "다국어 지원", "desc": "모국어 프롬프트 입력을 지원하며 최고 수준의 명령어 이해를 구현." },
        { "icon": "🎯", "title": "5개 모델 버전", "desc": "Klein 4B/9B (속도), Max (최고 품질), Pro (프로덕션), Flex (커스텀 제어)." },
        { "icon": "⚙️", "title": "유연한 제어", "desc": "스텝, 가이던스, 크기, 안전 수용도를 조정 가능한 프로덕션 워크플로우." }
      ],
      "faq": [
        { "q": "FLUX.2의 모델 버전은 어떤 것들이 있나요?", "a": "FLUX.2는 5개 버전을 제공합니다: Klein 4B와 9B(고속·대량), Max(최고 품질, 검색 기반), Pro(프로덕션 규모), Flex(스텝·가이던스 조정 가능)." },
        { "q": "지원되는 이미지 크기는?", "a": "FLUX.2는 픽셀 단위(너비 x 높이)를 사용하며 16의 배수여야 합니다. 1:1, 4:3, 3:4, 16:9, 9:16, 21:9, 9:21 프리셋이 있습니다." },
        { "q": "프롬프트 업샘플링이란?", "a": "활성화하면 모델이 내부적으로 프롬프트를 향상시켜 더 풍부한 디테일을 생성합니다. Max, Pro, Flex 버전에서 사용 가능(Klein 제외)." },
        { "q": "Flex 모드의 스텝과 가이던스는?", "a": "스텝(1-50)은 추론 품질을 제어합니다(높을수록 상세하지만 느림). 가이던스(1.5-10)는 프롬프트 준수도를 제어합니다(높을수록 설명에 가까움)." },
        { "q": "생성된 이미지를 상업적으로 사용할 수 있나요?", "a": "네, 생성된 콘텐츠는 상업적 목적으로 사용할 수 있습니다." }
      ]
    },
    "seedance": {
      "title": "시댄스 AI 비디오 생성기",
      "desc": "시댄스는 네이티브 오디오-비주얼 동기화, 시네마틱 모션 및 감정 표현을 지원하는 차세대 AI 비디오 모델입니다. 텍스트-비디오, 이미지-비디오, 비디오 확장을 포함한 다양한 모드를 제공합니다.",
      "textToVideo": "텍스트에서 비디오",
      "imageToVideo": "이미지에서 비디오",
      "videoExtend": "비디오 확장",
      "uploadImage": "클릭하여 참조 이미지 업로드",
      "uploadHint": "PNG, JPG, JPEG (최대 20MB)",
      "endFrame": "엔드 프레임 이미지",
      "endFrameHint": "(선택 사항) 비디오 종료를 제어하기 위해 엔드 프레임 업로드",
      "uploadEndFrame": "클릭하여 엔드 프레임 이미지 업로드",
      "uploadVideo": "클릭하여 참조 비디오 업로드",
      "uploadVideoHint": "MP4, MOV, WebM (최대 100MB)",
      "videoPrompt": "비디오 프롬프트",
      "promptPlaceholder": "생성하고 싶은 비디오를 설명하세요...",
      "videoPromptPlaceholder": "생성하고 싶은 비디오를 설명하세요...",
      "negativePrompt": "네거티브 프롬프트",
      "negativePromptPlaceholder": "비디오에 원하지 않는 내용을 설명하세요(선택 사항)",
      "duration": "지속 시간",
      "videoDuration": "비디오 지속 시간",
      "resolution": "해상도",
      "aspectRatio": "종횡비",
      "promptEnhance": "프롬프트 향상",
      "promptEnhanceDesc": "더 나은 생성 결과를 위해 프롬프트를 자동으로 최적화",
      "generateAudio": "오디오 생성",
      "audioOn": "네이티브 오디오(음성 + 효과음)",
      "audioOff": "비디오만, 오디오 없음",
      "seedValue": "시드 (랜덤 시드)",
      "seedHint": "시드 값은 작품 전체 스타일의 고유 식별자입니다. 같은 시드 값을 입력하면 스타일을 유지할 수 있고, 다른 파라미터를 미세 조정해 화면 디테일을 개선할 수 있습니다.",
      "seedPlaceholder": "-1 (랜덤)",
      "characters": "문자",
      "creditsRequired": "필요 크레딧:",
      "creditsRemaining": "남은 크레딧:",
      "remaining": "남은 크레딧:",
      "getMoreCredits": "크레딧 구매",
      "generate": "생성",
      "generating": "생성 중...",
      "demoPrompt": "데모 프롬프트",
      "demoPromptExample": "부드럽고 귀여운 흰 고양이 새끼가 발끝으로 즐겁게 춤을 춥니다. 보송보송한 몸이 작은 분홍색 발바닥을 든 채 부드럽게 흔들리고요. 따뜻한 노란 조명 아래, 폭신한 카펫 위에서 펼쳐지는 힐링 만화 스타일, 정교한 디테일과 부드럽고 은은한 색감.",
      "modelLabel": "모델:",
      "durationLabel": "지속 시간:",
      "techSpecsTitle": "기술 사양",
      "techSpecsDesc": "시댄스는 네이티브 오디오-비주얼 동기화, 시네마틱 모션 및 감정 표현을 지원합니다. 텍스트-비디오, 이미지-비디오, 비디오 확장을 포함한 다양한 모드를 제공합니다.",
      "t2vTitle": "텍스트에서 비디오(T2V)",
      "t2vDesc": "프롬프트를 시네마틱 비디오 장면으로 변환",
      "i2vTitle": "이미지에서 비디오(I2V)",
      "i2vDesc": "AI를 사용하여 단일 이미지 애니메이션",
      "input": "입력:",
      "textPrompt": "텍스트 프롬프트",
      "imagePrompt": "이미지 + 프롬프트",
      "audio": "오디오:",
      "nativeAudio": "네이티브 오디오 생성",
      "bestFor": "최적:",
      "t2vBestFor": "시네마틱 콘텐츠 제작, 광고, 소셜 미디어 비디오에 완벽합니다.",
      "i2vBestFor": "포트레이트 애니메이션, 제품 쇼케이스, 창의적 콘텐츠에 최적입니다.",
      "featuresDesc": "디자이너, 마케터, 콘텐츠 크리에이터 또는 일반 사용자이든, 시댄스는 고품질 AI 콘텐츠를 빠르게 생성하는 데 도움을 줍니다.",
      "features": [
        {
          "icon": "🎬",
          "title": "네이티브 오디오-비주얼 생성",
          "desc": "한 번에 비디오와 오디오를 동기화하여 생성하여 시네마틱 품질을 제공합니다. 자연스러운 립 싱크 및 대사 더빙."
        },
        {
          "icon": "😊",
          "title": "감정 중심 표현",
          "desc": "더 현실적인 얼굴 표현을 위한 새로운 감정 인식 성능. 망설임, 슬픔, 긴장 또는 감정 억제와 같은 미묘한 표현을 포함합니다."
        },
        {
          "icon": "🎥",
          "title": "감독 수준의 카메라 제어",
          "desc": "푸시, 풀, 팬, 오르빗, 트래킹 카메라 이동을 지원합니다. 부드러운 전환을 위한 첫 번째 및 마지막 프레임 가이드."
        },
        {
          "icon": "📱",
          "title": "멀티 모달 입력",
          "desc": "텍스트-비디오, 이미지-비디오 등 유연한 창의적 워크플로우 지원."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "최적화된 추론 엔진은 빠른 생산을 보장하며, 대부분의 비디오는 몇 분 이내에 완료됩니다."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 광고, 소셜 미디어 등 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "enterPrompt": "프롬프트를 입력하세요",
      "imageRequired": "이미지-비디오 모드에는 참조 이미지가 필요합니다",
      "videoRequired": "비디오 확장 모드에는 참조 비디오가 필요합니다",
      "generateFailed": "생성 실패",
      "requestFailed": "요청 실패, 다시 시도해 주세요",
      "faq": [
        {
          "q": "시댄스는 어떻게 작동하나요?",
          "a": "참조 이미지를 업로드하거나 텍스트 설명을 직접 입력하면 시댄스 모델이 지시 사항을 기반으로 고품질 비디오 콘텐츠를 생성하며, 동기화된 오디오를 제공합니다. 프로세스는 간단하고 직관적이며 전문적인 기술이 필요하지 않습니다."
        },
        {
          "q": "생성된 비디오를 상업적으로 사용할 수 있나요?",
          "a": "네, 시댄스를 사용하여 생성된 모든 콘텐츠는 마케팅 자료, 소셜 미디어, 제품 쇼케이스 등 상업적 용도로 사용할 수 있습니다."
        },
        {
          "q": "각 생성에는 몇 크레딧이 소요되나요?",
          "a": "시댄스 사용은 생성당 18 크레딧이 소요됩니다. 구독 플랜을 통해 더 좋은 크레딧 요율을 얻을 수 있습니다."
        },
        {
          "q": "생성 속도는 얼마나 빠른가요?",
          "a": "시댄스의 평균 생성 속도는 약 1.5분입니다. 우리는 빠르고 안정적인 생성을 보장하기 위해 인프라를 지속적으로 최적화하고 있습니다."
        },
        {
          "q": "어떤 출력 형식을 지원하나요?",
          "a": "비디오는 MP4 형식으로 출력되며, 480p, 720p, 1080p 해상도를 지원하며, 5초 또는 10초의 지속 시간과 다양한 종횡비를 제공합니다."
        }
      ]
    },
    "veo": {
      "title": "베오 3.1 AI 비디오 생성기",
      "desc": "구글 베오 3.1은 네이티브 오디오 생성, 초고해상도 및 긴 비디오 생성을 지원하는 최첨단 AI 비디오 모델입니다. 전문적인 비디오 제작에 완벽합니다.",
      "fastType": "빠른 유형",
      "fastTypeBadge": "빠른 속도, 낮은 비용",
      "fastTypeDesc": "(16:9 참조 이미지 지원)",
      "qualityType": "품질 유형",
      "qualityTypeBadge": "풍부한 세부 정보",
      "qualityTypeDesc": "부드러운 모션. 이미지 모드에서는 엔드 프레임을 선택하여 마지막 프레임을 제어할 수 있습니다.",
      "imageMode": "생성 모드",
      "startEndFrames": "시작/엔드 프레임",
      "referenceImage": "참조 이미지",
      "startFrame": "시작 프레임",
      "startFrameHint": "첫 번째 프레임을 설정합니다. 비디오는 이 프레임에서 애니메이션됩니다.",
      "uploadStartFrame": "클릭하여 시작 프레임 업로드",
      "endFrame": "엔드 프레임",
      "endFrameHint": "마지막 프레임을 설정합니다. 비디오는 이 프레임에서 종료됩니다.",
      "uploadEndFrame": "클릭하여 엔드 프레임 업로드",
      "negativePrompt": "네거티브 프롬프트",
      "negativePromptPlaceholder": "비디오에 원하지 않는 내용을 설명하세요...",
      "features": [
        {
          "icon": "🎬",
          "title": "네이티브 오디오 생성",
          "desc": "비디오와 오디오를 동기화하여 생성하며, 대사와 효과음을 포함합니다."
        },
        {
          "icon": "📺",
          "title": "울트라 HD 해상도",
          "desc": "전문적인 비디오 제작을 위한 최대 4K 해상도 출력 지원."
        },
        {
          "icon": "⏱️",
          "title": "긴 비디오 지원",
          "desc": "다양한 창의적 요구에 맞춘 최대 2분 길이의 비디오 생성."
        },
        {
          "icon": "🎥",
          "title": "시네마틱 모션",
          "desc": "전문적인 카메라 이동과 부드러운 전환."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "빠른 생산을 위한 최적화된 추론 엔진."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "빠른 유형과 품질 유형의 차이점은 무엇인가요?",
          "a": "빠른 유형은 더 빠르고 비용 효율적이며, 빠른 반복에 적합합니다. 품질 유형은 더 풍부한 세부 정보와 부드러운 모션을 제공하여 최종 출력에 이상적입니다."
        },
        {
          "q": "베오 3.1은 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력하거나 참조 이미지를 업로드하면 베오 3.1이 지시 사항을 기반으로 고품질 비디오 콘텐츠를 생성하며, 선택적으로 동기화된 오디오를 제공합니다."
        },
        {
          "q": "각 생성에는 몇 크레딧이 소요되나요?",
          "a": "베오 3.1 사용은 생성당 30 크레딧이 소요됩니다. 구독 플랜을 통해 더 좋은 크레딧 요율을 얻을 수 있습니다."
        },
        {
          "q": "어떤 해상도와 지속 시간을 지원하나요?",
          "a": "720p 및 1080p 해상도를 지원하며, 5초, 10초 및 최대 2분의 긴 비디오를 위한 지속 시간을 제공합니다."
        }
      ]
    },
    "veo30": {
      "title": "베오 3.0 AI 비디오 생성기",
      "desc": "구글 베오 3.0은 텍스트-비디오 및 이미지-비디오를 지원하는 고급 AI 비디오 모델로, 4초/6초/8초 지속 시간과 720p/1080p 출력을 제공합니다.",
      "fastType": "빠른 유형",
      "fastTypeBadge": "더 빠름, 낮은 비용",
      "fastTypeDesc": "(16:9 참조 이미지 지원)",
      "qualityType": "품질 유형",
      "qualityTypeBadge": "풍부한 세부 정보",
      "qualityTypeDesc": "부드러운 모션. 이미지 모드에서는 엔드 프레임을 선택하여 마지막 프레임을 제어할 수 있습니다.",
      "imageMode": "이미지 모드",
      "startEndFrames": "시작/엔드 프레임",
      "referenceImage": "참조 이미지",
      "referenceImageHint": "참조 이미지를 업로드하면, 비디오는 이를 기반으로 생성됩니다.",
      "uploadReferenceImage": "클릭하여 참조 이미지 업로드",
      "startFrame": "시작 프레임",
      "startFrameHint": "첫 번째 프레임을 설정합니다. 비디오는 이 프레임에서 애니메이션됩니다.",
      "uploadStartFrame": "클릭하여 시작 프레임 업로드",
      "endFrame": "엔드 프레임",
      "endFrameHint": "마지막 프레임을 설정합니다. 비디오는 이 프레임에서 종료됩니다.",
      "uploadEndFrame": "클릭하여 엔드 프레임 업로드",
      "negativePrompt": "네거티브 프롬프트",
      "negativePromptPlaceholder": "비디오에 원하지 않는 내용을 설명하세요...",
      "seedRangeError": "시드는 0에서 2147483647 사이의 정수여야 합니다.",
      "duration": "지속 시간",
      "resolution": "해상도",
      "demoPrompt": "카페 창문에서 노트북을 그리는 십대 소녀, 유리창에 빗방울이 떨어지는...",
      "features": [
        {
          "icon": "🎬",
          "title": "네이티브 오디오 생성",
          "desc": "비디오와 오디오를 동기화하여 생성하며, 대사와 효과음을 포함합니다."
        },
        {
          "icon": "📺",
          "title": "HD 해상도",
          "desc": "전문적인 비디오 제작을 위한 720p 및 1080p 출력 지원."
        },
        {
          "icon": "⏱️",
          "title": "다양한 지속 시간",
          "desc": "4초, 6초, 8초 비디오 생성 지원."
        },
        {
          "icon": "🎥",
          "title": "시네마틱 모션",
          "desc": "전문적인 카메라 이동과 부드러운 전환."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "빠른 생산을 위한 최적화된 추론 엔진."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "빠른 유형과 품질 유형의 차이점은 무엇인가요?",
          "a": "빠른 유형은 더 빠르고 비용 효율적이며, 빠른 반복에 적합합니다. 품질 유형은 더 풍부한 세부 정보와 부드러운 모션을 제공하여 최종 출력에 이상적입니다."
        },
        {
          "q": "베오 3.0은 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력하거나 참조 이미지를 업로드하면 베오 3.0이 지시 사항을 기반으로 고품질 비디오 콘텐츠를 생성하며, 선택적으로 동기화된 오디오를 제공합니다."
        },
        {
          "q": "각 생성에는 몇 크레딧이 소요되나요?",
          "a": "베오 3.0 사용은 생성당 25 크레딧이 소요됩니다. 구독 플랜을 통해 더 좋은 크레딧 요율을 얻을 수 있습니다."
        },
        {
          "q": "어떤 해상도와 지속 시간을 지원하나요?",
          "a": "720p 및 1080p 해상도를 지원하며, 4초, 6초, 8초의 지속 시간을 제공합니다."
        }
      ]
    },
    "veo31fast": {
      "title": "베오 3.1 빠른 AI 비디오 생성기",
      "desc": "구글 베오 3.1 빠름은 더 빠른 생성을 위한 것으로, 텍스트-비디오 및 이미지-비디오를 지원하며, 선택적 테일 프레임, 4초/6초/8초 지속 시간 및 720p/1080p/4K 출력을 제공합니다.",
      "referenceImage": "참조 이미지",
      "referenceImageHint": "참조 이미지를 업로드하면, 비디오는 이를 기반으로 생성됩니다.",
      "uploadReferenceImage": "클릭하여 참조 이미지 업로드",
      "endFrame": "테일 프레임",
      "endFrameHint": "선택 사항. 비디오 종료를 제어하기 위해 마지막 프레임의 이미지를 설정하세요.",
      "uploadEndFrame": "클릭하여 테일 프레임 업로드",
      "duration": "지속 시간",
      "resolution": "해상도",
      "seedRangeError": "시드는 0에서 2147483647 사이의 정수여야 합니다.",
      "demoPrompt": "카페 창문에서 노트북을 그리는 십대 소녀, 유리창에 빗방울이 떨어지는...",
      "features": [
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "더 빠른 출력을 위한 최적화."
        },
        {
          "icon": "📺",
          "title": "4K 해상도",
          "desc": "720p, 1080p, 4K 출력 지원."
        },
        {
          "icon": "⏱️",
          "title": "다양한 지속 시간",
          "desc": "4초, 6초, 8초 비디오 지원."
        },
        {
          "icon": "🖼️",
          "title": "선택적 테일 프레임",
          "desc": "이미지-비디오는 테일 프레임을 업로드하여 종료를 제어할 수 있습니다."
        },
        {
          "icon": "🎥",
          "title": "시네마틱 모션",
          "desc": "전문적인 카메라 이동과 부드러운 전환."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "베오 3.1 빠름과 베오 3.1의 차이점은 무엇인가요?",
          "a": "베오 3.1 빠름은 속도와 낮은 크레딧 비용을 위해 최적화되어 있으며, 4K 및 선택적 테일 프레임 지원을 제공합니다."
        },
        {
          "q": "테일 프레임이란 무엇인가요?",
          "a": "이미지-비디오의 경우, 테일 프레임 이미지를 업로드하여 비디오가 해당 프레임에서 종료되도록 제어할 수 있습니다."
        },
        {
          "q": "각 생성에는 몇 크레딧이 소요되나요?",
          "a": "베오 3.1 빠름 사용은 생성당 20 크레딧이 소요됩니다."
        },
        {
          "q": "어떤 해상도와 지속 시간을 지원하나요?",
          "a": "720p, 1080p, 4K 해상도를 지원하며, 4초, 6초, 8초의 지속 시간을 제공합니다."
        }
      ]
    },
    "kling": {
      "title": "클링 2.6 AI 비디오 생성기",
      "desc": "클링 2.6은 텍스트-비디오 및 이미지-비디오를 지원하는 고성능 AI 비디오 모델로, 우수한 모션 품질과 빠른 생성 속도를 제공합니다.",
      "features": [
        {
          "icon": "🎬",
          "title": "고품질 모션",
          "desc": "부드럽고 자연스러운 모션과 전문적인 품질 출력."
        },
        {
          "icon": "📱",
          "title": "다양한 종횡비",
          "desc": "1:1, 16:9, 9:16 등 다양한 종횡비 지원."
        },
        {
          "icon": "🔊",
          "title": "오디오 생성",
          "desc": "완전한 비디오 경험을 위한 선택적 네이티브 오디오 생성."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "대부분의 비디오는 2분 이내에 생성됩니다."
        },
        {
          "icon": "🖼️",
          "title": "이미지에서 비디오",
          "desc": "AI 기반 모션으로 정적 이미지 애니메이션."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "클링 2.6은 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력하거나 참조 이미지를 업로드하면 클링 2.6이 지시 사항을 기반으로 고품질 비디오 콘텐츠를 생성합니다."
        },
        {
          "q": "각 생성에는 몇 크레딧이 소요되나요?",
          "a": "클링 2.6 사용은 생성당 28 크레딧이 소요됩니다. 구독 플랜을 통해 더 좋은 크레딧 요율을 얻을 수 있습니다."
        },
        {
          "q": "어떤 해상도와 지속 시간을 지원하나요?",
          "a": "720p 및 1080p 해상도를 지원하며, 5초 및 10초의 지속 시간을 제공합니다."
        },
        {
          "q": "생성된 비디오를 상업적으로 사용할 수 있나요?",
          "a": "네, 클링 2.6을 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "kling3": {
      "title": "클링 3.0 AI 비디오 생성기",
      "desc": "클링 3.0은 텍스트-비디오 및 이미지-비디오를 지원하는 고성능 AI 비디오 모델로, 우수한 모션 품질과 빠른 생성 속도를 제공합니다.",
      "features": [
        {
          "icon": "🎬",
          "title": "고품질 모션",
          "desc": "부드럽고 자연스러운 모션과 전문적인 품질 출력."
        },
        {
          "icon": "📱",
          "title": "다양한 종횡비",
          "desc": "1:1, 16:9, 9:16 등 다양한 종횡비 지원."
        },
        {
          "icon": "🔊",
          "title": "오디오 생성",
          "desc": "완전한 비디오 경험을 위한 선택적 네이티브 오디오 생성."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "대부분의 비디오는 2분 이내에 생성됩니다."
        },
        {
          "icon": "🖼️",
          "title": "이미지에서 비디오",
          "desc": "AI 기반 모션으로 정적 이미지 애니메이션."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "클링 3.0은 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력하거나 참조 이미지를 업로드하면 클링 3.0이 지시 사항을 기반으로 고품질 비디오 콘텐츠를 생성합니다."
        },
        {
          "q": "각 생성에는 몇 크레딧이 소요되나요?",
          "a": "클링 3.0 사용은 생성당 28 크레딧이 소요됩니다. 구독 플랜을 통해 더 좋은 크레딧 요율을 얻을 수 있습니다."
        },
        {
          "q": "어떤 해상도와 지속 시간을 지원하나요?",
          "a": "720p 및 1080p 해상도를 지원하며, 5초 및 10초의 지속 시간을 제공합니다."
        },
        {
          "q": "생성된 비디오를 상업적으로 사용할 수 있나요?",
          "a": "네, 클링 3.0을 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "sora": {
      "title": "소라 2 AI 비디오 생성기",
      "desc": "소라 2는 OpenAI의 고급 AI 비디오 모델로, 현실적인 모션과 시네마틱 품질을 갖춘 고품질 비디오를 생성할 수 있습니다.",
      "demoPromptExample": "@sama OpenAI CEO 샘이 이 캐비닛 제품을 소개하며, 자신이 쓰는 것과 같고 매우 유용하다고 말한다.",
      "landscape": "가로",
      "portrait": "세로",
      "removeWatermark": "워터마크 제거",
      "enabled": "활성화됨",
      "disabled": "비활성화됨",
      "noWatermark": "워터마크 없음",
      "cinematic": "시네마틱 품질",
      "restrictedAccess": "제한된 접근",
      "60secDuration": "4초 / 8초 / 12초 길이",
      "photorealistic": "사진처럼 사실한",
      "physicsSimulation": "물리 시뮬레이션",
      "features": [
        {
          "icon": "🎬",
          "title": "시네마틱 품질",
          "desc": "전문적인 시네마틱 느낌의 비디오를 생성합니다."
        },
        {
          "icon": "🎥",
          "title": "현실적인 모션",
          "desc": "캐릭터와 장면을 위한 자연스럽고 현실적인 모션."
        },
        {
          "icon": "⏱️",
          "title": "유연한 지속 시간",
          "desc": "다양한 필요에 맞춘 다양한 비디오 길이 지원."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "빠른 비디오 생산을 위한 최적화."
        },
        {
          "icon": "🖼️",
          "title": "멀티 모달 입력",
          "desc": "텍스트-비디오 및 이미지-비디오 모드 지원."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "소라 2는 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력하거나 참조 이미지를 업로드하면 소라 2가 지시 사항을 기반으로 고품질 비디오 콘텐츠를 생성합니다."
        },
        {
          "q": "각 생성에는 몇 크레딧이 소요되나요?",
          "a": "소라 2 사용은 생성당 15 크레딧이 소요됩니다. 구독 플랜을 통해 더 좋은 크레딧 요율을 얻을 수 있습니다."
        },
        {
          "q": "소라 2의 특징은 무엇인가요?",
          "a": "소라 2는 현실적인 모션과 시네마틱 품질의 비디오 생성에 특화되어 있어 전문적인 콘텐츠 제작에 이상적입니다."
        },
        {
          "q": "생성된 비디오를 상업적으로 사용할 수 있나요?",
          "a": "네, 소라 2를 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "wan": {
      "title": "완 AI 비디오 생성기",
      "desc": "완은 텍스트-비디오 및 이미지-비디오를 지원하는 다재다능한 AI 비디오 모델로, 우수한 품질과 속도를 제공합니다.",
      "multiFormat": "다양한 형식",
      "smoothMotion": "부드러운 모션",
      "referenceAudio": "참조 오디오",
      "uploadAudio": "클릭하여 참조 오디오 업로드",
      "uploadAudioHint": "MP3, WAV, M4A (선택 사항, 비디오 사운드트랙을 주도)",
      "features": [
        {
          "icon": "🎬",
          "title": "고품질 출력",
          "desc": "텍스트 또는 이미지에서 전문적인 품질의 비디오를 생성합니다."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "효율적인 워크플로우를 위한 빠른 비디오 생산."
        },
        {
          "icon": "📱",
          "title": "다양한 형식",
          "desc": "다양한 종횡비와 해상도 지원."
        },
        {
          "icon": "🖼️",
          "title": "이미지 애니메이션",
          "desc": "AI 모션으로 정적 이미지를 생동감 있게 만듭니다."
        },
        {
          "icon": "🎥",
          "title": "부드러운 모션",
          "desc": "생성된 비디오에서 자연스럽고 유창한 모션."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "완은 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력하거나 참조 이미지를 업로드하면 완이 지시 사항을 기반으로 고품질 비디오 콘텐츠를 생성합니다."
        },
        {
          "q": "어떤 완 버전을 사용해야 하나요?",
          "a": "완 2.5 및 2.6은 최신 기능과 최고 품질을 제공합니다. 완 2.2는 단순한 프로젝트에 비용 효율적인 옵션입니다."
        },
        {
          "q": "각 생성에는 몇 크레딧이 소요되나요?",
          "a": "완 2.6은 생성당 70 크레딧, 완 2.5는 생성당 60 크레딧, 완 2.2는 생성당 10 크레딧이 소요됩니다."
        },
        {
          "q": "생성된 비디오를 상업적으로 사용할 수 있나요?",
          "a": "네, 완을 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "wan22": {
      "title": "완 2.2 클래식 AI 비디오 생성기",
      "desc": "완 2.2는 텍스트-비디오 및 이미지-비디오를 지원하는 클래식 AI 비디오 모델로, 안정적이고 신뢰할 수 있는 비디오 생성을 제공하며 가격 대비 성능이 우수합니다.",
      "demoPromptExample": "해질녘 옥상에 앉아 있는 주근깨와 헝클어진 빨간 머리의 소녀, 살짝 닳은 데님 재킷을 입고 폴라로이드 카메라를 들고 있으며, 뒤편 도시 스카이라인이 부드러운 색조로 빛난다.",
      "resolutionBadge": "720p",
      "costEffective": "가격 대비 성능 우수",
      "classicVersion": "클래식",
      "stableReliable": "안정적이고 신뢰할 수 있음",
      "features": [
        {
          "icon": "🎬",
          "title": "텍스트/이미지에서 비디오",
          "desc": "텍스트-비디오 및 이미지-비디오 모드를 모두 지원하며, 5초 또는 8초 지속 시간 옵션 제공."
        },
        {
          "icon": "⚡",
          "title": "안정적이고 신뢰할 수 있음",
          "desc": "철저히 테스트된 클래식 모델로 안정적이고 신뢰할 수 있는 결과 제공."
        },
        {
          "icon": "💰",
          "title": "탁월한 가치",
          "desc": "낮은 크레딧 소비로 대량 콘텐츠 제작 및 테스트에 적합."
        },
        {
          "icon": "📐",
          "title": "종횡비 선택",
          "desc": "16:9 및 9:16 두 가지 종횡비를 지원하여 다양한 시나리오 요구 충족."
        },
        {
          "icon": "🎥",
          "title": "720p 해상도",
          "desc": "720p 해상도 출력 제공으로 대부분의 애플리케이션 시나리오에 적합."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "완 2.2와 완 2.5의 차이점은 무엇인가요?",
          "a": "완 2.2는 클래식 모델로 크레딧 소비가 낮아 품질 요구 사항이 높지 않지만 대량 생성이 필요한 시나리오에 적합합니다. 완 2.5는 더 많은 기능을 지원하는 업데이트 버전입니다."
        },
        {
          "q": "완 2.2는 어떻게 작동하나요?",
          "a": "참조 이미지를 업로드하거나 텍스트 설명을 직접 입력하면 완 2.2 모델이 지시 사항을 기반으로 고품질 비디오 콘텐츠를 생성합니다."
        },
        {
          "q": "생성된 비디오를 상업적으로 사용할 수 있나요?",
          "a": "네, 완 2.2를 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "wan25": {
      "title": "완 2.5 AI 비디오 생성기",
      "desc": "완 2.5는 텍스트-비디오 및 이미지-비디오를 지원하는 다재다능한 AI 비디오 모델로, 우수한 품질과 속도를 제공합니다.",
      "features": [
        {
          "icon": "🎬",
          "title": "고품질 출력",
          "desc": "텍스트 또는 이미지에서 전문적인 품질의 비디오를 생성합니다."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "효율적인 워크플로우를 위한 빠른 비디오 생산."
        },
        {
          "icon": "📱",
          "title": "다양한 형식",
          "desc": "다양한 종횡비와 해상도 지원."
        },
        {
          "icon": "🖼️",
          "title": "이미지 애니메이션",
          "desc": "AI 모션으로 정적 이미지를 생동감 있게 만듭니다."
        },
        {
          "icon": "🎥",
          "title": "부드러운 모션",
          "desc": "생성된 비디오에서 자연스럽고 유창한 모션."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "완 2.5는 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력하거나 참조 이미지를 업로드하면 완 2.5가 지시 사항을 기반으로 고품질 비디오 콘텐츠를 생성합니다."
        },
        {
          "q": "완 2.5와 완 2.6의 차이점은 무엇인가요?",
          "a": "완 2.6은 품질과 안정성에서 추가적인 개선을 제공하며, 완 2.5는 대부분의 사용 사례에 적합한 비용 효율적인 옵션입니다."
        },
        {
          "q": "각 생성에는 몇 크레딧이 소요되나요?",
          "a": "완 2.5는 생성당 60 크레딧이 소요됩니다."
        },
        {
          "q": "생성된 비디오를 상업적으로 사용할 수 있나요?",
          "a": "네, 완 2.5를 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "wan26": {
      "title": "완 2.6 AI 비디오 생성기",
      "desc": "완 2.6은 품질과 안정성이 향상된 고급 AI 비디오 모델로, 텍스트-비디오 및 이미지-비디오를 지원합니다.",
      "features": [
        {
          "icon": "🎬",
          "title": "고품질 출력",
          "desc": "텍스트 또는 이미지에서 향상된 품질의 전문적인 품질 비디오를 생성합니다."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "효율적인 워크플로우를 위한 빠른 비디오 생산."
        },
        {
          "icon": "📱",
          "title": "다양한 형식",
          "desc": "다양한 종횡비와 해상도 지원."
        },
        {
          "icon": "🖼️",
          "title": "이미지 애니메이션",
          "desc": "AI 모션으로 정적 이미지를 생동감 있게 만듭니다."
        },
        {
          "icon": "🎥",
          "title": "부드러운 모션",
          "desc": "생성된 비디오에서 자연스럽고 유창한 모션."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "완 2.6과 완 2.5의 차이점은 무엇인가요?",
          "a": "완 2.6은 더 높은 품질의 출력을 위해 품질과 안정성에서 추가적인 개선을 제공합니다."
        },
        {
          "q": "완 2.6은 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력하거나 참조 이미지를 업로드하면 완 2.6이 지시 사항을 기반으로 고품질 비디오 콘텐츠를 생성합니다."
        },
        {
          "q": "각 생성에는 몇 크레딧이 소요되나요?",
          "a": "완 2.6은 생성당 70 크레딧이 소요됩니다."
        },
        {
          "q": "생성된 비디오를 상업적으로 사용할 수 있나요?",
          "a": "네, 완 2.6을 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "kling25": {
      "title": "클링 2.5 AI 비디오 생성기",
      "desc": "클링 2.5는 텍스트-비디오 및 이미지-비디오를 지원하는 표준 AI 비디오 모델로, 안정적이고 신뢰할 수 있는 비디오 생성을 제공하며 가격 대비 성능이 우수합니다.",
      "standard": "표준",
      "reliable": "안정적이고 신뢰할 수 있음",
      "costEffective": "가격 대비 성능 우수",
      "standardQuality": "표준 품질",
      "textToVideo": "텍스트에서 비디오",
      "imageToVideo": "이미지에서 비디오",
      "referenceImage": "참조 이미지",
      "referenceImageHint": "클릭하여 업로드하거나 파일을 드래그 앤 드롭",
      "referenceImageFormats": "PNG, JPG, JPEG, WEBP 형식 지원 (≤10MB), URL 업로드만",
      "endFrame": "엔드 프레임",
      "endFrameOptional": "선택 사항",
      "endFrameFormats": "PNG, JPG, JPEG",
      "endFrameHint": "비디오 끝 프레임을 제한하는 데 사용, 참조 이미지와 동일한 종횡비에서 더 나은 효과",
      "videoPrompt": "비디오 프롬프트",
      "promptPlaceholder": "생성하려는 비디오를 설명하세요...",
      "negativePrompt": "네거티브 프롬프트",
      "negativePromptPlaceholder": "비디오에 포함하지 않을 내용을 설명하세요...",
      "duration": "지속 시간",
      "aspectRatio": "종횡비",
      "uploading": "업로드 중...",
      "clickToUpload": "클릭하여 업로드",
      "clickToUploadReference": "클릭하여 참조 이미지 업로드",
      "clickToUploadEndFrame": "클릭하여 엔드 프레임 이미지 업로드",
      "remove": "삭제",
      "creditsRequired": "필요 크레딧:",
      "remaining": "남은 크레딧:",
      "generate": "생성",
      "generating": "생성 중...",
      "demoPrompt": "데모 프롬프트",
      "demoPromptExample": "업로드한 SF 골목 이미지를 첫 프레임으로 사용합니다. 같은 골목, 네온 간판, 반사, 후드를 쓴 여성이 멀어지는 모습을 유지하고 카메라를 천천히 골목 안으로 전진시킵니다...",
      "model": "모델:",
      "durationLabel": "지속 시간:",
      "introTitle": "클링 2.5 표준으로 고품질 AI 비디오 생성",
      "featuresBadge": "핵심 기능",
      "featuresTitle": "{name}으로 할 수 있는 것",
      "faqTitle": "자주 묻는 질문",
      "errorPromptRequired": "프롬프트를 입력하세요",
      "errorImageRequired": "이미지-비디오 모드에서는 참조 이미지 업로드가 필요합니다",
      "errorGenerationFailed": "생성 실패",
      "errorRequestFailed": "요청 실패",
      "errorUploadFailed": "업로드 실패, 다시 시도하세요",
      "features": [
        {
          "icon": "🎬",
          "title": "텍스트/이미지에서 비디오",
          "desc": "텍스트-비디오 및 이미지-비디오 모드를 모두 지원하며, 5초 또는 10초 지속 시간 옵션 제공."
        },
        {
          "icon": "⚡",
          "title": "안정적이고 신뢰할 수 있음",
          "desc": "철저히 테스트된 표준 모델로 안정적이고 신뢰할 수 있는 결과 제공."
        },
        {
          "icon": "💰",
          "title": "탁월한 가치",
          "desc": "클링 2.6에 비해 낮은 크레딧 소비로 대량 콘텐츠 제작에 적합."
        },
        {
          "icon": "📐",
          "title": "다양한 종횡비",
          "desc": "1:1, 16:9, 9:16 종횡비를 지원하여 다양한 시나리오 요구 충족."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "클링 2.5와 클링 2.6의 차이점은 무엇인가요?",
          "a": "클링 2.5는 표준 모델로 크레딧 소비가 낮아 품질 요구 사항이 높지 않지만 대량 생성이 필요한 시나리오에 적합합니다. 클링 2.6은 네이티브 오디오와 완벽한 립 싱크를 지원하는 최신 버전입니다."
        },
        {
          "q": "클링 2.5는 어떻게 작동하나요?",
          "a": "참조 이미지를 업로드하거나 텍스트 설명을 직접 입력하면 클링 2.5 모델이 지시 사항을 기반으로 고품질 비디오 콘텐츠를 생성합니다."
        },
        {
          "q": "생성된 비디오를 상업적으로 사용할 수 있나요?",
          "a": "네, 클링 2.5를 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    },
    "viduq3pro": {
      "title": "Vidu Q3 Pro AI 비디오",
      "desc": "Vidu Q3 Pro: 텍스트·이미지 기반 비디오, 해상도, 1~16초, 화면비, 오디오 옵션.",
      "imageUrlHint": "HTTPS 이미지 URL만 허용(업로드 시 공개 URL). 이미지 화면비는 1:4~4:1 범위여야 합니다.",
      "lengthLabel": "길이(초)",
      "optional": "선택",
      "tagHighQuality": "고품질",
      "tagLength": "1~16초",
      "tagResolution": "최대 2K",
      "demoPromptExample": "해질녘 산책로, 조깅하는 사람들, 바다 위 갈매기, 멀리 요트.",
      "features": [
        { "icon": "🎬", "title": "텍스트·이미지", "desc": "프롬프트 또는 참조 이미지로 생성." },
        { "icon": "📐", "title": "화면비", "desc": "텍스트 모드: 16:9, 9:16, 1:1, 4:3, 3:4." },
        { "icon": "⏱️", "title": "길이 선택", "desc": "1~16초." },
        { "icon": "🎵", "title": "오디오", "desc": "자연스러운 오디오 생성 가능." },
        { "icon": "🎲", "title": "시드", "desc": "선택 시드로 재현성 향상." }
      ],
      "faq": [
        { "q": "이미지→비디오 요구사항은?", "a": "공개 HTTPS 이미지 URL(JPG/PNG). 화면비는 1:4 또는 4:1보다 극단적이면 안 됩니다." },
        { "q": "텍스트와 이미지 모드 차이?", "a": "텍스트는 화면비 지정. 이미지는 참조 URL 사용, 텍스트용 화면비는 전송하지 않습니다." },
        { "q": "크레딧은?", "a": "페이지 표시 규칙에 따라 길이·해상도·오디오에 따라 계산됩니다." }
      ]
    },
    "hailuo": {
      "title": "Hailuo 2.3 AI 비디오 생성기",
      "desc": "Hailuo 2.3은 차세대 AI 비디오 모델로, 고품질 텍스트-비디오 생성을 지원하고 창의적인 비디오 솔루션을 제공합니다.",
      "demoPromptExample": "영화적 샷: 노을이 지는 바위 해변에 부서지는 파도, 물결에 비치는 황금빛...",
      "highQuality": "고품질",
      "highQualityOutput": "고품질 출력",
      "features": [
        {
          "icon": "🎬",
          "title": "텍스트-비디오",
          "desc": "텍스트 설명을 입력하면 고품질 비디오를 생성할 수 있으며, 길이는 6초 또는 10초를 선택할 수 있습니다."
        },
        {
          "icon": "✨",
          "title": "프롬프트 향상",
          "desc": "프롬프트 최적화 및 안전 검사를 활성화하여 더 나은 생성 결과를 얻을 수 있도록 프롬프트를 자동으로 최적화합니다."
        },
        {
          "icon": "🌊",
          "title": "창의적 스타일",
          "desc": "창의적이고 예술적인 비디오 콘텐츠 생성에 능숙합니다."
        },
        {
          "icon": "⚡",
          "title": "빠른 생성",
          "desc": "최적화된 추론 엔진이 빠른 출력을 보장합니다."
        },
        {
          "icon": "🎨",
          "title": "고품질 출력",
          "desc": "다양한 애플리케이션에 적합한 고품질 비디오 콘텐츠를 생성합니다."
        },
        {
          "icon": "💼",
          "title": "상업 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "Hailuo 2.3은 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력하면 Hailuo 2.3 모델이 지시사항에 따라 고품질 비디오 콘텐츠를 생성합니다."
        },
        {
          "q": "프롬프트 향상이란 무엇인가요?",
          "a": "프롬프트 향상 기능은 프롬프트를 자동으로 최적화하고 안전 검사를 수행하여 생성된 콘텐츠가 지침을 준수하는지 확인합니다."
        },
        {
          "q": "생성된 비디오를 상업적 용도로 사용할 수 있나요?",
          "a": "네, Hailuo 2.3을 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        },
        {
          "q": "각 생성에 필요한 크레딧은?",
          "a": "Hailuo 2.3을 사용하면 생성당 12 크레딧을 소비합니다."
        }
      ]
    },
    "wanAnimate": {
      "title": "Wan Animate",
      "desc": "참조 이미지와 동영상으로 캐릭터 애니메이션. 표준/프로 품질, 선택적 워터마크.",
      "refImageLabel": "참조 이미지",
      "refImageHint": "애니메이션할 캐릭터(JPG/PNG/JPEG/BMP/WEBP, 최대 5MB, 변 200~4096px, 비율 1:3~3:1).",
      "refVideoLabel": "참조 동영상",
      "refVideoHint": "모션 참조(MP4/AVI/MOV, 2~30초, 최대 200MB, 변 200~2048px, 비율 1:3~3:1).",
      "animateModeLabel": "애니메이션 모드",
      "modeAnimate": "이미지 동작 생성",
      "modeReplace": "영상 인물 교체",
      "referenceVideo": "참고 동영상",
      "btnAnimate": "애니메이션",
      "animateModeBadgeAnimate": "모션",
      "animateModeBadgeReplace": "교체",
      "btnAnimateDesc": "이미지 캐릭터에 동영상의 움직임을 결합합니다.",
      "btnReplace": "교체",
      "btnReplaceDesc": "동영상 속 캐릭터를 이미지 캐릭터로 바꿉니다.",
      "qualityLabel": "화질 모드",
      "qualityStd": "표준",
      "qualityPro": "프로",
      "watermarkLabel": "워터마크",
      "uploadVideoRequired": "참조 동영상을 업로드하세요.",
      "uploadImage": "이미지 업로드",
      "uploadVideo": "동영상 업로드",
      "uploading": "업로드 중…",
      "imageUploadHint": "JPG, PNG, JPEG, BMP, WEBP · 최대 5MB",
      "videoUploadHint": "MP4, AVI, MOV · 2~30초 · 최대 200MB",
      "uploadImageRequired": "참조 이미지를 업로드하세요.",
      "errImageFileTooLarge": "이미지 크기가 한도(최대 5MB)를 초과했습니다.",
      "errImageDimensions": "이미지 가로·세로는 200~4096px이어야 합니다.",
      "errImageAspect": "이미지 비율은 1:3~3:1이어야 합니다.",
      "errImageInvalid": "이미지가 유효하지 않거나 읽을 수 없습니다.",
      "errVideoFileTooLarge": "동영상 크기가 한도(최대 200MB)를 초과했습니다.",
      "errVideoDuration": "동영상 길이는 2~30초여야 합니다.",
      "errVideoDimensions": "동영상 가로·세로는 200~2048px이어야 합니다.",
      "errVideoAspect": "동영상 비율은 1:3~3:1이어야 합니다.",
      "errVideoInvalid": "동영상이 유효하지 않거나 읽을 수 없습니다.",
      "defaultModelName": "Wan Animate",
      "demoEmptyHint": "캐릭터 이미지와 모션 동영상을 업로드하고 Wan Animate로 멋진 캐릭터 애니메이션을 만들어 보세요.",
      "demoEmptyTitle": "캐릭터 애니메이션",
      "demoStepCharacter": "캐릭터",
      "demoStepMotion": "모션",
      "demoStepAnimate": "애니메이션",
      "faqCredits": "프로 모드는 표준보다 크레딧을 더 사용합니다. 상단 참고.",
      "characterAnimation": "캐릭터 애니메이션",
      "faceSwap": "페이스 스왑",
      "motionTransfer": "모션 전송",
      "identityReplacement": "신원 교체",
      "motionAccuracy": "높은 모션 재현",
      "features": [
        { "icon": "🎭", "title": "두 가지 모드", "desc": "모션 이전 또는 캐릭터 전체 교체." },
        { "icon": "📐", "title": "DashScope 공식", "desc": "Alibaba Cloud Wan 2.2 Animate." },
        { "icon": "⚡", "title": "표준/프로", "desc": "작업마다 품질 선택." },
        { "icon": "💧", "title": "워터마크 옵션", "desc": "출력에 워터마크 적용 여부." }
      ],
      "faq": [
        { "q": "필요한 입력은?", "a": "업로드 후 공개 HTTPS 이미지·동영상 URL이 필요합니다. 형식·크기·비율 제한을 따르세요." },
        { "q": "애니메이션과 교체의 차이?", "a": "애니메이션은 동영상 모션을 이미지 캐릭터에 적용합니다. 교체는 동영상 속 캐릭터를 이미지 캐릭터로 바꿉니다." },
        { "q": "크레딧은?", "a": "프로가 표준보다 비쌉니다. 페이지 표시 기준." }
      ]
    },
    "runway": {
      "title": "런웨이 AI 비디오 생성기",
      "desc": "런웨이는 다양한 비디오 품질, 종횡비 및 워터마크 설정을 지원하는 전문가급 AI 비디오 생성 도구로, 전문 콘텐츠 크리에이터에게 적합합니다.",
      "demoPromptExample": "해질녘, 싱가포르 건설 현장의 크레인 실루엣이 화려한 노을을 배경으로 드리워진다. 안전모를 쓴 노동자들이 도구를 정리하며 퇴근 준비를 한다...",
      "professional": "전문가급",
      "multiOption": "다양한 옵션",
      "highQuality": "고품질",
      "multiFormat": "다양한 종횡비",
      "reproducibleSeed": "재현 가능한 시드",
      "features": [
        {
          "icon": "🎬",
          "title": "텍스트/이미지에서 비디오",
          "desc": "텍스트-비디오 및 이미지-비디오 모두 지원하며, 5초 또는 10초 지속 시간 옵션 제공."
        },
        {
          "icon": "📐",
          "title": "다양한 종횡비",
          "desc": "다양한 시나리오를 위해 16:9, 9:16, 1:1, 4:3, 3:4, 21:9 종횡비 지원."
        },
        {
          "icon": "🎲",
          "title": "제어 가능한 시드",
          "desc": "동일한 비디오 효과를 재현하기 위한 랜덤 시드 설정 지원."
        },
        {
          "icon": "⚡",
          "title": "전문적 출력",
          "desc": "상업적 사용에 적합한 전문 품질의 비디오 콘텐츠 생성."
        },
        {
          "icon": "🖼️",
          "title": "이미지 애니메이션",
          "desc": "AI 모션으로 정적 이미지를 생동감 있게 만듭니다."
        },
        {
          "icon": "💼",
          "title": "상업적 라이선스",
          "desc": "생성된 모든 비디오는 상업적 용도로 사용할 수 있습니다."
        }
      ],
      "faq": [
        {
          "q": "런웨이는 어떻게 작동하나요?",
          "a": "텍스트 설명을 입력하거나 참조 이미지를 업로드하면 런웨이가 지시 사항을 기반으로 고품질 비디오 콘텐츠를 생성합니다."
        },
        {
          "q": "어떤 종횡비를 지원하나요?",
          "a": "런웨이는 16:9(가로), 9:16(세로), 1:1(정사각형), 4:3, 3:4, 21:9 등 5가지 종횡비를 지원합니다."
        },
        {
          "q": "생성된 비디오를 상업적으로 사용할 수 있나요?",
          "a": "네, 런웨이를 사용하여 생성된 모든 콘텐츠는 상업적 용도로 사용할 수 있습니다."
        }
      ]
    }
  },
  "privacy": {
    "title": "개인정보 보호정책",
    "lastUpdated": "마지막 업데이트: 2025년 1월 15일",
    "navTerms": "서비스 이용 약관 →",
    "navTrust": "신뢰 및 안전 →",
    "sections": [
      {
        "title": "1. 정보 수집",
        "paragraphs": [
          "등록 및 서비스 사용 시 제공하는 이메일 주소, 사용자 이름 및 결제 정보를 포함하여 정보를 수집합니다.",
          "IP 주소, 브라우저 유형, 접속 시간 및 사용 기능과 같은 사용 데이터를 자동으로 수집합니다."
        ]
      },
      {
        "title": "2. 정보 사용",
        "paragraphs": [
          "수집한 정보를 서비스 제공, 유지 및 개선, 거래 처리, 서비스 관련 알림 전송, 사기 및 남용 방지를 위해 사용합니다.",
          "귀하의 개인 정보를 제3자에게 판매하지 않습니다."
        ]
      },
      {
        "title": "3. AI 생성 콘텐츠",
        "paragraphs": [
          "업로드한 이미지와 입력한 프롬프트는 요청한 콘텐츠 생성에만 사용되며 AI 모델 학습에는 사용되지 않습니다.",
          "생성된 콘텐츠는 귀하가 다운로드할 수 있도록 서버에 일시적으로 저장된 후 데이터 보존 정책에 따라 삭제됩니다."
        ]
      },
      {
        "title": "4. 데이터 보안",
        "paragraphs": [
          "SSL 암호화, 접근 제어 및 정기적인 보안 감사를 포함한 업계 표준 보안 조치를 채택하여 귀하의 개인 정보를 보호합니다.",
          "데이터를 보호하기 위해 최선을 다하지만 인터넷 전송 방법은 100% 안전하지 않습니다."
        ]
      },
      {
        "title": "5. 쿠키 사용",
        "paragraphs": [
          "사용자 경험 개선, 사용 분석 및 개인화된 콘텐츠 제공을 위해 쿠키 및 유사한 기술을 사용합니다.",
          "브라우저 설정을 통해 쿠키 기본 설정을 관리할 수 있습니다. 쿠키를 비활성화하면 특정 기능에 영향을 줄 수 있습니다."
        ]
      },
      {
        "title": "6. 제3자 서비스",
        "paragraphs": [
          "결제 처리, 데이터 분석 및 고객 지원과 같은 서비스 제공을 위해 제3자 서비스 제공업체를 사용할 수 있습니다.",
          "이러한 제3자 서비스 제공업체는 귀하를 위해 서비스를 수행하는 데 필요한 범위 내에서만 귀하의 개인 정보에 접근합니다."
        ]
      },
      {
        "title": "7. 귀하의 권리",
        "paragraphs": [
          "귀하는 귀하의 개인 정보에 접근, 수정 또는 삭제할 권리가 있습니다. 또한 귀하의 데이터 처리를 제한하거나 다른 서비스로 데이터를 전송할 것을 요청할 권리도 있습니다.",
          "이러한 권리를 행사하려면 miral_support@miralvis.com로 문의하십시오. 요청에 30일 이내에 응답하겠습니다."
        ]
      },
      {
        "title": "8. GDPR 규정 준수",
        "paragraphs": [
          "유럽 경제 지역의 사용자의 경우, 일반 데이터 보호 규정(GDPR)의 요구 사항을 준수합니다. 귀하의 데이터 처리에 대한 법적 근거에는 계약 이행, 정당한 이익 및 귀하의 동의가 포함됩니다."
        ]
      },
      {
        "title": "9. 문의하기",
        "paragraphs": [
          "개인정보 보호정책에 대해 궁금한 점이나 우려 사항이 있으면 miral_support@miralvis.com로 데이터 보호 팀에 문의하십시오."
        ]
      }
    ]
  },
  "terms": {
    "title": "서비스 이용 약관",
    "lastUpdated": "마지막 업데이트: 2025년 1월 15일",
    "navPrivacy": "개인정보 보호정책 →",
    "navTrust": "신뢰 및 안전 →",
    "sections": [
      {
        "title": "1. 서비스 개요",
        "paragraphs": [
          "Miral(이하 \"플랫폼\")은 이미지, 비디오 및 음악 생성을 통합한 AI 플랫폼입니다. 본 이용 약관(이하 \"약관\")은 플랫폼 사용 조건 및 규칙을 규정합니다.",
          "플랫폼을 사용함으로써 귀하는 본 약관에 구속됨에 동의합니다. 본 약관에 동의하지 않으면 플랫폼을 사용하지 마십시오."
        ]
      },
      {
        "title": "2. 계정 등록",
        "paragraphs": [
          "계정을 등록하려면 최소 18세 이상이어야 합니다. 정확하고 완전한 등록 정보를 제공해야 하며 계정 보안을 유지할 책임이 있습니다.",
          "귀하의 계정을 통해 수행된 모든 활동에 대해 귀하는 책임이 있습니다. 무단 사용을 발견하면 즉시 저희에게 알려주십시오."
        ]
      },
      {
        "title": "3. 서비스 사용",
        "paragraphs": [
          "플랫폼은 크레딧 기반의 AI 콘텐츠 생성 서비스를 제공합니다. 크레딧은 구독 또는 일회성 구매를 통해 얻을 수 있습니다. 다양한 AI 모델 및 기능은 서로 다른 크레딧을 소비합니다.",
          "귀하는 플랫폼을 불법적, 유해하거나 권리 침해 목적에 사용하지 않을 것에 동의합니다. 불법, 음란, 폭력 또는 권리 침해 콘텐츠 생성은 금지되어 있습니다."
        ]
      },
      {
        "title": "4. 지적 재산권",
        "paragraphs": [
          "플랫폼을 통해 생성한 콘텐츠의 지적 재산권은 각 AI 모델 제공자의 이용 약관에 따라 귀하에게 속합니다.",
          "플랫폼의 상표, 로고, 인터페이스 설계 및 소프트웨어 코드는 지적 재산권 법률에 의해 보호되며 무단 사용할 수 없습니다."
        ]
      },
      {
        "title": "5. 결제 및 환불",
        "paragraphs": [
          "모든 결제는 미국 달러로 이루어집니다. 구독료는 선택한 플랜에 따라 월간 또는 연간으로 청구됩니다.",
          "일회성 팩 또는 첫 구독의 첫 구매의 경우, 크레딧 사용률이 3% 미만일 경우 7일 이내에 환불을 요청할 수 있습니다."
        ]
      },
      {
        "title": "6. 면책 조항",
        "paragraphs": [
          "플랫폼은 \"있는 그대로\" 서비스를 제공하며 서비스의 가용성, 정확성 또는 적합성에 대한 명시적 또는 묵시적 보증을 하지 않습니다.",
          "AI 생성 콘텐츠는 부정확하거나 불완전할 수 있습니다. 사용자는 생성된 콘텐츠의 적합성을 스스로 판단해야 합니다."
        ]
      },
      {
        "title": "7. 책임 제한",
        "paragraphs": [
          "법이 허용하는 최대한도로, 플랫폼은 서비스 사용 또는 사용 불가능으로 인한 직접적, 간접적, 부수적 또는 결과적 손해에 대해 책임을 지지 않습니다.",
          "플랫폼의 총 책임은 귀하가 지난 12개월 동안 지불한 총 수수료를 초과하지 않습니다."
        ]
      },
      {
        "title": "8. 약관 수정",
        "paragraphs": [
          "우리는 언제든지 본 약관을 수정할 권리가 있습니다. 수정된 약관은 본 페이지에 게시될 때 효력을 발생합니다.",
          "플랫폼의 지속적인 사용은 수정된 약관 수용을 의미합니다. 중요한 변경 사항은 이메일 또는 플랫폼 알림을 통해 알릴 것입니다."
        ]
      },
      {
        "title": "9. 문의하기",
        "paragraphs": [
          "본 약관에 대해 질문이 있으시면 miral_support@miralvis.com로 문의하십시오."
        ]
      }
    ]
  },
  "trustSafety": {
    "tag": "🛡️ 신뢰 및 안전",
    "title": "귀하의 데이터 보안이 우리의 최우선 순위입니다",
    "subtitle": "우리가 귀하의 개인정보와 데이터 보안을 어떻게 보호하는지 알아보세요.",
    "badges": [
      {
        "icon": "🛡️",
        "title": "AI 학습 없음",
        "desc": "업로드한 콘텐츠와 생성된 작품은 AI 모델 학습에 사용되지 않습니다."
      },
      {
        "icon": "🔒",
        "title": "엔드 투 엔드 암호화",
        "desc": "모든 데이터 전송은 TLS 1.3 암호화를 사용하며, 저장된 데이터는 AES-256 암호화를 사용합니다."
      },
      {
        "icon": "✓",
        "title": "GDPR 규정 준수",
        "desc": "EU 일반 데이터 보호 규정 요구 사항을 완전히 준수합니다."
      },
      {
        "icon": "🗑️",
        "title": "자가 데이터 제어",
        "desc": "귀하는 언제든지 모든 데이터를 내보내거나 삭제할 수 있으며, 계정 삭제도 포함됩니다."
      }
    ],
    "sections": [
      {
        "title": "데이터 처리 투명성",
        "paragraphs": [
          "우리는 데이터 처리 방식에 대해 완전히 투명합니다. 귀하가 업로드한 이미지와 비디오는 요청한 콘텐츠 생성에만 사용되며 처리 후 24시간 이내에 서버에서 삭제됩니다.",
          "생성된 콘텐츠는 귀하의 계정에 저장되며, 언제든지 다운로드하거나 삭제할 수 있습니다. 귀하의 동의 없이 콘텐츠를 공유하지 않습니다."
        ]
      },
      {
        "title": "보안 인프라",
        "paragraphs": [
          "우리 서비스는 다중 계층 보안 보호가 있는 세계적 수준의 클라우드 인프라에 배포됩니다. 모든 서버는 SOC 2 및 ISO 27001 인증 데이터 센터에 위치합니다.",
          "우리는 시스템 보안을 보장하기 위해 정기적인 보안 감사 및 침투 테스트를 수행합니다. 모든 직원은 엄격한 보안 교육을 받습니다."
        ]
      },
      {
        "title": "콘텐츠 안전",
        "paragraphs": [
          "우리는 유해한 콘텐츠 생성을 자동으로 감지하고 차단하는 고급 콘텐츠 안전 시스템을 배포합니다. 여기에는 폭력, 음란, 권리 침해 콘텐츠가 포함됩니다.",
          "위반 콘텐츠를 발견하면 abuse@miral.org로 신고해 주십시오."
        ]
      },
      {
        "title": "규정 준수 및 인증",
        "paragraphs": [
          "우리는 GDPR(EU), CCPA(캘리포니아), LGPD(브라질)를 포함한 주요 글로벌 데이터 보호 규정을 준수합니다.",
          "우리 결제 처리는 PCI DSS 표준을 준수하여 귀하의 결제 정보가 안전하다는 것을 보장합니다."
        ]
      }
    ],
    "ctaTitle": "보안 우려 사항이 있나요?",
    "ctaDesc": "우리 보안 팀은 귀하의 질문에 답변할 준비가 되어 있습니다",
    "ctaButton": "보안 팀 문의",
    "navTerms": "서비스 이용 약관 →",
    "navPrivacy": "개인정보 보호정책 →"
  },
  "gallery": {
    "tag": "내 창작물",
    "title": "창작 기록",
    "subtitle": "이미지 및 비디오 생성 기록을 포함한 모든 AI 창작 기록을 확인하세요.",
    "loadMore": "더 불러오기",
    "loginRequired": "창작 기록을 보려면 로그인해주세요",
    "empty": "아직 창작 기록이 없습니다. 지금 바로 창작을 시작하세요!",
    "filters": {
      "all": "모두",
      "pending": "처리 중",
      "finish": "완료됨",
      "failed": "실패"
    },
    "status": {
      "pending": "처리 중",
      "finish": "완료됨",
      "failed": "실패"
    },
    "usePrompt": "이 프롬프트로 생성",
    "download": "다운로드"
  },
  "watermarkRemover": {
    "breadcrumb": {
      "home": "홈"
    },
    "tag": "AI 도구",
    "title": "이미지 워터마크 제거",
    "subtitle": "이미지에서 워터마크를 지능적으로 감지하고 제거하며 원본 품질 유지",
    "uploadText": "클릭하거나 드래그하여 이미지 업로드",
    "uploadHint": "JPG, PNG, BMP, WEBP 형식 지원, 최대 50MB",
    "keepAlphaChannel": "알파 채널 유지",
    "keepAlphaChannelDesc": "활성화하면 결과 이미지의 알파 채널 정보를 유지합니다",
    "removeWatermark": "워터마크 제거",
    "processing": "처리 중...",
    "result": "처리 결과",
    "download": "결과 다운로드",
    "newImage": "새 이미지 처리",
    "watermarkDetected": "워터마크 감지됨",
    "noWatermark": "워터마크 없음",
    "before": "처리 전",
    "after": "처리 후",
    "emptyText": "이미지를 업로드하여 워터마크 제거 시작",
    "invalidFormat": "유효한 이미지 파일을 업로드하세요",
    "fileTooLarge": "파일 크기는 50MB를 초과할 수 없습니다",
    "processFailed": "처리 실패, 다시 시도하세요",
    "features": {
      "title": "기능",
      "ai": {
        "title": "AI 감지",
        "desc": "워터마크 위치와 유형 자동 감지"
      },
      "fast": {
        "title": "빠른 처리",
        "desc": "효율적인 알고리즘으로 빠른 워터마크 제거"
      },
      "formats": {
        "title": "다중 형식 지원",
        "desc": "JPG, PNG, BMP, WEBP 등 지원"
      },
      "quality": {
        "title": "품질 유지",
        "desc": "원본 이미지 품질 유지, 무손실 제거"
      }
    }
  },
  "profile": {
    "joinTime": "가입일",
    "tabs": {
      "account": "계정",
      "billing": "결제",
      "privacy": "데이터 및 개인정보"
    },
    "balance": {
      "title": "잔액 개요",
      "available": "사용 가능 크레딧"
    },
    "subscription": {
      "currentPlan": "현재 플랜",
      "status": "상태",
      "activated": "활성화됨",
      "cancelled": "현재 기간 종료 시 취소됨",
      "pending": "처리 중",
      "failed": "결제 실패",
      "expiryDate": "유효 기간",
      "permanent": "영구",
      "upgradePlan": "플랜 업그레이드 또는 변경",
      "cancelPlan": "구독 취소",
      "cancelNote": "귀하의 구독은 현재 청구 기간이 끝날 때까지 활성화 상태를 유지합니다",
      "cancelWarning": "귀하의 구독이 취소됩니다. 다음까지 모든 기능을 계속 사용할 수 있습니다",
      "restorePlan": "구독 재개"
    },
    "upgrade": {
      "title": "업그레이드",
      "desc": "무제한 접근 및 독점 혜택을 얻으세요",
      "btn": "플랜 보기"
    },
    "billing": {
      "title": "결제 기록",
      "subtitle": "결제 기록 보기 및 송장 다운로드",
      "empty": "아직 결제 기록 없음",
      "creditsPack": "크레딧 팩",
      "oneTime": "일회성",
      "monthly": "월간",
      "yearly": "연간",
      "refresh": "새로고침",
      "plan": "플랜",
      "date": "날짜",
      "amount": "금액",
      "invoice": "송장",
      "download": "다운로드",
      "invoiceModal": {
        "title": "송장 세부 정보",
        "orderInfo": "주문 정보",
        "invoiceInfo": "송장 정보",
        "plan": "플랜",
        "date": "결제 날짜",
        "amount": "금액",
        "paymentId": "주문 ID",
        "close": "닫기",
        "download": "송장 다운로드",
        "fullName": "성명",
        "fullNamePlaceholder": "성명 입력",
        "email": "이메일",
        "emailPlaceholder": "이메일 입력",
        "company": "회사",
        "companyPlaceholder": "회사 법적 이름",
        "taxId": "사업자 등록 번호",
        "taxIdPlaceholder": "사업자 등록 번호 입력",
        "addressLine1": "주소 1",
        "addressLine1Placeholder": "도로 주소",
        "addressLine2": "주소 2",
        "addressLine2Placeholder": "아파트, 스위트 등(선택 사항)",
        "city": "도시",
        "cityPlaceholder": "도시",
        "province": "도/시",
        "provincePlaceholder": "도/시",
        "postalCode": "우편 번호",
        "postalCodePlaceholder": "우편 번호",
        "country": "국가",
        "countryPlaceholder": "국가",
        "invoiceRemarks": "비고",
        "invoiceRemarksPlaceholder": "송장 비고",
        "optional": "선택 사항",
        "required": "이 필드는 필수입니다"
      }
    },
    "privacy": {
      "title": "개인정보 설정",
      "cardTitle": "귀하의 데이터는 보호됩니다",
      "cardSubtitle": "귀하의 데이터 개인정보 보호 및 보안에 대한 우리의 약속",
      "item1": "귀하의 데이터는 AI 모델 학습에 사용되지 않습니다",
      "item2": "데이터 전송 및 저장은 완전히 암호화됩니다",
      "item3": "생성된 작품은 저장 기간 후 자동 삭제됩니다",
      "item4": "피드백 루프 없음, 파생 데이터의 2차 사용 없음",
      "item5": "데이터 보호 규정 엄격 준수"
    },
    "support": {
      "title": "도움이 필요하신가요?",
      "desc": "우리 지원팀이 도와드리겠습니다",
      "btn": "지원 문의",
      "note": "miral_support@miralvis.com · 24시간 이내 응답"
    }
  },
  "payment": {
    "success": {
      "title": "결제 성공",
      "message": "구매해 주셔서 감사합니다! 귀하의 주문이 성공적으로 처리되었으며 크레딧이 귀하의 계정에 추가되었습니다.",
      "goHome": "홈으로 이동",
      "viewProfile": "프로필 보기"
    },
    "cancel": {
      "title": "결제 취소",
      "message": "귀하의 결제가 취소되었습니다. 질문이 있으시면 언제든지 지원팀에 문의해 주십시오.",
      "tryAgain": "다시 시도",
      "goHome": "홈으로 이동"
    }
  },
  "inspiration": {
    "title": "Inspiration",
    "subtitle": "See what creators are building with Miral — from hyper-realistic images to cinematic videos, inspiration at your fingertips.",
    "filters": {
      "all": "All",
      "image": "Image",
      "video": "Video",
      "portrait": "Portrait",
      "landscape": "Landscape",
      "fantasy": "Fantasy",
      "anime": "Anime"
    },
  },
  "seo": {
    "default": {
      "title": "Miral - AI 이미지, 동영상 및 음악 생성 플랫폼",
      "description": "Miral은 Seedream 4, Midjourney, GPT Image, Veo 3, Sora 2 등 최고 AI 모델을 지원하는 올인원 AI 창작 플랫폼입니다.",
      "keywords": "AI 이미지 생성, AI 동영상 생성, AI 음악 생성, 텍스트 이미지, 텍스트 동영상, Seedream, Midjourney, Veo, Sora, Miral"
    },
    "home": { "title": "Miral AI 이미지·동영상·음악 생성 플랫폼 | 주요 AI 모델 지원", "description": "Miral에서 Seedream 5, Midjourney, Veo 3.1, Sora 2 등 선도적인 AI 모델을 한곳에서 이용하세요. 고품질 이미지, 동영상과 음악을 빠르게 생성해 디자인, 마케팅과 다양한 콘텐츠 제작에 활용할 수 있으며 누구나 쉽게 시작할 수 있습니다." },
    "pricing": { "title": "요금제 - Miral AI 창작 플랫폼", "description": "Miral은 유연한 요금제를 제공합니다. 크레딧을 구매하여 사용만 하세요, 구독 불필요." },
    "profile": { "title": "내 프로필 - Miral", "description": "Miral 계정 관리, 주문 내역 및 창작 기록 확인." },
    "models": { "title": "AI 모델 - Miral", "description": "Miral 플랫폼의 최고 AI 모델을 탐색하세요. 이미지, 동영상, 음악 생성 모델 포함." },
    "music": { "title": "AI 음악 생성 - Miral", "description": "Miral의 AI 음악 생성으로 텍스트에서 고유한 음악을 제작." },
    "tools": { "title": "AI 이미지 도구 - Miral", "description": "Miral은 워터마크 제거, 배경 제거, 이미지 향상 등 다양한 AI 이미지 처리 도구를 제공." },
    "inspiration": { "title": "영감 - Miral", "description": "Miral 커뮤니티의 추천 작품을 보고 AI 창작 영감을 얻으세요." },
    "gallery": { "title": "내 갤러리 - Miral", "description": "Miral 플랫폼에서 제작한 모든 작품 확인 및 관리." },
    "faq": { "title": "자주 묻는 질문 - Miral", "description": "Miral 플랫폼에 대한 자주 묻는 질문." },
    "about": {
      "title": "회사 소개 - Miral",
      "description": "Miral AI 창작 플랫폼을 소개합니다."
    },
    "contact": {
      "title": "문의하기 - Miral",
      "description": "Miral 지원팀 연락처입니다."
    },
    "terms": { "title": "이용약관 - Miral", "description": "Miral 플랫폼 이용약관 및 사용자 동의사항." },
    "privacy": { "title": "개인정보 처리방침 - Miral", "description": "Miral 플랫폼 개인정보 처리방침 및 데이터 보호 설명." },
    "trustSafety": { "title": "신뢰 및 안전 - Miral", "description": "Miral 플랫폼 신뢰 및 안전 정책." },
    "models": {
      "wan25": { "title": "Wan 2.5 - 강력한 AI 동영상 모델", "description": "Wan 2.5는 차세대 AI 동영상 생성을 제공합니다. 고급 모션과 디테일로 사실적이고 부드러운 동영상을 제작, 크리에이터와 비즈니스에 적합." },
      "wan26": { "title": "Wan 2.6 - 고급 AI 동영상 생성기", "description": "Wan 2.6로 동영상 제작을 업그레이드. 개선된 모션, 디테일, 속도로 초현실적 동영상을 생성하여 전문 콘텐츠에 적합." },
      "wan22": { "title": "Wan 2.2 - 빠른 AI 동영상 생성기", "description": "Wan 2.2는 빠르고 신뢰할 수 있는 AI 동영상 모델. 빠르게 고품질 동영상을 생성, 효율적인 전문 콘텐츠 제작에 이상적." },
      "wanAnimate": { "title": "Wan Animate - 캐릭터 애니메이션 - Miral", "description": "Alibaba Wan 2.2 Animate로 참조 이미지와 모션 동영상에서 캐릭터 애니메이션을 생성합니다." },
      "veo30": { "title": "Veo 3.0 - 선도적인 AI 동영상 모델", "description": "Veo 3.0는 최고급 AI 동영상 생성기. 고급 AI로 사실적인 시네마틱 동영상을 제작, 전문 콘텐츠 제작과 마케팅에 적합." },
      "veo31": { "title": "Veo 3.1 - 최고 AI 동영상 생성", "description": "Veo 3.1은 놀라운 사실적 동영상을 위한 선도적 AI 동영상 모델. 비교할 수 없는 품질과 속도로 시네마틱 클립과 애니메이션을 제작." },
     "kling26": { "title": "Kling 2.6 - 프리미엄 AI 동영상 모델", "description": "Kling 2.6이 전문적 AI 동영상 생성을 실현. 고급 AI로 고품질 부드러운 동영상을 생성, 크리에이터, 마케터, 비즈니스에 적합." },
      "kling25": { "title": "Kling 2.5 - 신뢰할 수 있는 AI 동영상 모델", "description": "Kling 2.5는 크리에이터를 위한 강력한 AI 동영상 생성. 부드러운 모션과 디테일로 고품질 동영상을 제작, 콘텐츠와 마케팅에 적합." },
      "seedance": { "title": "Seedance AI - 고급 AI 동영상 생성기", "description": "Seedance AI로 고품질 AI 동영상을 생성. 최첨단 AI 모델로 멋진 클립, 애니메이션, 시네마틱 콘텐츠를 빠르고 전문적으로 제작." },
      "sora2": { "title": "Sora 2 AI 동영상 생성기 – 텍스트·이미지 투 비디오 | Miral", "description": "Miral에서 텍스트나 이미지로 Sora 2 AI 동영상을 만드세요. 무료 크레딧으로 체험하고 4~12초, 720p/1080p, 16:9/9:16을 선택할 수 있습니다." },
      "hailuo23": { "title": "Hailuo 2.3 - 스마트 AI 동영상 생성기", "description": "Hailuo 2.3이 지능형 AI 동영상 생성을 제공. 고급 AI로 고품질 크리에이티브 동영상을 생성, 콘텐츠 크리에이터와 비즈니스에 적합." },
      "runway": { "title": "Runway - AI 동영상 제작 플랫폼", "description": "Runway는 크리에이터를 위한 선도적 AI 동영상 플랫폼. 강력한 AI 도구로 동영상을 편집, 생성, 향상, 전문 콘텐츠 제작에 적합." },
      "nanobanana": { "title": "Nano Banana - AI 이미지 생성 - Miral", "description": "Nano Banana 모델로 크리에이티브 이미지를 빠르게 생성." },
      "seedream4": { "title": "Seedream 4 - AI 이미지 생성기", "description": "Seedream 4로 멋진 고해상도 AI 이미지를 생성. 고급 AI로 사실적인 아트, 일러스트, 디자인을 생성하여 전문 크리에이티브 작업에 적합." },
      "midjourney": { "title": "Midjourney - AI 아트 생성기", "description": "Midjourney는 선도적인 AI 아트 생성기. 텍스트 프롬프트에서 놀라운 이미지와 아트를 생성, 아티스트, 디자이너, 콘텐츠 크리에이터에게 적합." },
      "gptimage1": { "title": "GPT-Image-1 - OpenAI AI 이미지 모델", "description": "OpenAI GPT-Image-1이 텍스트에서 고품질 AI 이미지를 생성. 디자인, 마케팅, 콘텐츠 제작을 위한 사실적이고 창의적인 비주얼을 생성." },
      "gptimage15": { "title": "GPT Image 1.5 - OpenAI AI 이미지 생성 - Miral", "description": "OpenAI GPT Image 1.5 모델로 고품질 AI 이미지 생성." },
      "fluxpro11ultra": { "title": "Flux Pro 1.1 Ultra - 프리미엄 AI 이미지 생성기", "description": "Flux Pro 1.1 Ultra는 초고품질 AI 이미지 생성을 제공. 고급 AI로 사실적이고 세밀한 이미지를 생성, 전문 디자인과 아트에 적합." },
      "fluxschnell": { "title": "Flux Schnell - 빠른 AI 이미지 생성기", "description": "Flux Schnell은 초고속 AI 이미지 생성기. 빠르게 고품질 이미지를 생성, 빠른 전문 비주얼 콘텐츠가 필요한 크리에이터에게 적합." },
      "flux2": {
        "title": "FLUX.2 - AI 이미지 생성 - Miral",
        "description": "FLUX.2 모델로 프로 수준의 AI 이미지 생성 — 속도, 품질, 제어를 위한 5개 버전."
      },
      "zimageturbo": {
        "title": "Z Image Turbo - AI 이미지 생성 - Miral",
        "description": "Z Image Turbo 모델로 고해상도 AI 이미지를 생성합니다."
      }
    },
    "tools": {
      "watermarkRemover": { "title": "무료 AI 워터마크 제거기 - 사진과 이미지 온라인 정리 도구 | Miral", "description": "AI로 사진의 워터마크, 로고, 날짜, 텍스트와 초안 표시를 온라인에서 제거하세요. 이미지 디테일과 품질을 유지하며 JPG, PNG 또는 WebP로 깔끔하게 저장할 수 있습니다. 상품 사진, SNS 콘텐츠와 작업 이미지를 별도 프로그램 없이 브라우저에서 빠르게 정리할 수 있습니다." },
      "backgroundRemover": { "title": "무료 AI 배경 제거 - 온라인 투명 PNG 만들기 | Miral", "description": "AI로 이미지 배경을 무료 제거하세요. 인물과 제품을 자동 누끼 처리하고 머리카락과 미세한 경계를 살려 JPG, PNG, WebP에서 투명 PNG를 만듭니다." },
      "imageEraser": { "title": "AI 이미지 지우개 - 사진에서 객체 제거", "description": "AI로 사진에서 원치 않는 객체, 인물, 워터마크, 텍스트를 제거. 해당 영역을 브러시로 칠하면 AI가 자연스럽게 지우고 빈 공간을 자연스러운 콘텐츠로 채웁니다. 이미지 정리에 적합." },
      "objectRemover": { "title": "AI 오브젝트 제거 - 사진에서 객체 제거", "description": "AI로 사진에서 원치 않는 객체를 제거. 해당 객체를 브러시로 칠하면 AI가 자연스럽게 지우고 해당 영역을 자연스러운 콘텐츠로 채웁니다. 사진 정리에 적합." },
      "aiPersonRemover": { "title": "AI 인물 제거 - 사진에서 인물 제거", "description": "AI로 사진에서 인물을 제거. 브러시로 원하는 인물을 칠하면 AI가 자연스럽게 지우고 해당 영역을 자연스러운 콘텐츠로 채웁니다. 지나가는 사람과 낯선 사람 제거에 적합." },
            "whiteBackground": { "title": "AI 흰색 배경 - 이미지 배경을 흰색으로 교체", "description": "AI로 이미지 배경을 흰색으로 자동 교체. 이커머스 상품 사진, 증명사진, 카탈로그 이미지에 적합." },
            "blueBackground": { "title": "AI 파란색 배경 - 이미지 배경을 파란색으로 교체", "description": "AI로 이미지 배경을 파란색으로 자동 교체. 여권 사진, 증명사진, 공식 문서에 적합." },
      "faceSwap": { "title": "AI 얼굴 교체 - 사진 얼굴 교체", "description": "AI로 사진의 얼굴을 교체. 대상 사진과 소스 얼굴을 업로드하면 현실적이고 자연스러운 결과로 얼굴을 자연스럽게 합성." },
      "imageEnhancer": { "title": "AI 이미지 향상 - 업스케일 및 고화질", "description": "AI로 이미지를 향상 및 업스케일. 디테일 선명화, 흐림 수정, 해상도 향상, 오래된 사진 복원으로 고품질 프로 결과 달성." },
      "docCropEnhance": { "title": "무료 AI 문서 자르기 및 기울기 보정 - 시험지 온라인 스캔 | Miral", "description": "문서, 시험지, 숙제와 교과서 사진을 AI로 자동 자르고 보정하세요. 기울기, 원근, 휘어진 페이지와 그림자를 수정하고 글자를 선명하게 만들어 깨끗한 스캔 이미지를 얻을 수 있습니다. 휴대폰으로 찍은 학습 자료도 읽기 좋게 정리해 저장, 공유와 인쇄에 활용할 수 있습니다." },
      "handwrittenErase": { "title": "무료 AI 손글씨 제거기 - 시험지와 숙제 답안 온라인 삭제 | Miral", "description": "시험지, 숙제와 문제집의 손글씨 답안을 AI로 제거하면서 인쇄된 문제와 원래 배치를 보존하세요. 문서 회전, 자르기와 휘어짐 보정도 지원해 깨끗한 빈 학습지를 복원합니다. 필기된 학습 자료를 브라우저에서 정리해 반복 연습과 수업 준비에 다시 활용할 수 있습니다." }
    },
    imageModels: {
            title: "AI 이미지 모델 - Miral",
            description: "Miral에서 최고의 AI 이미지 모델을 탐색하고 텍스트 프롬프트에서 멋진 이미지를 생성하세요.",
            relatedModelsTitle: "더 많은 AI 이미지 모델 살펴보기",
            demoPrompt: "텍스트 프롬프트",
            demoOutput: "생성된 이미지",
            demoPlaceholder: "샘플 이미지 — 곧 제공 예정",
            promptLabel: "다음으로 만들기",
            usePrompt: "이 프롬프트를 사용하세요 →",
            imagePlaceholder: "AI 이미지 예시",
            replaceImageHint: "이 이미지 옆에 표시된 프롬프트에서 생성됨",
            flux1: {
                title: "FLUX.1 AI 이미지 생성기 무료 온라인 | 밀알",
                description: "Flux Pro 1.1 Ultra 또는 Flux Schnell을 사용하여 FLUX.1로 고품질 AI 이미지를 온라인으로 생성하세요. 9가지 화면 비율, 시각적 스타일 및 무료 크레딧을 살펴보세요.",
                heroHeadline: "FLUX.1 AI 이미지 생성기",
                heroIntro: "Miral AI에서 Black Forest Labs의 FLUX.1 AI 이미지 생성기를 무료로 사용해 보세요. 무료 크레딧을 받으려면 등록하고 Flux Pro 1.1 Ultra의 고품질 출력과 Flux Schnell의 빠른 다중 스타일 생성 중에서 선택하세요.",
                eyebrow: "블랙 포레스트 연구소 · FLUX.1",
                sectionKicker: "플럭스.1",
                ctaTag: "FLUX.1 · 밀알",
                badges: ["텍스트를 이미지로", "9 종횡비", "프로와 슈넬", "사진/디지털 아트/애니메이션"],
                previewLabel: "플럭스 프로 1.1 울트라",
                previewMeta: ["1:1", "16:9", "9:16", "9 비율"],
                previewTitle: "세련된 품질과 빠른 창의적 탐색 중에서 선택하세요",
                previewDesc: "자세한 영상을 보려면 Pro 1.1 Ultra를 사용하고 사진, 디지털 아트 및 애니메이션 방향을 빠르게 탐색하려면 Schnell을 사용하세요.",
                keyFeaturesTitle: "FLUX.1 텍스트-이미지 생성기를 사용하여 고품질 비주얼 생성",
                keyFeaturesIntro: "신속한 이해, 출력 속도, 시각적 스타일 및 유연한 종횡비를 위한 Flux Pro 1.1 Ultra 및 Flux Schnell 기능을 살펴보세요.",
                exploreTitle: "더 많은 AI 이미지 모델 살펴보기",
                mainFeaturesTitle: "FLUX.1의 주요 기능",
                generatedImageLabel: "생성된 이미지",
                versionLabel: "버전",
                featureLabel: "주요 특징",
                useCaseLabel: "최고의 대상",
                controlsTitle: "올바른 모델, 비율, 시각적 스타일 선택",
                controlsIntro: "세련된 최종 이미지를 위해 Flux Pro 1.1 Ultra를 사용하거나 더 빠른 탐색을 위해 Flux Schnell을 사용한 다음 화면 비율과 스타일을 의도한 채널에 일치시킵니다.",
                galleryTitle: "더 많은 FLUX.1 이미지 예시",
                discussionTitle: "일반적인 FLUX.1 선택 질문",
                communityTitle: "FLUX.1을 사용하여 생성하는 인기 있는 방법",
                tutorialPrompt: "해가 뜨는 바다 옆의 조용한 유리집 서점, 따뜻한 독서등, 옅은 참나무 선반, 바닥에 비친 은은한 빛, 사실적인 실내 사진.",
                qualityBenefits: [
                    "더욱 세련된 마감으로 재료, 조명 및 공간 깊이를 렌더링합니다.",
                    "피사체, 구도, 카메라, 스타일을 결합한 자세한 프롬프트를 따르세요.",
                    "일반 텍스트 지침을 통해 사진, 디지털 아트, 애니메이션 제작 방향을 살펴보세요."
                ],
                features: [
                    { name: "고품질 FLUX.1 텍스트를 이미지로 변환", short: "서면 프롬프트를 상세하고 전문적인 시각적 자료로 바꿔보세요.", desc: "Flux Pro 1.1 Ultra는 이미지 디테일, 재료, 조명 및 전반적인 마감이 중요한 작업에 적합합니다. 피사체, 구도, 카메라, 스타일을 명확하게 설명하면 이미지를 프로젝트 방향으로 이끄는 데 도움이 됩니다.", demo: { type: 'table', rows: [
                        { prompt: "블루 아워의 부티크 사막 호텔 외관, 흙벽, 따뜻한 창문 빛, 자생 풀, 긴 그림자, 사실적인 건축 사진.", image: require('@/assets/images/flux1/b9d1e267-bb35-4d5c-a196-fae49460749d.webp') },
                        { prompt: "매트 블랙 플레이트, 바질 오일, 리넨 냅킨, 방향성 창 조명, 얕은 심도에 수제 라비올리의 편집 음식 사진입니다.", image: require('@/assets/images/flux1/2ab9dde4-0420-4594-b875-a8465741b767.webp') }
                    ] } },
                    { name: "Flux Schnell을 통한 빠른 생성", short: "빠른 초안을 만들고, 프롬프트를 테스트하고, 아이디어를 빠르게 탐색하세요.", desc: "Flux Schnell은 빠른 구성, 스타일 또는 개념 테스트가 필요한 작업 흐름에 매우 적합합니다. 초안을 생성하고 방향을 검토한 다음 다른 반복을 위해 프롬프트를 구체화합니다.", prompt: "친환경 스타트업을 위한 모듈식 판지 무역 박람회 부스 개념, 단순한 제품 받침대, 재활용 종이 질감, 밝은 전시 조명, 깔끔한 레이아웃.", image: require('@/assets/images/flux1/b8ffe8cb-1d2f-4bfc-897f-1068861614f9.webp') },
                    { name: "9가지 이미지 종횡비", short: "초광각, 가로, 정사각형, 세로 및 세로 형식을 지원합니다.", desc: "Flux Pro 1.1 Ultra와 Flux Schnell은 모두 배너, 제품 이미지, 소셜 콘텐츠, 포스터 및 모바일 영상에 대해 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 및 9:21을 지원합니다.", prompt: "운해 위의 21:9 파노라마 고산 전망대, 유리 전망대, 이른 아침의 빛, 규모에 맞는 작은 등산객, 영화 같은 매트 페인팅.", image: require('@/assets/images/flux1/a5efd8d2-571d-406d-9a01-f30581d4ea3b.webp') },
                    { name: "Schnell의 다양한 시각적 스타일", short: "자동, 사진, 디지털 아트 또는 애니메이션을 선택합니다.", desc: "Flux Schnell은 자동, 사진, 디지털 아트 및 애니메이션 스타일 방향을 제공하므로 모델을 변경하지 않고도 사진 실제, 일러스트레이션 및 애니메이션 비주얼 간에 쉽게 전환할 수 있습니다.", demo: { type: 'table', rows: [
                        { prompt: "사진 스타일: 햇볕이 잘 드는 차고에서 빈티지 경주용 자전거를 조정하는 자전거 정비공, 기름 묻은 손, 사실적인 크롬 반사.", image: require('@/assets/images/flux1/2b870b40-a436-42b9-980f-538e303cdfce.webp') },
                        { prompt: "애니메이션 스타일: 스카이 트레인 내부의 아늑한 고양이 카페, 창밖의 파스텔톤 일몰 구름, 표현력이 풍부한 캐릭터, 깔끔한 라인 아트.", image: require('@/assets/images/flux1/faded76c-4da1-49bb-98dc-10b8276f7da8.webp') }
                    ] } },
                    { name: "유연한 창의적 사용 사례", short: "제품, 마케팅, 초상화, 컨셉, 소셜 영상을 제작하세요.", desc: "FLUX.1 제품군은 세련된 제품 및 브랜드 이미지뿐만 아니라 빠른 캠페인 컨셉, 인물 사진, 환경 디자인 및 플랫폼별 종횡비를 지원합니다.", prompt: "재활용 패브릭 질감, 떠다니는 레이스 디테일, 모스 그린 그라데이션 배경, 소셜 광고 카피를 위한 대담한 빈 공간을 갖춘 지속 가능한 운동화 출시 시각적 요소입니다.", image: require('@/assets/images/flux1/0dfa0b4b-7722-40f4-9bc0-7bbf9bb1c000.webp') }
                ],
                showcaseKicker: "프롬프트 예시",
                showcaseTitle: "더 나은 AI 이미지를 위한 FLUX.1 프롬프트 예",
                showcaseIntro: "이러한 FLUX.1 프롬프트를 시작점으로 사용하세요. 피사체, 구도, 조명, 카메라, 재료, 색상 팔레트, 시각적 스타일을 명확하게 설명합니다.",
                variantsKicker: "모델 가이드",
                variantsTitle: "Flux Pro 1.1 Ultra 대 Flux Schnell",
                variantsIntro: "프로젝트에 필요한 품질, 속도 및 스타일 제어를 기반으로 FLUX.1 모델을 선택하십시오.",
                variants: [
                    { name: "플럭스 프로 1.1 울트라", tag: "고품질", desc: "지원되는 9가지 화면 비율을 통해 상세하고 사실적이며 세련된 텍스트-이미지 작업을 위해 설계되었습니다.", bestFor: "제품 사진, 캠페인 히어로 이미지, 세련된 최종 영상에 가장 적합합니다." },
                    { name: "플럭스 슈넬", tag: "빠르게", desc: "9가지 화면 비율과 자동, 사진, 디지털 아트 및 애니메이션 스타일을 사용하여 빠른 반복을 위해 설계되었습니다.", bestFor: "초안, 신속한 테스트, 소셜 콘텐츠 및 빠른 탐색에 가장 적합합니다." }
                ],
                useCasesKicker: "실제 업무용으로 제작됨",
                useCasesTitle: "인기 있는 FLUX.1 사용 사례",
                useCases: [
                    { name: "제품 사진을 위한 FLUX.1", desc: "제품 히어로 이미지, 라이프스타일 장면, 전자상거래 시각적 컨셉을 제작해 보세요." },
                    { name: "마케팅 및 광고용 FLUX.1", desc: "소셜 광고, 캠페인 배너, 브랜드 마케팅 비주얼을 생성합니다." },
                    { name: "사실적인 인물 사진을 위한 FLUX.1", desc: "조명, 배경, 구도를 조절하여 사진 같은 인물 사진을 만들어 보세요." },
                    { name: "디지털 아트를 위한 FLUX.1", desc: "Schnell을 사용하여 일러스트레이션, 판타지, 디지털 아트 방향을 빠르게 탐색해 보세요." },
                    { name: "애니메이션 이미지를 위한 FLUX.1", desc: "캐릭터와 애니메이션 장면에는 Schnell Anime 스타일을 사용하세요." },
                    { name: "컨셉 아트를 위한 FLUX.1", desc: "영화 환경, 게임 장면, 캐릭터, 시각적 세계를 탐색해 보세요." },
                    { name: "소셜 미디어 이미지용 FLUX.1", desc: "가로, 정사각형, 세로 플랫폼 콘텐츠에 9개의 가로세로 비율을 사용하세요." },
                    { name: "포스터 및 배너용 FLUX.1", desc: "이벤트, 프로모션, 모바일 페이지 레이아웃 컨셉에 적합한 비율을 선택하세요." }
                ],
                howToKicker: "세 가지 간단한 단계",
                howToTitle: "FLUX.1 AI 이미지 생성기를 온라인으로 무료로 사용하는 방법",
                howToIntro: "무료 크레딧을 받고 Miral에서 온라인으로 Flux Pro 1.1 Ultra 또는 Flux Schnell을 사용하려면 등록하세요.",
                howToSteps: [
                    { title: "자세한 프롬프트를 입력하세요", desc: "피사체, 설정, 구도, 조명, 카메라, 재료, 색상 및 대상 스타일을 설명합니다." },
                    { title: "모델 및 비율 선택", desc: "세련된 품질을 원하면 Pro 1.1 Ultra를 선택하고 빠른 탐색을 원하면 Schnell을 선택한 다음 종횡비와 Schnell 스타일을 설정하세요." },
                    { title: "생성 및 개선", desc: "이미지를 생성하고 검토 및 다운로드하거나 다른 버전에 맞게 프롬프트, 비율 또는 스타일을 조정하세요." }
                ],
                howToCta: "FLUX.1 AI 이미지 생성기를 무료로 사용해 보세요",
                faqTitle: "FLUX.1에 대해 자주 묻는 질문",
                faqs: [
                    { q: "FLUX.1 AI 이미지 생성기란 무엇인가요?", a: "FLUX.1은 Black Forest Labs의 이미지 생성 모델 제품군입니다. Miral에서는 Flux Pro 1.1 Ultra 및 Flux Schnell을 사용하여 텍스트 프롬프트를 제품, 마케팅, 초상화, 애니메이션 및 컨셉 아트 이미지로 변환합니다." },
                    { q: "FLUX.1 AI 이미지 생성기를 무료로 사용할 수 있나요?", a: "그렇습니다. 무료 크레딧을 받으려면 가입하고 FLUX.1 AI 이미지 생성기를 사용하여 즉시 고품질 이미지 생성을 시작하세요. 이미지 생성에는 해당 크레딧이 사용됩니다." },
                    { q: "Flux Pro 1.1 Ultra와 Flux Schnell의 차이점은 무엇입니까?", a: "Flux Pro 1.1 Ultra는 디테일과 마감이 중요한 세련된 최종 이미지에 적합합니다. Flux Schnell은 자동, 사진, 디지털 아트 및 애니메이션 스타일을 사용하여 빠른 초안, 신속한 테스트 및 다중 스타일 탐색에 적합합니다." },
                    { q: "FLUX.1은 어떤 이미지 종횡비를 지원합니까?", a: "Flux Pro 1.1 Ultra 및 Miral의 Flux Schnell은 21:9, 16:9, 4:3, 3:2, 1:1, 2:3, 3:4, 9:16 및 9:21을 지원하며 총 9개의 화면비를 지원합니다." },
                    { q: "Flux Schnell은 어떤 스타일을 지원합니까?", a: "Flux Schnell은 자동 매칭, 실사 이미지, 디지털 일러스트레이션 및 애니메이션 비주얼을 위해 자동, 사진, 디지털 아트 및 애니메이션을 지원합니다." },
                    { q: "FLUX.1 AI 이미지 생성기를 온라인으로 어떻게 사용합니까?", a: "텍스트 프롬프트를 입력하고 Flux Pro 1.1 Ultra 또는 Flux Schnell을 선택하고 화면 비율을 설정하십시오. Schnell을 사용하면 생성을 클릭하기 전에 시각적 스타일을 선택할 수도 있습니다." },
                    { q: "최고의 FLUX.1 프롬프트 예는 무엇입니까?", a: "효과적인 FLUX.1 프롬프트는 피사체, 설정, 구도, 조명, 카메라, 재료, 색상 팔레트 및 대상 스타일을 명확하게 설명합니다. 이 페이지의 예제를 출발점으로 사용하여 프로젝트에 적용하세요." },
                    { q: "FLUX.1과 FLUX.2: 어느 것을 사용해야 합니까?", a: "Flux Pro 1.1 Ultra로 세련된 출력을 원하거나 Flux Schnell로 빠르게 멀티 스타일을 생성하려면 FLUX.1을 선택하세요. Klein, Max, Pro 및 Flex 변형이 필요한 경우 Miral의 FLUX.2 페이지를 선택하십시오." },
                    { q: "FLUX.1과 Midjourney: 어느 것을 사용해야 합니까?", a: "FLUX.1은 명시적인 종횡비, 빠른 Schnell 워크플로우 또는 세련된 Pro 1.1 Ultra 출력에 매우 적합합니다. Midjourney는 예술적 스타일, 참조 이미지 워크플로 및 창의적인 프로세스를 선호하는 사용자에게 적합할 수 있습니다." }
                ],
                ctaTitle: "Miral에서 FLUX.1을 무료로 사용해 보세요!",
                ctaDesc: "무료 크레딧을 받으려면 등록하세요. Flux Pro 1.1 Ultra 또는 Flux Schnell을 선택하고 프로젝트에 필요한 비율과 스타일로 이미지를 만드세요."
            },
            flux2: {
                title: "FLUX.2 AI 이미지 생성기 무료 온라인 | 밀알",
                description: "FLUX.2를 사용하여 온라인으로 사실적인 AI 이미지를 만드세요. 제품 사진, 포스터, 삽화 및 세련된 마케팅 영상을 위한 5가지 모델 변형을 선택하세요.",
                heroHeadline: "FLUX.2 AI 이미지 생성기",
                heroIntro: "Miral AI에서 Black Forest Labs의 FLUX.2 AI 이미지 생성기를 무료로 사용해 보세요. 무료 크레딧을 받고 즉시 고품질의 사실적인 이미지, 제품 사진, 포스터 및 마케팅 영상을 만들려면 등록하세요.",
                eyebrow: "블랙 포레스트 연구소 · FLUX.2",
                sectionKicker: "FLUX.2",
                ctaTag: "FLUX.2 · 밀랄",
                badges: ["텍스트를 이미지로", "사실적인", "정확한 타이포그래피", "다양한 종횡비"],
                previewLabel: "FLUX.2",
                previewMeta: ["1:1", "1024×1024", "PNG"],
                previewTitle: "정확한 프롬프트부터 바로 제작 가능한 시각적 요소까지",
                previewDesc: "하나의 간소화된 작업 흐름으로 자세한 제품 사진, 캠페인 컨셉, 초상화, 텍스트가 풍부한 디자인을 제작하세요.",
                keyFeaturesTitle: "FLUX.2 텍스트-이미지 생성기를 사용하여 전문적인 시각적 자료 만들기",
                keyFeaturesIntro: "정확한 프롬프트, 세련된 디테일, 사실적인 출력 및 신뢰할 수 있는 시각적 제어를 위한 주요 FLUX.2 AI 이미지 생성기 기능을 살펴보세요.",
                exploreTitle: "더 많은 AI 이미지 모델 살펴보기",
                mainFeaturesTitle: "주요 FLUX.2 기능",
                generatedImageLabel: "생성된 이미지",
                versionLabel: "버전",
                featureLabel: "주요 특징",
                useCaseLabel: "최고의 대상",
                controlsTitle: "올바른 FLUX.2 버전 및 출력 설정 선택",
                controlsIntro: "신속한 반복을 위해서는 Klein을, 가장 강력한 최종 품질을 위해서는 Max를, 제작 워크플로를 위해서는 Pro를, 타이포그래피 및 세부적인 세부 제어를 위해서는 Flex를 사용하세요.",
                galleryTitle: "더 많은 FLUX.2 이미지 예시",
                discussionTitle: "일반적인 FLUX.2 모델 질문",
                communityTitle: "FLUX.2로 생성하는 인기 있는 방법",
                tutorialPrompt: "옅은 석회암 위의 반투명 에메랄드 향수병, 부드러운 아침 햇살, 사실적인 유리 굴절, 세련된 타이포그래피, 넉넉한 네거티브 공간의 프리미엄 캠페인 사진.",
                qualityBenefits: [
                    "피사체, 구도, 조명, 스타일을 더욱 강력하게 제어하여 자세한 메시지를 따르세요.",
                    "전문적인 시각적 작업을 위해 사실적인 질감, 깊이, 세련된 디테일을 만들어 보세요.",
                    "더욱 선명한 타이포그래피로 텍스트가 많은 포스터, 제품 라벨, 캠페인 그래픽을 처리하세요."
                ],
                features: [
                    { name: "고급 이미지 합성", short: "추가 대기 시간 없이 향상된 프롬프트 준수 및 이미지 품질을 제공합니다.", desc: "FLUX.2는 프롬프트 정렬을 크게 향상시키고 자세한 스크립트 및 장면 설명과 같은 긴 형식의 입력도 지원합니다. 생성된 이미지는 속도 저하 없이 더 높은 충실도를 제공하므로 반복적인 조정의 필요성이 줄어들고 제작자는 최종 결과에 더 빨리 도달할 수 있습니다.", demo: { type: 'table', rows: [
                        { prompt: "생동감 넘치는 색상과 복잡한 디테일이 돋보이는 놀라운 풍경으로, 산맥 너머로 지는 일몰을 보여줍니다.",image: require('@/assets/images/flux2/1a2627bd-61e0-406a-9308-19f2883d004e.webp') },
                        { prompt: "기능적 언어와 저수준 언어 간 번역을 위한 추상 미술입니다." ,image: require('@/assets/images/flux2/sample.webp')},
                        { prompt: "애니메이션/만화 캐릭터의 얼굴 사진으로, 상세하고 잘 만들어졌지만 인간이 만든 것처럼 보입니다." ,image: require('@/assets/images/flux2/57047990-2e26-4b44-bacf-f10bca5ee70d.webp')}
                    ] } },
                    { name: "뛰어난 디테일과 현실감", short: "스튜디오 수준의 비주얼을 위해 실제와 같은 질감, 조명 및 깊이를 생성합니다.", desc: "FLUX.2는 생성된 이미지를 진정한 사진처럼 보이게 만드는 미세한 질감, 사실적인 조명, 자연스러운 깊이를 포착합니다. 따라서 신뢰성이 가장 중요한 제품 사진, 인물 사진, 영화 같은 영상에 매우 적합합니다.", prompt: "다크 슬레이트의 은색 기계식 시계, 부드러운 측면 조명, 사실적인 브러시 처리된 금속 질감, 얕은 피사계 심도, 미묘한 반사, 고급 편집 구성의 스튜디오 제품 사진." ,image: require('@/assets/images/flux2/b1d818f0-ff1f-4612-b586-62f75e14466c.webp') },
                    { name: "강력한 프롬프트 준수", short: "특정 주제, 스타일 및 구성을 포함하여 복잡한 프롬프트를 면밀히 따릅니다.", desc: "FLUX.2는 단일 세대에서 특정 주제, 아트 스타일, 색상 팔레트 및 구성 지침을 처리하여 인상적인 정확도로 계층화된 다중 부분 프롬프트를 해석합니다. 이를 통해 제작자는 원하는 것을 정확하게 설명할 때 더 많은 제어권을 갖고 재굴림을 줄일 수 있습니다.", prompt: "해질녘에 비오는 유럽 광장을 가로지르는 빨간 전차, 전경에 세 명의 자전거 타는 사람, 왼쪽에 있는 따뜻한 카페 창문, 파란 시간 하늘, 대칭적인 구도, 영화 사진.",image: require('@/assets/images/flux2/2026b767-edcb-4441-b70e-a6d94ae6ebb9.webp') },
                    { name: "고급 타이포그래피 처리", short: "더 깔끔한 철자와 스타일 일관성으로 이미지 내의 텍스트를 렌더링합니다.", desc: "FLUX.2는 보다 정확한 글꼴 스타일 일관성을 통해 향상된 텍스트 생성 및 이미지 제어 기능을 제공합니다. 이를 통해 훨씬 적은 수의 인공물을 사용하여 포스터, 광고, 만화 및 브랜드 그래픽을 위한 텍스트 기반 자료 및 간판을 제작할 수 있습니다.", demo: { type: 'table', rows: [
                        { prompt: "\"FLUX 2\"라는 문구가 적힌 아름다운 신비로운 풍경 사진, 은은한 아름다움이 블루베리를 담고 있습니다." ,image: require('@/assets/images/flux2/c2f47f20-00b4-4cec-b972-e7a69d40be56.webp') },
                        { prompt: "\"FLUX 2 Pro\"라는 글자가 적힌 검은 숲의 가토 케이크, 맛있는 음식 사진." ,image: require('@/assets/images/flux2/2258b023-29ba-433f-b909-88f542adc3b9.webp') }
                    ] } },
                    { name: "빠르고 확장 가능한 생성", short: "1초 미만의 반복부터 최고 품질의 출력까지 선택하세요.", desc: "FLUX.2는 빠른 Klein 모델과 생산 중심의 Pro, Max 및 Flex 변형을 포괄합니다. 이 범위는 신속한 초안, 일괄 콘텐츠 제작, 최종 품질 마케팅 또는 창의적 자산에 실용적입니다.", prompt: "석회암 위의 반투명 녹색 향수병, 부드러운 아침 햇살, 은은한 그림자, 프리미엄 캠페인 미학을 담은 깔끔한 사설 제품 사진입니다." ,image: require('@/assets/images/flux2/2a4b147b-31c2-4ded-a626-d7e209fb751b.webp')}
                ],
                showcaseKicker: "프롬프트 예시",
                showcaseTitle: "더 나은 AI 이미지를 위한 FLUX.2 프롬프트 예",
                showcaseIntro: "이러한 FLUX.2 프롬프트 예제를 시작점으로 사용하여 주제, 구성, 조명 및 스타일을 사용자 정의한 다음 프롬프트를 생성기에 직접 보냅니다.",
                variantsKicker: "모델 가이드",
                variantsTitle: "FLUX.2 모델 비교: Klein vs Max vs Pro vs Flex",
                variantsIntro: "FLUX.2 Klein, Max, Pro 및 Flex를 비교하여 빠른 반복, 최종 품질 자산, 생산 규모 또는 미세한 타이포그래피 제어에 적합한 AI 이미지 모델을 선택하세요.",
                variants: [
                    { name: "FLUX.2 클라인 4B / 9B", tag: "가장 빠른", desc: "빠른 대용량 이미지 생성, 초안 및 신속한 프로토타이핑을 위해 FLUX.2 Klein을 선택하십시오.", bestFor: "초안, 배치 및 빠른 반복에 가장 적합" },
                    { name: "FLUX.2 최대", tag: "최고 품질", desc: "최종 자산, 가장 강력한 프롬프트 팔로우 및 기반 생성을 위해 FLUX.2 Max를 선택하세요.", bestFor: "프리미엄 캠페인 및 히어로 이미지에 가장 적합" },
                    { name: "FLUX.2 프로", tag: "생산", desc: "이미지 품질, 처리 시간 및 확장 가능한 출력의 프로덕션 등급 균형을 위해 FLUX.2 Pro를 선택하십시오.", bestFor: "마케팅 및 콘텐츠 제작에 가장 적합" },
                    { name: "FLUX.2 플렉스", tag: "제어", desc: "조정 가능한 안내, 타이포그래피, 텍스트 렌더링 및 작은 세부 사항 보존을 위해 FLUX.2 Flex를 선택하십시오.", bestFor: "포스터, 라벨, 디자인 자산에 가장 적합" }
                ],
                useCasesKicker: "실제 업무용으로 제작됨",
                useCasesTitle: "인기 있는 FLUX.2 사용 사례",
                useCases: [
                    { name: "제품 사진을 위한 FLUX.2", desc: "세련된 제품 사진, 라이프스타일 장면, 전자상거래 이미지 변형을 만들어보세요." },
                    { name: "마케팅 및 광고용 FLUX.2", desc: "캠페인 컨셉을 소셜 광고, 배너, 일관된 브랜드 비주얼로 전환하세요." },
                    { name: "포스터 및 타이포그래피용 FLUX.2", desc: "FLUX.2 텍스트 렌더링을 사용하여 보다 명확한 헤드라인, 라벨, 포스터 및 텍스트 기반 그래픽을 생성합니다." },
                    { name: "사실적인 인물 사진을 위한 FLUX.2", desc: "조명, 스타일, 구도를 제어하여 상세한 AI 인물 사진을 생성하세요." },
                    { name: "컨셉 아트를 위한 FLUX.2", desc: "영화 환경, 캐릭터, 시각적 방향을 빠르게 탐색해 보세요." },
                    { name: "편집 디자인을 위한 FLUX.2", desc: "기사와 프리젠테이션을 위한 독특한 일러스트레이션과 표지를 만듭니다." }
                ],
                howToKicker: "세 가지 간단한 단계",
                howToTitle: "FLUX.2 AI 이미지 생성기를 온라인으로 사용하는 방법",
                howToIntro: "Miral에서 온라인으로 FLUX.2 AI 이미지 생성기를 사용하면 자세한 텍스트 프롬프트에서 생성된 이미지로 이동할 수 있습니다.",
                howToSteps: [
                    { title: "프롬프트를 입력하세요", desc: "피사체, 구도, 조명, 색상, 스타일 및 이미지에 표시하려는 텍스트를 설명하세요." },
                    { title: "FLUX.2 설정을 선택하세요", desc: "생성기를 열고 Klein, Max, Pro 또는 Flex를 선택한 다음 프로젝트에 맞는 출력 크기를 선택하십시오." },
                    { title: "이미지 생성", desc: "생성을 시작하고, 결과를 검토하고, 이미지를 다운로드하거나 다른 버전에 맞게 프롬프트를 구체화하세요." }
                ],
                howToCta: "FLUX.2 AI 이미지 생성기를 사용해 보세요",
                faqTitle: "FLUX.2에 대해 자주 묻는 질문",
                faqs: [
                    { q: "FLUX.2란 무엇입니까?", a: "FLUX.2는 Black Forest Labs의 차세대 텍스트-이미지 AI 모델입니다. 서면 프롬프트를 고품질의 상세한 이미지로 변환하고 브라우저에서 직접 아트, 디자인, 마케팅 및 제품 시각적 제작을 위해 Miral에서 사용할 수 있습니다." },
                    { q: "제품 사진과 텍스트가 풍부한 마케팅 영상을 제작하려면 어떤 도구를 사용할 수 있나요?", a: "FLUX.2는 충실도와 정확성을 요구하는 전문적인 제품 사진과 텍스트가 풍부한 마케팅 비주얼을 위해 신속한 일관성, 디테일, 포토리얼리즘, 타이포그래피 처리를 결합합니다." },
                    { q: "FLUX.2 AI 이미지 생성기를 무료로 사용할 수 있나요?", a: "그렇습니다. 무료 크레딧을 받으려면 가입하고 FLUX.2 AI 이미지 생성기를 사용하여 즉시 고품질 이미지 생성을 시작하세요. 이미지 생성에는 해당 크레딧이 사용됩니다." },
                    { q: "FLUX.2 AI 이미지 생성기를 온라인으로 어떻게 사용합니까?", a: "자세한 텍스트 프롬프트를 입력하고 FLUX.2 Klein, Max, Pro 또는 Flex를 선택한 후 이미지 크기를 선택하고 생성을 클릭하세요. FLUX.2는 마케팅 자료, 제품 사진, 영화 컨셉, 소셜 크리에이티브 및 포스터 디자인에 적합합니다." },
                    { q: "FLUX.2를 생성하는 데 시간이 얼마나 걸리나요?", a: "생성 시간은 선택한 FLUX.2 변형, 이미지 크기 및 현재 서비스 로드에 따라 달라집니다. Klein은 매우 빠른 반복을 위해 설계된 반면 Max, Pro 및 Flex는 품질과 제어의 다양한 균형을 우선시합니다." },
                    { q: "내 메시지를 따르지 않는 FLUX.2 이미지를 수정하는 방법은 무엇입니까?", a: "피사체, 설정, 구도, 조명, 카메라 또는 아트 스타일, 색상, 필요한 텍스트를 보다 명확하게 설명하세요. 이 페이지의 FLUX.2 프롬프트 예제를 시작점으로 사용하여 프로젝트에 맞게 사용자 정의하세요." },
                    { q: "어떤 FLUX.2 모델을 선택해야 합니까?", a: "신속한 초안 및 배치를 위해서는 FLUX.2 Klein을, 최고 품질의 최종 자산을 위해서는 Max를, 프로덕션 규모의 이미지 생성을 위해서는 Pro를, 타이포그래피와 미세한 제어가 가장 중요한 경우에는 Flex를 선택하세요." },
                    { q: "FLUX.2 Max와 Pro: 차이점은 무엇인가요?", a: "FLUX.2 Max는 최고의 품질, 강력한 프롬프트 추적 및 기반 생성을 우선시합니다. FLUX.2 Pro는 일상적인 크리에이티브 워크플로우를 위해 프로덕션급 품질, 더 빠른 처리 속도 및 확장 가능한 출력의 균형을 유지합니다." },
                    { q: "FLUX.2와 Midjourney: 어느 것을 사용해야 합니까?", a: "보편적인 승자가 아닌 작업 흐름을 기준으로 선택하세요. FLUX.2는 정확한 프롬프트 따르기, 타이포그래피, 제품 비주얼 및 API 기반 제작에 매우 적합합니다. Midjourney는 독특한 예술적 작업 흐름과 커뮤니티 도구를 선호하는 제작자에게 적합할 수 있습니다." }
                ],
                ctaTitle: "Miral에서 FLUX.2를 무료로 사용해 보세요!",
                ctaDesc: "위에 아이디어를 입력하고 FLUX.2 AI 이미지 생성기를 사용하여 워크플로우에 맞는 모델 변형으로 상세한 이미지를 생성하세요."
            },
            seedream: {
                title: "Seedream AI 이미지 생성기 무료 온라인 | 밀알",
                description: "Seedream을 사용하여 온라인으로 고품질 AI 이미지를 생성하세요. 창의적인 프로젝트를 위한 정확한 프롬프트 이해, 명확한 텍스트 렌더링, 상세한 2K-4K 출력을 얻으세요.",
                heroHeadline: "Seedream AI 이미지 생성기",
                heroIntro: "Seedream AI 이미지 생성기를 무료로 사용해 보세요. 무료 크레딧을 받고 고품질의 제품 시각 자료, 포스터, 인물 사진 및 마케팅 이미지를 즉시 만들려면 등록하세요.",
                eyebrow: "ByteDance 시드 · Seedream AI",
                sectionKicker: "시드림 AI",
                ctaTag: "씨드림·미랄",
                badges: ["텍스트를 이미지로", "의도 이해", "2K / 3K / 4K 출력", "일반 텍스트 렌더링"],
                previewLabel: "시드림 AI",
                previewMeta: ["1:1", "2K / 3K / 4K", "사용자 정의 크기"],
                previewTitle: "창의적인 의도부터 정밀한 고해상도 비주얼까지",
                previewDesc: "세련된 디테일과 신뢰할 수 있는 신속한 제어를 통해 복잡한 구도, 제품 사진, 인물 사진, 텍스트가 풍부한 디자인을 제작하세요.",
                keyFeaturesTitle: "Seedream AI 텍스트-이미지 생성기로 정확한 비주얼 생성",
                keyFeaturesIntro: "텍스트-이미지 생성을 통해 더 깊은 의도 이해, 복잡한 구성, 고해상도 출력, 사실적인 디테일 및 정확한 텍스트 렌더링을 위한 Seedream AI 기능을 살펴보세요.",
                exploreTitle: "Seedream AI 모델 살펴보기",
                mainFeaturesTitle: "주요 Seedream AI 텍스트-이미지 변환 기능",
                seedream5Desc: "정확한 프롬프트, 세련된 현실감, 텍스트 렌더링 및 고해상도 출력을 위해 최신 Seedream 모델을 사용하십시오.",
                seedream4Desc: "신뢰할 수 있는 텍스트-이미지 생성 및 유연한 출력 설정을 위해 확립된 Seedream 4 워크플로를 엽니다.",
                features: [
                    { name: "더 깊은 프롬프트 이해", short: "창의적 의도, 공간적 관계 및 자세한 지침을 해석합니다.", desc: "Seedream AI는 격리된 프롬프트 용어 매칭 그 이상입니다. 복잡한 텍스트 지침에서 보다 일관된 결과를 생성하기 위해 주제, 레이아웃, 속성 및 시각적 컨텍스트 간의 관계를 추론합니다.", demo: { type: 'table', rows: [
                        { prompt: "3x3 디스플레이 선반, 정면도, 소재와 색상별로 배열된 9개의 서로 다른 물체, 일관된 스튜디오 조명 및 정확한 공간 정렬.", image: require('@/assets/images/seedream/0217834949526105a9f949eb72c2227dac5c405ca3d9cd6c996b9_0.webp') },
                        { prompt: "접힌 리넨과 세라믹 컵 옆에 있는 시계의 편집 제품 사진, 균형 잡힌 삼각형 구성, 부드러운 아침 햇살.", image: require('@/assets/images/seedream/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.webp') },
                        { prompt: "전경의 쇼핑객, 선명한 중앙 피사체, 겹겹이 쌓인 깊이, 젖은 도로에 반사되는 따뜻한 빛이 있는 영화 같은 시장 장면.", image: require('@/assets/images/seedream/994ae318-58d7-4ffa-98e1-ea97553ff0c0.webp') }
                    ] } },
                    { name: "복합 조성 제어", short: "여러 주제, 속성 및 구조화된 레이아웃을 보다 일관성 있게 처리합니다.", desc: "Seedream AI 이미지 생성기는 복잡한 장면 전반에 걸쳐 여러 부분으로 구성된 지침을 따르므로 요청된 객체 속성, 위치, 색상 및 관계를 단일 구성으로 보존하는 데 도움이 됩니다.", prompt: "서로 다른 모양의 세 개의 세라믹 꽃병이 엇갈린 석재 플랫폼 위에 놓여 있는 전면 편집 장면, 가장 높은 꽃병 뒤의 빨간색 구, 부드러운 측면 조명, 균형 잡힌 간격, 중립적인 스튜디오 배경.", image: require('@/assets/images/seedream/021783495389730ffa263910bfaab0198f27d0234753c494fd2fa_0.webp') },
                    { name: "2K, 3K, 4K 출력", short: "프로젝트에 필요한 세부 사항과 크기를 기준으로 출력 해상도를 선택하세요.", desc: "Seedream AI는 Miral에서 선택 가능한 2K, 3K, 4K 출력과 사용자 정의 이미지 크기를 지원합니다. 최종 사용에 필요한 치수와 세부 수준을 기준으로 선택하세요.", prompt: "일출 시 미래 해안 도시의 넓은 영화적 풍경, 다층 건축물, 반사되는 물, 대기 깊이, 복잡한 건물 세부 사항, 파노라마 구성.", image: require('@/assets/images/seedream/0217834956211361c17ef9c173e8babb4a0658490f0169e937059_0.webp') },
                    { name: "향상된 텍스트 렌더링", short: "포스터, 레이아웃, 라벨 및 프리젠테이션 그래픽에 대한 텍스트를 더욱 명확하게 만듭니다.", desc: "Seedream AI는 시각적 추론과 향상된 텍스트 생성을 결합하여 포스터, 프레젠테이션 그래픽, 광고, 패키징 개념 및 읽을 수 있는 텍스트가 이미지의 일부인 기타 레이아웃에 유용합니다.", demo: { type: 'table', rows: [
                        { prompt: "\"내일을 위한 디자인\"이라는 제목의 미니멀리스트 이벤트 포스터, 굵은 기하학적 유형, 흰색 배경, 녹색 액센트 그리드.", image: require('@/assets/images/seedream/0217834957232579f663fff68d336b1dca042ed755c42d2babd5a_0.webp') },
                        { prompt: "\"MIRAL ROAST\" 라벨이 붙은 프리미엄 커피 패키지, 간결한 테이스팅 노트, 따뜻한 종이 질감, 스튜디오 제품 사진.", image: require('@/assets/images/seedream/021783495813482572fdc12977fa128088f145c73a50ff1524591_0.webp') }
                    ] } },
                    { name: "세련된 디테일과 현실감", short: "설득력 있는 조명, 소재, 깊이, 제품 프레젠테이션을 연출합니다.", desc: "Seedream AI는 명확성과 믿을 수 있는 구조가 중요한 제품 사진, 인물 사진, 편집 영상 및 영화 컨셉을 위해 세련된 질감과 일관된 조명을 렌더링합니다.", prompt: "석회암 위의 반투명 녹색 향수병, 부드러운 아침 햇살, 은은한 그림자, 프리미엄 캠페인 미학을 담은 깔끔한 사설 제품 사진입니다.", image: require('@/assets/images/seedream/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.webp') }
                ],
                showcaseKicker: "프롬프트 예시",
                showcaseTitle: "더 나은 AI 이미지를 위한 Seedream AI 프롬프트 예",
                showcaseIntro: "Seedream AI 프롬프트 예시를 출발점으로 사용하세요. 주제, 공간 관계, 텍스트, 조명 및 레이아웃을 명확하게 설명하고 프롬프트를 생성기에 직접 보냅니다.",
                variantsKicker: "해결 가이드",
                variantsTitle: "Seedream AI 해상도 가이드: 2K vs 3K vs 4K",
                variantsIntro: "반복하려는 속도와 최종 자산에 필요한 세부 정보에 따라 Seedream AI 출력 해상도를 선택하세요.",
                variants: [
                    { name: "2K", tag: "표준 출력", desc: "소셜 콘텐츠, 일상적인 창작 작업, 표준 디지털 레이아웃을 위한 실용적인 솔루션입니다.", bestFor: "일반 디지털 콘텐츠에 가장 적합" },
                    { name: "3K", tag: "자세한 내용", desc: "더 많은 이미지 세부 정보를 추가하고 마케팅 및 프레젠테이션 작업을 위한 더 큰 레이아웃을 지원합니다.", bestFor: "마케팅 및 프레젠테이션 자산에 가장 적합" },
                    { name: "4K", tag: "최대한의 디테일", desc: "미세한 질감, 텍스트가 많은 레이아웃 또는 프리미엄 전달 품질이 중요한 경우 가장 높은 사전 설정을 사용하십시오.", bestFor: "최종 캠페인 및 고해상도 출력에 가장 적합" }
                ],
                useCasesKicker: "실제 업무용으로 제작됨",
                useCasesTitle: "인기 있는 Seedream AI 사용 사례",
                useCases: [
                    { name: "제품 사진 촬영을 위한 Seedream AI", desc: "세련된 제품 사진, 라이프스타일 장면, 전자상거래 이미지 컨셉을 제작하세요." },
                    { name: "마케팅을 위한 Seedream AI", desc: "구조화된 캠페인 아이디어를 소셜 광고, 배너, 브랜드 비주얼로 전환하세요." },
                    { name: "포스터와 텍스트를 위한 Seedream AI", desc: "포스터 컨셉, 프리젠테이션 그래픽, 라벨, 텍스트 기반 레이아웃을 제작합니다." },
                    { name: "복잡한 작곡을 위한 Seedream AI", desc: "여러 주제와 요청된 속성을 일관된 시각적 구조로 배열합니다." },
                    { name: "컨셉 아트를 위한 Seedream AI", desc: "영화적 환경, 캐릭터, 상세한 시각적 방향을 살펴보세요." },
                    { name: "편집 영상을 위한 Seedream AI", desc: "표지, 일러스트레이션, 인포그래픽, 프레젠테이션에 바로 사용할 수 있는 이미지를 만드세요." }
                ],
                howToKicker: "세 가지 간단한 단계",
                howToTitle: "Seedream AI 이미지 생성기를 온라인으로 무료로 사용하는 방법",
                howToIntro: "무료 크레딧을 받고 프로젝트에 필요한 명확한 프롬프트와 해상도로 Seedream AI 이미지 생성기를 온라인으로 사용하려면 등록하세요.",
                howToSteps: [
                    { title: "창의적인 의도를 입력하세요", desc: "주제, 공간 관계, 구성, 조명, 스타일, 필수 텍스트를 최대한 명확하게 설명하세요." },
                    { title: "해상도 및 크기 선택", desc: "생성기를 열고 최종 용도에 따라 2K, 3K, 4K 또는 지원되는 사용자 정의 크기를 선택합니다." },
                    { title: "생성 및 검토", desc: "생성을 시작하고 구성과 세부 사항을 검토한 다음 결과를 다운로드하거나 프롬프트를 조정하세요." }
                ],
                howToCta: "Seedream AI 이미지 생성기를 무료로 사용해 보세요",
                faqTitle: "Seedream AI에 대해 자주 묻는 질문",
                faqs: [
                    { q: "Seedream AI 이미지 생성기란 무엇인가요?", a: "Seedream AI는 ByteDance Seed 팀의 지능형 이미지 생성 모델입니다. Miral에서는 자세한 텍스트 프롬프트를 디자인, 마케팅, 제품 컨셉, 포스터 및 편집용 시각 자료를 위한 고해상도 이미지로 변환합니다." },
                    { q: "명확한 텍스트가 포함된 고해상도 포스터를 만들려면 어떤 도구를 사용할 수 있습니까?", a: "Seedream AI는 더 깊은 의도 이해, 정확한 구성, 향상된 텍스트 생성, 포스터 및 기타 텍스트가 풍부한 레이아웃을 위한 선택 가능한 고해상도 출력을 결합합니다." },
                    { q: "Seedream AI 이미지 생성기를 무료로 사용할 수 있나요?", a: "그렇습니다. 무료 크레딧을 받으려면 등록하고 Seedream AI 이미지 생성기를 사용하여 즉시 고품질 이미지 생성을 시작하세요. 이미지 생성에는 해당 크레딧이 사용됩니다." },
                    { q: "Seedream AI 이미지 생성기를 온라인으로 어떻게 사용하나요?", a: "자세한 텍스트 프롬프트를 입력하고 2K, 3K 또는 4K 출력을 선택하고 선택적으로 사용자 정의 크기를 선택한 다음 생성을 클릭합니다. 더 나은 결과를 얻으려면 피사체, 공간 관계, 속성, 조명, 텍스트 및 레이아웃을 명확하게 설명하십시오." },
                    { q: "Seedream AI는 2K, 3K, 4K 이미지를 지원합니까?", a: "그렇습니다. Miral은 Seedream AI에 대한 2K, 3K 및 4K 해상도 사전 설정과 함께 다양한 종횡비 및 전달 요구 사항에 맞게 지원되는 사용자 정의 치수를 제공합니다." },
                    { q: "잘못된 텍스트나 구성으로 Seedream 이미지를 수정하는 방법은 무엇입니까?", a: "주제, 개체 간의 관계, 구성, 조명, 색상, 스타일 및 필수 텍스트를 보다 명확하게 설명합니다. 이 페이지의 Seedream 예제를 시작점으로 사용하고 각 시각적 요구 사항을 명확하게 명시하십시오." },
                    { q: "어떤 Seedream AI 해상도를 선택해야 합니까?", a: "표준 디지털 콘텐츠에는 2K를 선택하고, 마케팅이나 프리젠테이션 레이아웃에 더 많은 디테일이 필요할 때는 3K를, 대규모 최종 캠페인, 포스터 또는 프리미엄 디자인 자산에 최대한의 디테일이 중요한 경우에는 4K를 선택하세요." },
                    { q: "Seedream AI와 Midjourney: 어느 것을 사용해야 합니까?", a: "Seedream AI는 Miral의 구조화된 프롬프트, 복잡한 구성, 텍스트가 풍부한 레이아웃 및 선택 가능한 고해상도 출력에 매우 적합합니다. Midjourney는 독특한 예술적 작업 흐름과 커뮤니티 도구를 선호하는 제작자에게 적합할 수 있습니다." }
                ],
                ctaTitle: "Miral에서 Seedream AI를 무료로 사용해 보세요!",
                ctaDesc: "무료 크레딧을 받으려면 등록하세요. 아이디어를 설명하고, 올바른 해상도를 선택하고, Seedream AI 이미지 생성기를 사용하여 정밀한 고해상도 비주얼을 만들어보세요."
            },
            gptImage: {
                title: "GPT 이미지 AI 이미지 생성기 무료 온라인 | 밀알",
                description: "Miral AI에서 GPT Image 및 GPT-Image-1.5를 사용하여 온라인으로 고품질 AI 이미지를 생성하세요. 포스터, 제품, 인물 사진에 적합한 크기와 품질 수준을 선택하세요.",
                heroHeadline: "GPT 이미지 AI 이미지 생성기",
                heroIntro: "Miral AI에서 GPT Image AI 이미지 생성기를 무료로 사용해 보세요. 무료 크레딧을 받으려면 등록하고 GPT-Image-1.5를 사용하여 즉시 고품질 제품 이미지, 포스터, 인물 사진 및 마케팅 영상을 만드십시오.",
                eyebrow: "OpenAI · GPT-이미지-1.5",
                sectionKicker: "GPT 이미지",
                ctaTag: "GPT 이미지 · Miral",
                badges: ["텍스트를 이미지로", "선택 가능한 품질", "가로/세로/정사각형", "정확한 프롬프트 이해"],
                previewLabel: "GPT-이미지-1.5",
                previewMeta: ["1024×1024", "1536×1024", "1024×1536"],
                previewTitle: "서면 아이디어부터 세련되고 실용적인 AI 이미지까지",
                previewDesc: "명확한 프롬프트와 선택 가능한 품질을 사용하여 제품 시각 자료, 포스터, 초상화, 브랜드 콘텐츠를 제작하세요.",
                keyFeaturesTitle: "GPT Image AI 이미지 생성기로 고품질 비주얼 생성",
                keyFeaturesIntro: "신속한 이해, 품질 관리, 실용적인 이미지 크기 및 전문적인 시각적 제작을 위한 GPT-Image-1.5 기능을 살펴보세요.",
                features: [
                    { name: "자연어 및 다중 주제 프롬프트", short: "피사체, 구성, 조명, 스타일 및 시각적 관계를 자연어로 설명합니다.", desc: "GPT Image AI 이미지 생성기는 여러 주제, 속성 및 구성 요구 사항이 있는 자연어 프롬프트를 지원합니다. 간단한 프롬프트로 시작하거나 각 피사체의 위치, 색상 및 관계를 지정하여 더욱 일관적인 다중 피사체 이미지를 만듭니다.", demo: { type: 'table', rows: [
                        { prompt: "창백한 돌 받침대 위에 있는 투명한 향수병의 편집 제품 사진, 왼쪽의 부드러운 아침 햇살, 깨끗한 배경, 얕은 피사계 심도, 프리미엄 브랜드 미학.", image: require('@/assets/images/gptImage/perfume-editorial.webp') },
                        { prompt: "밤에 비가 오는 도시 거리, 서로 다른 색상의 우산을 들고 있는 전경 보행자 3명, 저 멀리 지나가는 트램, 젖은 포장도로에 반사된 네온, 영화 같은 넓은 구성.", image: require('@/assets/images/gptImage/rainy-city-tram.webp') }
                    ] } },
                    { name: "GPT-이미지-1.5 품질 관리", short: "속도와 디테일 요구 사항에 따라 자동, 낮음, 중간 또는 높음을 선택하세요.", desc: "GPT-Image-1.5는 자동, 낮음, 중간 및 고품질 설정을 제공합니다. 빠른 탐색을 위해서는 낮은 품질을 사용하고 최종 제품 이미지, 포스터 또는 마케팅 자산에는 높은 품질을 사용하십시오.", prompt: "검정색 배경에 딸기 케이크를 담은 고급 음식 광고, 바삭바삭한 크림 질감, 부드러운 테두리 조명, 상세한 음식 사진, 상업 구성.", image: require('@/assets/images/gptImage/strawberry-cake.webp') },
                    { name: "세 가지 실제 이미지 크기", short: "정사각형, 가로 및 세로 출력을 만듭니다.", desc: "소셜 게시물, 배너 및 프레젠테이션 영상, 인물 포스터 및 모바일 콘텐츠의 경우 1024×1024, 1536×1024 또는 1024×1536을 선택합니다.", prompt: "아침 안개 속에 해변 절벽과 등대가 있는 1024×1536 초상화 여행 포스터, 상단에 헤드라인을 위한 공간, 현대적인 편집 레이아웃.", image: require('@/assets/images/gptImage/lighthouse-travel-poster.webp') },
                    { name: "명확한 텍스트 및 레이아웃 생성", short: "텍스트가 포함된 포스터, 라벨, 브랜드 컨셉을 만드세요.", desc: "필요한 카피, 배치, 타이포그래피 분위기, 레이아웃 관계를 명확하게 명시함으로써 GPT Image는 헤드라인이 포함된 포스터, 포장, 이벤트 그래픽 및 마케팅 이미지를 탐색하는 데 도움이 될 수 있습니다.", demo: { type: 'table', rows: [
                        { prompt: "\"CREATE THE FUTURE\"라는 제목의 미니멀리스트 기술 이벤트 포스터, 굵은 산세리프체, 짙은 파란색 배경, 녹색 기하학적 격자선, 명확한 중앙 헤드라인.", image: require('@/assets/images/gptImage/create-the-future.webp') },
                        { prompt: "전면에 \"MIRAL ROAST\"라는 텍스트가 있는 프리미엄 커피 패키지 컨셉, 따뜻한 갈색 종이 질감, 클린 라벨, 스튜디오 제품 사진.", image: require('@/assets/images/gptImage/miral-roast-package.webp') }
                    ] } },
                    { name: "디테일과 현실감", short: "믿을 수 있는 재료, 조명, 사람, 제품 세부정보를 렌더링합니다.", desc: "GPT 이미지는 프롬프트가 재료, 카메라 선택, 조명 및 피사계 심도를 명확하게 설명하는 경우 제품 사진, 인물 사진, 인테리어 및 편집 영상에 적합합니다.", prompt: "자연스러운 창문 조명, 사실적인 피부 질감, 손에 묻은 점토 먼지, 작업장 배경, 얕은 피사계 심도, 따뜻한 편집 사진을 통해 도자기 예술가의 편집 초상화를 닫습니다.", image: require('@/assets/images/gptImage/ceramic-artist.webp') }
                ],
                showcaseKicker: "프롬프트 예시",
                showcaseTitle: "더 나은 AI 이미지를 위한 GPT 이미지 프롬프트 예",
                showcaseIntro: "이러한 GPT 이미지 프롬프트를 시작점으로 사용하세요. 주제, 구도, 조명, 스타일, 재료 및 필요한 텍스트를 명확하게 설명하십시오.",
                variantsKicker: "버전 가이드",
                variantsTitle: "GPT-이미지-1.5 대 GPT-이미지-1",
                variantsIntro: "품질 관리가 필요한지 여부에 따라 GPT 이미지 버전을 선택하세요. 둘 다 실용적인 정사각형, 가로 및 세로 크기를 지원합니다.",
                variants: [
                    { name: "GPT-이미지-1.5", tag: "추천", desc: "자동, 낮음, 중간, 고품질 옵션으로 1024×1024, 1536×1024 및 1024×1536을 지원합니다.", bestFor: "품질 관리가 필요한 일상 업무 및 전문 업무에 가장 적합" },
                    { name: "GPT-이미지-1", tag: "클래식", desc: "더 간단한 컨트롤 세트를 사용하여 동일한 세 가지 실제 이미지 크기를 지원합니다.", bestFor: "간단한 범용 텍스트-이미지 생성에 가장 적합" }
                ],
                useCasesKicker: "실제 업무용으로 제작됨",
                useCasesTitle: "인기 있는 GPT 이미지 사용 사례",
                useCases: [
                    { name: "제품 사진 및 모형용 GPT 이미지", desc: "제품 히어로 이미지, 라이프스타일 장면, 제품 모형, 전자상거래 시각적 컨셉을 제작해 보세요." },
                    { name: "전자상거래 목록 이미지용 GPT 이미지", desc: "제품 목록 이미지, 기능 그래픽, 포장 디스플레이 및 광고 개념을 살펴보세요." },
                    { name: "마케팅 및 소셜 미디어 광고용 GPT 이미지", desc: "소셜 미디어 광고, 캠페인 배너, 이메일 배너, 브랜드 마케팅 비주얼을 만드세요." },
                    { name: "UI/UX 및 웹사이트 레이아웃용 GPT 이미지", desc: "앱 인터페이스, 웹사이트 레이아웃, 랜딩 페이지, 제품 쇼케이스 페이지에 대한 시각적 개념을 생성합니다." },
                    { name: "인포그래픽 및 시각적 보고서용 GPT 이미지", desc: "인포그래픽, 시각적 보고서, 프레젠테이션 그래픽에 대한 레이아웃 개념을 살펴보세요. 최종 사용 전에 모든 텍스트와 데이터를 확인하십시오." },
                    { name: "포스터 및 제품 포장용 GPT 이미지", desc: "헤드라인 및 레이아웃 요구 사항이 포함된 포스터, 제품 라벨, 포장 디자인을 살펴보세요." },
                    { name: "책 표지 및 블로그 이미지용 GPT 이미지", desc: "책 표지, 편집 일러스트레이션, 블로그 헤더 및 출판 시각적 개념을 만듭니다." },
                    { name: "인물 사진용 GPT 이미지", desc: "제어된 조명, 배경 및 스타일을 사용하여 편집 인물 사진을 만드세요." },
                    { name: "게임 캐릭터 컨셉을 위한 GPT 이미지", desc: "게임 캐릭터, 의상, 소품, 다양한 예술적 방향을 빠르게 탐색해 보세요." },
                    { name: "게임 환경을 위한 GPT 이미지", desc: "초기의 창의적인 탐색을 위해 게임 환경, 영화 같은 장면, 세계 구축 개념을 생성합니다." },
                    { name: "소셜 콘텐츠용 GPT 이미지", desc: "다양한 플랫폼에 대한 정사각형, 가로 및 세로 이미지를 생성합니다." }
                ],
                howToKicker: "세 가지 간단한 단계",
                howToTitle: "GPT Image AI 이미지 생성기를 온라인으로 무료로 사용하는 방법",
                howToIntro: "무료 크레딧을 받고 Miral에서 온라인으로 GPT Image AI 이미지 생성기를 사용하려면 등록하세요.",
                howToSteps: [
                    { title: "자세한 프롬프트를 입력하세요", desc: "주제, 설정, 구성, 조명, 스타일, 재료 및 필요한 텍스트를 설명합니다." },
                    { title: "크기와 품질을 선택하세요", desc: "정사각형, 가로 또는 세로 크기를 선택하고 필요에 따라 GPT-Image-1.5 품질을 설정하세요." },
                    { title: "생성 및 검토", desc: "생성을 시작하고 이미지를 검토 및 다운로드하거나 프롬프트를 조정하고 다른 버전을 생성합니다." }
                ],
                howToCta: "GPT Image AI 이미지 생성기를 무료로 사용해 보세요",
                faqTitle: "GPT 이미지에 대해 자주 묻는 질문(FAQ)",
                faqs: [
                    { q: "GPT Image AI 이미지 생성기란 무엇입니까?", a: "GPT 이미지는 OpenAI의 범용 텍스트-이미지 모델 제품군입니다. Miral에서 GPT Image AI 이미지 생성기는 작성된 프롬프트를 디자인, 마케팅, 제품 컨셉, 포스터 및 소셜 콘텐츠를 위한 고품질 이미지로 변환합니다." },
                    { q: "GPT Image AI 이미지 생성기를 무료로 사용할 수 있나요?", a: "그렇습니다. 무료 크레딧을 받으려면 등록하고 즉시 GPT Image AI 이미지 생성기를 사용하여 고품질 이미지 생성을 시작하세요. 이미지 생성에는 해당 크레딧이 사용됩니다." },
                    { q: "GPT Image AI 이미지 생성기를 온라인으로 어떻게 사용합니까?", a: "자세한 프롬프트를 입력하고 1024×1024, 1536×1024 또는 1024×1536을 선택합니다. GPT-Image-1.5를 사용하면 생성을 클릭하기 전에 자동, 낮음, 중간 또는 높음 품질을 선택할 수도 있습니다." },
                    { q: "GPT-Image-1.5와 GPT-Image-1의 차이점은 무엇입니까?", a: "두 버전 모두 동일한 세 가지 실제 이미지 크기를 지원합니다. Miral의 GPT-Image-1.5는 자동, 낮음, 중간 및 높음 품질 제어 기능도 제공하는 반면, GPT-Image-1에는 더 간단한 매개변수 세트가 있습니다." },
                    { q: "GPT 이미지는 어떤 이미지 크기를 지원합니까?", a: "Miral에서 GPT-Image-1 및 GPT-Image-1.5는 1024×1024 정사각형, 1536×1024 가로 및 1024×1536 세로 이미지를 지원합니다." },
                    { q: "어떤 GPT 이미지 품질을 선택해야 합니까?", a: "메시지를 신속하게 테스트할 때는 낮음 또는 중간을 선택하고, 최종 제품 이미지, 포스터 또는 마케팅 자산에 대해서는 높음을 선택하고, 확실하지 않은 경우에는 자동을 선택하세요. 품질 옵션은 GPT-Image-1.5에 적용됩니다." },
                    { q: "내 프롬프트와 일치하지 않는 GPT 이미지 결과를 수정하는 방법은 무엇입니까?", a: "피사체, 설정, 구도, 조명, 카메라, 재료, 스타일 및 필요한 텍스트를 보다 명확하게 설명합니다. 이 페이지의 GPT 이미지 예시를 출발점으로 사용하여 프로젝트에 적용하세요." },
                    { q: "GPT 이미지를 사용하려면 신속한 엔지니어링 경험이 필요합니까?", a: "아니요. 간단한 자연어 프롬프트로 시작한 다음 필요에 따라 피사체 위치, 구성, 조명, 색상, 재료 및 텍스트 요구 사항을 추가하세요. 설명이 명확할수록 일반적으로 결과가 창의적 의도와 더 밀접하게 일치하는 데 도움이 됩니다." },
                    { q: "전자상거래 제품 이미지, 포스터 및 UI 컨셉을 만드는 데 사용할 수 있는 도구는 무엇입니까?", a: "GPT 이미지는 전자상거래 목록 이미지, 제품 모형, 포스터, UI/UX 컨셉, 웹사이트 레이아웃, 인포그래픽 레이아웃, 책 표지, 블로그 이미지, 이메일 배너, 게임 컨셉을 생성할 수 있습니다. 최종 사용 전에 텍스트, 데이터, 브랜드 요소 및 구조적 세부 사항을 확인하십시오." },
                    { q: "GPT 이미지와 Midjourney: 어느 것을 사용해야 합니까?", a: "GPT 이미지는 명확한 프롬프트 제어, 실용적인 이미지 크기 및 직접 브라우저 생성에 매우 적합합니다. Midjourney는 예술적 스타일, 참조 이미지 워크플로 및 창의적인 프로세스를 선호하는 사용자에게 적합할 수 있습니다." }
                ],
                ctaTitle: "Miral에서 GPT 이미지를 무료로 사용하세요!",
                ctaDesc: "무료 크레딧을 받으려면 등록하세요. 아이디어를 설명하고, 크기와 품질을 선택하고, GPT Image AI 이미지 생성기를 사용하여 고품질 비주얼을 만드세요."
            },
            qwenImage2Pro: {
                title: "Qwen Image 2.0 Pro AI 이미지 생성기 무료 온라인 | 밀알",
                description: "Qwen Image 2.0 Pro를 사용하여 온라인으로 AI 이미지를 생성하세요. 네거티브 프롬프트, 프롬프트 향상, 유연한 종횡비를 사용하고 실행당 최대 4개의 이미지를 생성합니다.",
                heroHeadline: "Qwen Image 2.0 Pro AI 이미지 생성기",
                heroIntro: "Miral AI에서 Qwen Image 2.0 Pro AI 이미지 생성기를 무료로 사용해 보세요. 무료 크레딧을 받으려면 등록하고 네거티브 프롬프트, 즉각적인 향상 및 유연한 종횡비를 갖춘 고품질 이미지를 빠르게 생성하십시오.",
                eyebrow: "Alibaba Tongyi Qwen · Qwen-Image-2.0-Pro",
                sectionKicker: "Qwen 이미지 2.0 프로",
                ctaTag: "Qwen Image 2.0 Pro · Miral",
                badges: ["텍스트를 이미지로", "부정적인 프롬프트", "프롬프트 강화", "1-4 이미지/실행", "유연한 종횡비"],
                previewLabel: "Qwen 이미지 2.0 프로",
                previewMeta: ["1:1", "2048 × 2048", "최대 1~4개의 이미지"],
                previewTitle: "제외 항목이 포함된 정확한 프롬프트부터 세련된 시각적 요소까지",
                previewDesc: "긍정적인 프롬프트를 부정적인 프롬프트 및 프롬프트 향상과 결합하여 한 번의 실행으로 여러 개의 대상 이미지를 생성합니다.",
                keyFeaturesTitle: "Qwen Image 2.0 Pro 텍스트-이미지 생성기로 정확한 비주얼 생성",
                keyFeaturesIntro: "미세 제어, 네거티브 프롬프트, 프롬프트 향상, 일괄 출력 및 유연한 종횡비를 위한 주요 Qwen Image 2.0 Pro AI 이미지 생성기 기능을 살펴보세요.",
                mainFeaturesTitle: "주요 Qwen Image 2.0 Pro 기능",
                promptLabel: "긍정적 프롬프트",
                negativePromptLabel: "부정적인 프롬프트",
                shortPromptLabel: "짧은 프롬프트",
                negativePromptFallback: "낮은 선명도, 왜곡된 디테일, 어수선한 구성",
                features: [
                    { name: "부정적인 프롬프트 컨트롤", short: "보다 명확하고 목표에 맞는 결과를 얻으려면 무엇을 제외해야 하는지 설명하세요.", desc: "Qwen Image 2.0 Pro AI 이미지 생성기는 전용 네거티브 프롬프트를 지원하므로 낮은 선명도, 변형된 손 또는 어수선한 구도 등 피해야 할 사항을 모델에 알려줄 수 있습니다. 이렇게 하면 최종 이미지를 보다 세밀하게 제어할 수 있고 반복적으로 다시 롤링할 필요성이 줄어듭니다.", demo: { type: 'table', rows: [
                        { prompt: "젖은 돌 위에 있는 유리 스킨케어 병, 부드러운 아침 햇살, 깨끗한 배경의 프리미엄 제품 사진입니다. (부정적: 어수선한 배경, 낮은 해상도, 변형된 반사.)", image: require('@/assets/images/qwenImage2Pro/32ccbe94-155c-4873-9e85-602969ecb6e4.webp') },
                        { prompt: "가을 빛, 자연스러운 피부 질감, 얕은 심도를 지닌 젊은 여성의 초상화. (부정적: 지나치게 매끈한 피부, 왁스 같은 느낌, 과포화 색상.)", image: require('@/assets/images/qwenImage2Pro/b4c88e78-6c88-4db5-9ea2-a6041609a380.webp') }
                    ] } },
                    { name: "프롬프트 강화", short: "선택적으로 짧은 프롬프트를 더 자세한 내용으로 확장합니다.", desc: "프롬프트 향상을 켜면 Qwen Image 2.0 Pro가 생성 전에 추가 세부 정보로 간단한 프롬프트를 자동으로 강화합니다. 이를 통해 전문가가 아닌 프롬프트에서도 수동으로 다시 작성하지 않고도 더욱 완전하고 생생한 이미지를 생성할 수 있습니다.", demo: { type: 'table', rows: [
                        { prompt: "비오는 창가의 아늑한 독서 공간.", image: require('@/assets/images/qwenImage2Pro/f9f87426-60d9-4f97-a372-7cb55b5bf7de.webp') },
                        { prompt: "밤이면 비가 내리는 창문 옆에 있는 나무 독서 책상, 펼쳐진 책과 김이 피어오르는 차를 비추는 따뜻한 작업등, 조용하고 아늑한 인테리어.", image: require('@/assets/images/qwenImage2Pro/qwen-enhance-rainy-desk.webp') }
                    ] } },
                    { name: "한 번에 1-4개의 이미지 생성", short: "한 번의 실행으로 다양한 변형을 생성합니다.", desc: "Qwen Image 2.0 Pro는 요청당 최대 4개의 이미지를 생성할 수 있으므로 컨셉, 각도 또는 스타일의 변형을 나란히 비교하고 가장 적합한 이미지를 선택할 수 있습니다. 이를 통해 마케팅 및 제품 시각적 요소에 대한 창의적인 탐색 속도가 빨라집니다.", prompt: "호두나무 사이드 테이블 위의 미니멀한 세라믹 테이블 램프, 따뜻한 저녁 인테리어, 크림색 벽, 부드러운 그림자, 스칸디나비아 제품 사진.", image: require('@/assets/images/qwenImage2Pro/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.webp') },
                    { name: "유연한 종횡비", short: "가로, 세로, 정사각형 또는 맞춤 크기를 선택하세요.", desc: "2688×1536 가로, 1536×2688 세로, 2048×2048 정사각형, 2368×1728 / 1728×2368 등 미리 만들어진 화면 비율 중에서 선택하거나 512×512에서 2048×2048까지 사용자 정의 크기를 입력합니다. 따라서 Qwen Image 2.0 Pro 텍스트-이미지 생성기는 배너, 포스터, 소셜 게시물 및 사각형 썸네일 모두에 적합합니다.", prompt: "황금 시간의 해안 절벽, 드라마틱한 구름, 섬세한 바위 디테일을 담은 영화 같은 넓은 풍경 사진, 2688×1536.", image: require('@/assets/images/qwenImage2Pro/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.webp') },
                    { name: "세련된 디테일과 현실감", short: "실제와 같은 질감, 조명 및 깊이를 렌더링합니다.", desc: "Qwen Image 2.0 Pro는 미세한 질감, 사실적인 조명 및 자연스러운 깊이를 생성하므로 신뢰성이 중요한 제품 사진, 인물 사진 및 편집용 영상에 적합합니다.", prompt: "햇볕이 잘 드는 작업장에 있는 나이든 도예가의 클로즈업 편집 초상화, 자연스러운 피부 질감, 손에 묻은 점토 먼지, 따뜻한 창문 조명, 얕은 심도.", image: require('@/assets/images/qwenImage2Pro/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.webp') }
                ],
                showcaseKicker: "프롬프트 예시",
                showcaseTitle: "더 나은 AI 이미지를 위한 Qwen Image 2.0 Pro 프롬프트 예",
                showcaseIntro: "Qwen Image 2.0 Pro 프롬프트 예시를 시작점으로 사용하세요. 각 긍정적 프롬프트를 부정적 프롬프트와 결합하여 원하지 않는 요소를 제거한 다음 생성기로 직접 보냅니다.",
                useCasesKicker: "실제 업무용으로 제작됨",
                useCasesTitle: "인기 있는 Qwen Image 2.0 Pro 사용 사례",
                useCases: [
                    { name: "제품 사진용 Qwen Image 2.0 Pro", desc: "네거티브 프롬프트를 사용하여 배경이 통제된 깔끔한 제품 사진을 만들어 어수선함을 제거하세요." },
                    { name: "마케팅용 Qwen Image 2.0 Pro", desc: "다양한 화면비에 걸쳐 캠페인 컨셉, 소셜 광고 및 배너를 생성합니다." },
                    { name: "포스터 및 타이포그래피용 Qwen Image 2.0 Pro", desc: "명확한 헤드라인과 라벨을 사용하여 포스터 레이아웃과 텍스트가 풍부한 디자인을 제작합니다." },
                    { name: "인물 사진용 Qwen Image 2.0 Pro", desc: "아티팩트를 방지하기 위해 네거티브 프롬프트를 사용하여 자연스러운 피부 질감으로 상세한 인물 사진을 생성합니다." },
                    { name: "컨셉 아트용 Qwen Image 2.0 Pro", desc: "실행당 1~4가지 변형을 통해 캐릭터, 환경 및 시각적 방향을 탐색하세요." },
                    { name: "전자상거래용 Qwen Image 2.0 Pro", desc: "단일 세대로 목록 및 광고에 대한 다양한 이미지 변형을 생성합니다." }
                ],
                howToKicker: "세 가지 간단한 단계",
                howToTitle: "Qwen Image 2.0 Pro AI 이미지 생성기를 온라인으로 사용하는 방법",
                howToIntro: "긍정적인 프롬프트, 부정적인 프롬프트 및 유연한 출력 제어 기능을 갖춘 Miral에서 온라인으로 Qwen Image 2.0 Pro AI 이미지 생성기를 사용하세요.",
                howToSteps: [
                    { title: "기본 프롬프트를 입력하세요", desc: "원하는 주제, 장면, 구도, 조명, 스타일 및 시각적 세부 사항을 설명합니다." },
                    { title: "생성 제어 구성", desc: "필요한 경우 네거티브 프롬프트를 추가하고, 프롬프트 향상을 활성화하고, 크기를 선택하고, 1~4개의 이미지를 선택합니다." },
                    { title: "생성 및 비교", desc: "생성을 시작하고, 반환된 변형을 비교하고, 의도에 가장 일치하는 이미지를 다운로드하세요." }
                ],
                howToCta: "Qwen Image 2.0 Pro AI 이미지 생성기를 사용해 보세요",
                faqTitle: "Qwen Image 2.0 Pro에 대해 자주 묻는 질문",
                faqs: [
                    { q: "Qwen Image 2.0 Pro AI 이미지 생성기란 무엇입니까?", a: "Qwen Image 2.0 Pro는 Alibaba의 Tongyi Qwen 텍스트-이미지 변환 모델입니다. Qwen Image 2.0 Pro AI 이미지 생성기는 서면 프롬프트를 고품질의 상세한 이미지로 변환하며 Miral에서 브라우저에서 직접 예술, 디자인, 마케팅 및 제품 시각적 제작을 위해 사용할 수 있습니다." },
                    { q: "부정적인 메시지가 포함된 여러 제품 이미지 변형을 만들려면 어떤 도구를 사용할 수 있습니까?", a: "Qwen Image 2.0 Pro는 전용 네거티브 프롬프트, 선택적 프롬프트 향상, 실행당 1~4개의 이미지, 제품 사진, 마케팅 및 전자상거래 시각적 변형을 위한 유연한 종횡비를 제공합니다." },
                    { q: "Qwen Image 2.0 Pro AI 이미지 생성기를 무료로 사용할 수 있나요?", a: "그렇습니다. 무료 크레딧을 받으려면 등록하고 Qwen Image 2.0 Pro AI 이미지 생성기를 사용하여 즉시 고품질 이미지 생성을 시작하세요. 이미지 생성에는 해당 크레딧이 사용됩니다." },
                    { q: "Qwen Image 2.0 Pro AI 이미지 생성기를 온라인으로 어떻게 사용합니까?", a: "자세한 텍스트 프롬프트를 입력하고, 선택적으로 피해야 할 사항을 설명하는 네거티브 프롬프트를 추가하고, 필요한 경우 프롬프트 향상을 켜고, 종횡비 또는 사용자 정의 크기를 선택하고, 생성할 이미지 수(1-4)를 설정하고, 생성을 클릭하세요. Qwen Image 2.0 Pro는 마케팅 자료, 제품 사진, 인물 사진 및 포스터 디자인에 적합합니다." },
                    { q: "Qwen Image 2.0 Pro 결과에서 원치 않는 요소를 수정하는 방법은 무엇입니까?", a: "낮은 선명도, 변형된 손, 어수선한 배경 등 원하지 않는 요소를 설명하는 부정적인 프롬프트를 추가하세요. Qwen Image 2.0 Pro는 이를 사용하여 이러한 결과로부터 세대를 멀어지게 합니다." },
                    { q: "Qwen Image 2.0 Pro는 한 번에 몇 개의 이미지를 생성할 수 있습니까?", a: "Qwen Image 2.0 Pro는 단일 요청으로 최대 4개의 이미지(n = 1 ~ 4)를 생성할 수 있으므로 컨셉, 각도 또는 스타일의 변형을 비교하고 가장 적합한 이미지를 선택할 수 있습니다." },
                    { q: "Qwen Image 2.0 Pro는 어떤 크기와 종횡비를 지원합니까?", a: "Miral에서 Qwen Image 2.0 Pro는 2688×1536, 1536×2688, 2048×2048, 2368×1728 및 1728×2368과 같은 기성 비율과 512×512에서 최대 2048×2048까지의 사용자 정의 크기를 제공합니다. 여기에는 배너, 포스터, 소셜 게시물 및 썸네일에 대한 가로, 세로 및 정사각형 출력이 포함됩니다." },
                    { q: "최고의 Qwen Image 2.0 Pro 프롬프트 예는 무엇입니까?", a: "효과적인 Qwen Image 2.0 Pro 프롬프트는 피사체, 설정, 구도, 조명 및 스타일을 명확하게 설명하고 긍정적인 프롬프트와 부정적인 프롬프트를 결합하여 원하지 않는 세부 사항을 제거합니다. 이 페이지의 Qwen Image 2.0 Pro 프롬프트 예를 시작점으로 사용하고 프로젝트에 맞게 사용자 정의하세요." },
                    { q: "Qwen Image 2.0 Pro와 Midjourney: 어느 것을 사용해야 합니까?", a: "보편적인 승자가 아닌 작업 흐름을 기준으로 선택하세요. Qwen Image 2.0 Pro는 Miral의 브라우저 기반 생성기에서 명시적인 네거티브 프롬프트, 프롬프트 향상, 실행당 1~4개의 이미지 및 유연한 종횡비가 필요한 경우에 매우 적합합니다. Midjourney는 독특한 예술적 작업 흐름과 커뮤니티 도구를 선호하는 제작자에게 적합할 수 있습니다." }
                ],
                ctaTitle: "Miral에서 Qwen Image 2.0 Pro를 무료로 사용해 보세요!",
                ctaDesc: "위에 아이디어를 입력하고 선택적 컨트롤이 포함된 Qwen Image 2.0 Pro AI 이미지 생성기를 사용하여 정확한 이미지 변형을 만드세요."
            },
            stableDiffusion: {
                title: "Stable Diffusion 3.5 AI 이미지 생성기 무료 온라인 | 밀알",
                description: "Stable Diffusion 3.5를 사용하여 온라인으로 AI 이미지를 생성하세요. Miral에서는 네거티브 프롬프트, 사전 설정된 가로 세로 비율 및 512~2048픽셀의 사용자 정의 크기를 사용하세요.",
                heroHeadline: "Stable Diffusion 3.5 AI 이미지 생성기",
                heroIntro: "Miral AI에서 Stable Diffusion 3.5 AI 이미지 생성기를 무료로 사용해 보세요. 무료 크레딧을 받으려면 등록하고 자세한 프롬프트, 네거티브 프롬프트 및 유연한 크기를 갖춘 고품질 이미지를 빠르게 생성하세요.",
                eyebrow: "안정성 AI · 안정 확산 3.5",
                sectionKicker: "안정확산 3.5",
                ctaTag: "안정확산 3.5 · Miral",
                badges: ["텍스트를 이미지로", "부정적인 프롬프트", "유연한 종횡비", "사용자 정의 크기"],
                previewLabel: "안정확산 3.5",
                previewMeta: ["1:1", "512 – 2048", "64의 배수"],
                previewTitle: "상세한 프롬프트부터 제어되고 세련된 이미지까지",
                previewDesc: "긍정적인 메시지와 부정적인 메시지를 결합하고 올바른 화면비를 선택하여 Stable Diffusion 3.5를 깨끗하고 정확한 시각적 이미지로 전환하세요.",
                keyFeaturesTitle: "Stable Diffusion 3.5 텍스트-이미지 생성기를 사용하여 제어된 시각적 개체 생성",
                keyFeaturesIntro: "네거티브 프롬프트, 유연한 종횡비, 사용자 정의 크기 및 자세한 프롬프트 이해를 위한 주요 Stable Diffusion 3.5 AI 이미지 생성기 기능을 살펴보세요.",
                exploreTitle: "더 많은 AI 이미지 모델 살펴보기",
                mainFeaturesTitle: "주요 Stable Diffusion 3.5 기능",
                generatedImageLabel: "생성된 이미지",
                versionLabel: "제어",
                featureLabel: "무엇이 바뀌는가",
                useCaseLabel: "최고의 대상",
                variantsTitle: "안정 확산 3.5 출력 제어",
                variantsIntro: "Stable Diffusion 3.5 모델을 사전 설정된 종횡비 또는 필요한 최종 레이아웃에 따라 정확한 사용자 정의 치수와 결합하세요.",
                variants: [
                    { name: "안정확산 3.5", desc: "포지티브 및 네거티브 프롬프트 제어를 통한 상세한 텍스트-이미지 생성.", bestFor: "제품 시각 자료, 초상화, 컨셉 아트, 마케팅 이미지." },
                    { name: "사전 설정된 화면 비율", desc: "기성품 가로, 세로 및 정사각형 출력 크기.", bestFor: "소셜 게시물, 배너, 포스터, 썸네일." },
                    { name: "사용자 정의 이미지 크기", desc: "512에서 2048까지의 정확한 너비와 높이는 64의 배수입니다.", bestFor: "정확한 픽셀 크기가 필요한 레이아웃 슬롯 및 프로젝트." }
                ],
                controlsTitle: "올바른 프롬프트 컨트롤과 이미지 크기를 선택하세요",
                controlsIntro: "원하지 않는 세부 사항을 줄이기 위해 네거티브 프롬프트를 사용한 다음 사전 설정된 비율을 선택하거나 원하는 채널에 대한 사용자 정의 치수를 입력하십시오.",
                galleryTitle: "보다 안정적인 확산 3.5 이미지 예",
                discussionTitle: "일반적인 안정 확산 3.5 질문",
                communityTitle: "Stable Diffusion 3.5를 사용하여 생성하는 인기 있는 방법",
                tutorialPrompt: "창백한 돌 위에 조각 세라믹 스피커, 부드러운 아침 창문 빛, 사실적인 질감, 균형 잡힌 구성, 미묘한 그림자, 깨끗한 배경의 편집 제품 사진.",
                qualityBenefits: [
                    "부정적인 프롬프트를 사용하여 혼란, 잘못된 형식의 세부 사항 및 원치 않는 시각적 스타일을 줄이세요.",
                    "주제, 구도, 조명, 재료, 분위기에 대한 계층적 설명을 따르세요.",
                    "사전 설정이나 정밀한 사용자 정의 치수를 사용하여 가로, 세로 및 정사각형 이미지를 만듭니다."
                ],
                features: [
                    { name: "부정적인 프롬프트 컨트롤", short: "보다 명확하고 목표에 맞는 결과를 얻으려면 무엇을 제외해야 하는지 설명하세요.", desc: "Stable Diffusion 3.5 AI 이미지 생성기는 전용 네거티브 프롬프트를 지원하므로 낮은 선명도, 변형된 손 또는 어수선한 배경 등 피해야 할 사항을 모델에 알려줄 수 있습니다. 이렇게 하면 최종 이미지를 보다 세밀하게 제어할 수 있고 반복적으로 다시 롤링할 필요성이 줄어듭니다.", demo: { type: 'table', rows: [
                        { prompt: "대리석 받침대 위에 놓인 무광 블랙 세라믹 꽃병, 부드러운 스튜디오 조명, 깨끗한 배경의 프리미엄 제품 사진입니다. (부정적: 어수선한 배경, 낮은 해상도, 변형된 반사.)", image: require('@/assets/images/stableDiffusion/1783501013638.webp') },
                        { prompt: "부드러운 창문 빛, 자연스러운 피부 질감, 얕은 심도를 지닌 젊은 남자의 초상화. (부정적: 지나치게 매끈한 피부, 왁스 같은 느낌, 과포화 색상.)", image: require('@/assets/images/stableDiffusion/1783501332038.webp') }
                    ] } },
                    { name: "유연한 종횡비", short: "가로, 세로, 정사각형 또는 맞춤 크기를 선택하세요.", desc: "1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536, 1536×1536 등 미리 만들어진 화면비 중에서 선택하거나 512×512에서 1536×1536까지 사용자 정의 크기를 입력하세요. 2048×2048. 따라서 Stable Diffusion 3.5 텍스트-이미지 생성기는 배너, 포스터, 소셜 게시물 및 정사각형 썸네일 모두에 적합합니다.", prompt: "황금 시간의 해안 절벽, 드라마틱한 구름, 섬세한 암석 디테일을 담은 영화 같은 넓은 풍경 사진, 1536×896.", image: require('@/assets/images/stableDiffusion/1783501396803.webp') },
                    { name: "사용자 정의 이미지 크기", short: "정확한 출력을 위해 정확한 픽셀 크기를 설정합니다.", desc: "사전 설정이 맞지 않으면 사용자 정의 크기로 전환하고 512에서 2048 사이의 너비와 높이를 64의 배수로 입력하세요. 이렇게 하면 수동으로 자르지 않고도 특정 레이아웃, 배너 슬롯 또는 인쇄 비율을 일치시킬 수 있습니다.", prompt: "중심 기하학적 구성, 짙은 파란색 그라데이션, 미묘한 결, 1280×1280을 갖춘 미니멀리스트 포스터 배경입니다.", image: require('@/assets/images/stableDiffusion/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.webp') },
                    { name: "자세한 프롬프트 이해", short: "주제, 조명, 스타일에 대한 계층적 설명을 따릅니다.", desc: "Stable Diffusion 3.5는 계층화된 텍스트 지침을 읽고 사용자가 설명하는 주제, 설정, 조명 및 분위기를 렌더링합니다. 명확한 긍정적 프롬프트와 부정적인 프롬프트를 결합하면 더 적은 시도로 결과가 의도에 더 가까워지도록 할 수 있습니다.", demo: { type: 'table', rows: [
                        { prompt: "접힌 린넨과 세라믹 컵 옆에 있는 손목시계의 편집 제품 사진, 균형 잡힌 삼각형 구성, 부드러운 아침 햇살.", image: require('@/assets/images/stableDiffusion/1783501741652.webp') },
                        { prompt: "비오는 창가의 아늑한 독서 공간, 따뜻한 램프 조명, 쌓여 있는 책, 질감이 있는 담요, 영화 같은 분위기.", image: require('@/assets/images/stableDiffusion/1783501817217.webp') }
                    ] } },
                    { name: "세련된 디테일과 현실감", short: "사실적인 조명, 재질, 깊이를 렌더링합니다.", desc: "Stable Diffusion 3.5는 미세한 질감, 사실적인 조명 및 자연스러운 깊이를 생성하므로 Stable Diffusion 3.5 AI 이미지 생성기는 신뢰성이 중요한 제품 사진, 인물 사진, 컨셉 아트 및 편집용 비주얼에 적합합니다.", prompt: "햇볕이 잘 드는 작업장에 있는 나이든 도예가의 클로즈업 편집 초상화, 자연스러운 피부 질감, 손에 묻은 점토 먼지, 따뜻한 창문 조명, 얕은 심도.", image: require('@/assets/images/stableDiffusion/021783502374347ebd7c24e3cae4a4b683f52566c3e30e2cb26b5_0.webp') }
                ],
                showcaseKicker: "프롬프트 예시",
                showcaseTitle: "더 나은 AI 이미지를 위한 Stable Diffusion 3.5 프롬프트 예",
                showcaseIntro: "이러한 Stable Diffusion 3.5 프롬프트 예제를 시작점으로 사용하세요. 주제, 구성, 조명 및 스타일을 명확하게 설명하고 각 프롬프트를 부정적인 프롬프트와 짝을 맞춘 다음 생성기로 직접 보냅니다.",
                useCasesKicker: "실제 업무용으로 제작됨",
                useCasesTitle: "인기 있는 Stable Diffusion 3.5 사용 사례",
                useCases: [
                    { name: "제품 사진 촬영을 위한 Stable Diffusion 3.5", desc: "네거티브 프롬프트를 사용하여 배경이 통제된 깔끔한 제품 사진을 만들어 어수선함을 제거하세요." },
                    { name: "마케팅을 위한 Stable Diffusion 3.5", desc: "다양한 화면비에 걸쳐 캠페인 컨셉, 소셜 광고 및 배너를 생성합니다." },
                    { name: "포스터 및 레이아웃을 위한 Stable Diffusion 3.5", desc: "맞춤형 픽셀 크기로 포스터 배경과 레이아웃에 바로 사용할 수 있는 영상을 제작하세요." },
                    { name: "인물 사진용 Stable Diffusion 3.5", desc: "아티팩트를 방지하기 위해 네거티브 프롬프트를 사용하여 자연스러운 피부 질감으로 상세한 인물 사진을 생성합니다." },
                    { name: "컨셉 아트를 위한 Stable Diffusion 3.5", desc: "계층화된 프롬프트를 통해 캐릭터, 환경 및 시각적 방향을 탐색하세요." },
                    { name: "소셜 콘텐츠를 위한 Stable Diffusion 3.5", desc: "다양한 소셜 플랫폼에 적합한 크기의 정사각형, 세로 및 가로 이미지를 만듭니다." }
                ],
                howToKicker: "세 가지 간단한 단계",
                howToTitle: "Stable Diffusion 3.5 AI 이미지 생성기를 온라인으로 사용하는 방법",
                howToIntro: "명확한 프롬프트, 네거티브 프롬프트 및 프로젝트에 필요한 종횡비를 사용하여 Miral에서 온라인으로 Stable Diffusion 3.5 AI 이미지 생성기를 사용하세요.",
                howToSteps: [
                    { title: "기본 프롬프트를 입력하세요", desc: "원하는 주제, 장면, 구도, 조명, 스타일 및 시각적 세부 사항을 설명합니다." },
                    { title: "생성 제어 구성", desc: "필요한 경우 네거티브 프롬프트를 추가한 다음 미리 만들어진 종횡비를 선택하거나 사용자 정의 크기를 입력하세요." },
                    { title: "생성 및 검토", desc: "생성을 시작하고 결과를 검토한 후 이미지를 다운로드하거나 다른 단계에 대한 프롬프트를 조정하세요." }
                ],
                howToCta: "Stable Diffusion 3.5 AI 이미지 생성기를 사용해 보세요",
                faqTitle: "Stable Diffusion 3.5에 대해 자주 묻는 질문",
                faqs: [
                    { q: "Stable Diffusion 3.5 AI 이미지 생성기란 무엇입니까?", a: "Stable Diffusion 3.5는 Stability AI의 텍스트-이미지 모델입니다. Stable Diffusion 3.5 AI 이미지 생성기는 작성된 메시지를 자세한 이미지로 변환하고 Miral에서 브라우저에서 직접 예술, 디자인, 마케팅 및 제품 시각적 제작을 위해 사용할 수 있습니다." },
                    { q: "네거티브 프롬프트가 포함된 사용자 정의 크기 이미지를 만들려면 어떤 도구를 사용할 수 있나요?", a: "Stable Diffusion 3.5는 제품 사진, 마케팅 영상, 인물 사진 및 컨셉 아트를 위해 전용 네거티브 프롬프트, 기성 화면 비율 및 512에서 2048까지의 사용자 정의 크기를 제공합니다." },
                    { q: "Stable Diffusion 3.5 AI 이미지 생성기를 무료로 사용할 수 있나요?", a: "그렇습니다. 무료 크레딧을 받으려면 등록하고 Stable Diffusion 3.5 AI 이미지 생성기를 사용하여 즉시 고품질 이미지 생성을 시작하세요. 이미지 생성에는 해당 크레딧이 사용됩니다." },
                    { q: "Stable Diffusion 3.5 AI 이미지 생성기를 온라인에서 어떻게 사용합니까?", a: "자세한 텍스트 프롬프트를 입력하고 선택적으로 피해야 할 사항을 설명하는 네거티브 프롬프트를 추가하고 미리 만들어진 가로 세로 비율을 선택하거나 사용자 정의 크기를 입력하고 생성을 클릭합니다. Stable Diffusion 3.5는 마케팅 자료, 제품 사진, 인물 사진 및 포스터 레이아웃에 적합합니다." },
                    { q: "Stable Diffusion 3.5 이미지에서 원하지 않거나 변형된 세부 사항을 수정하는 방법은 무엇입니까?", a: "낮은 선명도, 변형된 손, 어수선한 배경 등 원하지 않는 요소를 설명하는 부정적인 프롬프트를 추가하세요. Stable Diffusion 3.5는 이를 사용하여 이러한 결과로부터 생성을 방지합니다." },
                    { q: "Stable Diffusion 3.5는 어떤 크기와 종횡비를 지원합니까?", a: "Miral에서 Stable Diffusion 3.5는 1024×1024, 1280×1280, 896×1536, 1536×896, 768×1344, 1344×768, 1024×1536 및 1536×1536과 같은 기성 비율과 사용자 정의 크기를 제공합니다. 512×512에서 최대 2048×2048(64의 배수). 여기에는 배너, 포스터, 소셜 게시물 및 썸네일에 대한 가로, 세로 및 정사각형 출력이 포함됩니다." },
                    { q: "최고의 Stable Diffusion 3.5 프롬프트 예는 무엇입니까?", a: "Effective Stable Diffusion 3.5 프롬프트는 주제, 설정, 구성, 조명 및 스타일을 명확하게 설명하고 긍정적인 프롬프트와 부정적인 프롬프트를 결합하여 원하지 않는 세부 사항을 제거합니다. 이 페이지의 Stable Diffusion 3.5 프롬프트 예제를 시작점으로 사용하고 프로젝트에 맞게 사용자 정의하세요." },
                    { q: "Stable Diffusion 3.5와 Midjourney: 어느 것을 사용해야 합니까?", a: "보편적인 승자가 아닌 작업 흐름을 기준으로 선택하세요. Stable Diffusion 3.5는 Miral의 브라우저 기반 생성기에서 명시적 네거티브 프롬프트, 기성 화면 비율 및 사용자 정의 픽셀 크기가 필요한 경우에 매우 적합합니다. Midjourney는 독특한 예술적 작업 흐름과 커뮤니티 도구를 선호하는 제작자에게 적합할 수 있습니다." }
                ],
                ctaTitle: "Miral에서 Stable Diffusion 3.5를 무료로 사용해 보세요!",
                ctaDesc: "위에 아이디어를 입력하고 네거티브 프롬프트와 유연한 크기를 갖춘 Stable Diffusion 3.5 AI 이미지 생성기를 사용하여 제어된 시각적 개체를 만드세요."
            },
            zImageTurbo: {
                title: "Z 이미지 터보 AI 이미지 생성기 무료 온라인 | 밀알",
                description: "Z Image Turbo를 사용하여 온라인으로 고품질 AI 이미지를 생성하세요. 프롬프트를 확장하고, 유연한 종횡비를 선택하고, 맞춤 크기를 설정하고, Miral에서 시드를 제어하세요.",
                heroHeadline: "Z 이미지 터보 AI 이미지 생성기",
                heroIntro: "Miral AI에서 Z Image Turbo AI 이미지 생성기를 무료로 사용해 보세요. 무료 크레딧을 받으려면 등록하고 신속한 확장, 유연한 종횡비 및 시드 제어를 통해 고품질 이미지를 빠르게 생성하세요.",
                eyebrow: "Z 이미지 터보",
                sectionKicker: "Z 이미지 터보",
                ctaTag: "Z 이미지 터보 · Miral",
                badges: ["텍스트를 이미지로", "프롬프트 확장", "유연한 종횡비", "사용자 정의 크기", "종자 관리"],
                previewLabel: "Z 이미지 터보",
                previewMeta: ["1:1", "512 – 2048", "종자 관리"],
                previewTitle: "짧은 프롬프트부터 세련된 고해상도 비주얼까지",
                previewDesc: "프롬프트 확장을 통해 간단한 아이디어를 강화하고, 올바른 종횡비를 선택하고, 시드를 재사용하여 이미지 전체에서 일관된 스타일을 유지할 수 있습니다.",
                keyFeaturesTitle: "Z 이미지 터보 텍스트-이미지 생성기를 사용하여 세련된 비주얼 만들기",
                keyFeaturesIntro: "신속한 확장, 유연한 종횡비, 사용자 정의 크기 및 시드 기반 일관성을 위한 주요 Z Image Turbo AI 이미지 생성기 기능을 살펴보세요.",
                exploreTitle: "더 많은 AI 이미지 모델 살펴보기",
                mainFeaturesTitle: "주요 Z 이미지 터보 기능",
                generatedImageLabel: "생성된 이미지",
                versionLabel: "제어",
                featureLabel: "무엇이 바뀌는가",
                useCaseLabel: "최고의 대상",
                variantsTitle: "Z 이미지 터보 생성 제어",
                variantsIntro: "프로젝트에 필요한 세부 사항과 시각적 일관성에 따라 프롬프트 확장, 유연한 치수 및 시드 제어를 결합합니다.",
                variants: [
                    { name: "Z 이미지 터보", desc: "상세한 고해상도 출력으로 텍스트를 이미지로 빠르게 생성합니다.", bestFor: "제품 시각 자료, 초상화, 컨셉 아트, 마케팅 이미지." },
                    { name: "프롬프트 확장", desc: "시각적 세부정보를 추가하여 짧은 프롬프트를 자동으로 강화합니다.", bestFor: "빠른 아이디어를 보다 완전한 생성 지침으로 전환합니다." },
                    { name: "종자 관리", desc: "다른 설정을 구체화하는 동안 동일한 시작 시드를 재사용합니다.", bestFor: "이미지 변형이나 캠페인 전반에 걸쳐 조화로운 스타일을 유지합니다." }
                ],
                controlsTitle: "올바른 프롬프트, 크기 및 시드 설정 선택",
                controlsIntro: "아이디어에 더 자세한 내용이 필요할 때 프롬프트 확장을 활성화하고, 의도한 출력 크기를 선택하고, 시각적 일관성이 중요한 경우 시드를 재사용하세요.",
                galleryTitle: "더 많은 Z 이미지 터보 이미지 예시",
                discussionTitle: "일반적인 Z 이미지 터보 질문",
                communityTitle: "Z Image Turbo로 제작하는 인기 있는 방법",
                tutorialPrompt: "밝은 건축 스튜디오에 전시된 소형 전기 스쿠터, 창백한 콘크리트 바닥, 부드러운 채광창, 세련된 제품 사진, 균형 잡힌 구성, 사실적인 재료.",
                qualityBenefits: [
                    "모든 시각적 세부 사항을 수동으로 다시 작성하지 않고도 짧은 아이디어를 더욱 풍부한 프롬프트로 확장할 수 있습니다.",
                    "최종 채널에 대해 가로, 세로, 정사각형 또는 정확한 맞춤 크기를 선택하세요.",
                    "시드를 재사용하여 반복 전반에 걸쳐 조명, 팔레트 및 구성의 일관성을 유지합니다."
                ],
                features: [
                    { name: "프롬프트 확장", short: "선택적으로 짧은 프롬프트를 더 자세한 내용으로 확장합니다.", desc: "프롬프트 확장을 켜면 Z Image Turbo가 생성 전에 추가 세부정보로 간단한 프롬프트를 자동으로 강화합니다. 이를 통해 수동으로 다시 작성하지 않고도 짧거나 간단한 프롬프트를 통해 더욱 완전하고 생생한 이미지를 생성할 수 있습니다.", demo: { type: 'table', rows: [
                        { prompt: "화성 표면의 열대식물이 가득한 유리온실.", image: require('@/assets/images/zImageTurbo/b1057f7b-3e0e-9687-aa55-56cfed42147a0.webp') },
                        { prompt: "빈티지 기차 객차 안에 지어진 작은 장인 빵집입니다.", image: require('@/assets/images/zImageTurbo/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.webp') }
                    ] } },
                    { name: "유연한 종횡비", short: "가로, 세로, 정사각형 또는 맞춤 크기를 선택하세요.", desc: "1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536, 1536×1536 등 미리 만들어진 화면비 중에서 선택하거나 512×512에서 1536×1536까지 사용자 정의 크기를 입력하세요. 2048×2048. 따라서 Z Image Turbo 텍스트-이미지 생성기는 배너, 포스터, 소셜 게시물 및 사각형 썸네일 모두에 적합합니다.", prompt: "비가 내리는 도쿄 야시장의 초광각 조감도, 빛나는 종이등, 붐비는 음식 가판대, 반사되는 거리, 영화 같은 분위기, 1536×864.", image: require('@/assets/images/zImageTurbo/b2964bd5-066f-90b6-8c86-91dad79e44120.webp') },
                    { name: "사용자 정의 이미지 크기", short: "정확한 출력을 위해 정확한 픽셀 크기를 설정합니다.", desc: "사전 설정이 맞지 않으면 사용자 정의 크기로 전환하고 512에서 2048 사이의 너비와 높이를 입력하세요. 이렇게 하면 수동으로 자르지 않고도 특정 레이아웃, 배너 슬롯 또는 인쇄 측면을 일치시킬 수 있습니다.", prompt: "세로형 식물 전시 포스터, 오버사이즈 오렌지 타이포그래피, 희귀한 열대 나뭇잎, 따뜻한 회백색 종이 질감, 정밀한 편집 그리드, 1152×1728.", image: require('@/assets/images/zImageTurbo/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.webp') },
                    { name: "일관성을 위한 시드 제어", short: "시드를 재사용하여 이미지 전반에 걸쳐 안정적인 스타일을 유지하세요.", desc: "고정 시드(0 ~ 2147483647)를 설정하면 Z Image Turbo AI 이미지 생성기가 실행 전반에 걸쳐 동일한 시작점을 사용하므로 프롬프트를 수정하는 동안 일관된 모양을 더 쉽게 유지할 수 있습니다. 매번 새로운 무작위 결과를 얻으려면 시드를 0으로 두십시오.", prompt: "옅은 녹색 돌 위에 반투명 유리병 3개, 부드러운 확산광, 유칼립투스 액센트를 특징으로 하는 조화로운 스킨케어 캠페인입니다. 동일한 씨앗을 재사용하여 제품 시리즈 전반에 걸쳐 조명, 팔레트 및 구성을 보존합니다.", image: require('@/assets/images/zImageTurbo/f688ab6d-a723-969d-8df1-fbac721e66350.webp') },
                    { name: "세련된 디테일과 현실감", short: "사실적인 조명, 재질, 깊이를 렌더링합니다.", desc: "Z Image Turbo는 미세한 질감, 사실적인 조명 및 자연스러운 깊이를 생성하므로 신뢰성이 중요한 제품 사진, 인물 사진, 컨셉 아트 및 편집용 영상에 적합합니다.", prompt: "조용한 작업장에서 단풍나무 다리를 조각하는 바이올린 제작자의 모습을 클로즈업한 다큐멘터리, 고운 나무 부스러기, 낡은 수공구, 자연스러운 피부 질감, 북쪽 창문의 부드러운 빛, 얕은 피사계 심도.", image: require('@/assets/images/zImageTurbo/715e19f5-fea4-9361-a1e3-0f04d595db660.webp') }
                ],
                showcaseKicker: "프롬프트 예시",
                showcaseTitle: "더 나은 AI 이미지를 위한 Z 이미지 터보 프롬프트 예",
                showcaseIntro: "Z Image Turbo 프롬프트 예를 시작점으로 사용하세요. 주제, 구성, 조명 및 스타일을 명확하게 설명하고 선택적으로 프롬프트 확장을 활성화한 다음 생성기로 직접 보냅니다.",
                useCasesKicker: "실제 업무용으로 제작됨",
                useCasesTitle: "인기 있는 Z Image Turbo 사용 사례",
                useCases: [
                    { name: "제품 사진을 위한 Z 이미지 터보", desc: "일관된 모습을 위해 배경이 통제되고 고정된 시드를 사용하여 깔끔한 제품 사진을 만드세요." },
                    { name: "마케팅을 위한 Z Image Turbo", desc: "다양한 화면비에 걸쳐 캠페인 컨셉, 소셜 광고 및 배너를 생성합니다." },
                    { name: "포스터 및 레이아웃을 위한 Z Image Turbo", desc: "맞춤형 픽셀 크기로 포스터 배경과 레이아웃에 바로 사용할 수 있는 영상을 제작하세요." },
                    { name: "인물 사진용 Z 이미지 터보", desc: "자연스러운 피부 질감과 실제와 같은 조명으로 디테일한 인물 사진을 생성해 보세요." },
                    { name: "컨셉 아트를 위한 Z 이미지 터보", desc: "계층화된 프롬프트를 통해 캐릭터, 환경 및 시각적 방향을 탐색하세요." },
                    { name: "소셜 콘텐츠용 Z 이미지 터보", desc: "다양한 소셜 플랫폼에 적합한 크기의 정사각형, 세로 및 가로 이미지를 만듭니다." }
                ],
                howToKicker: "세 가지 간단한 단계",
                howToTitle: "Z Image Turbo AI 이미지 생성기를 온라인으로 사용하는 방법",
                howToIntro: "명확한 프롬프트, 선택적 프롬프트 확장 및 프로젝트에 필요한 종횡비를 갖춘 Miral에서 온라인으로 Z Image Turbo AI 이미지 생성기를 사용하세요.",
                howToSteps: [
                    { title: "기본 프롬프트를 입력하세요", desc: "원하는 주제, 장면, 구도, 조명, 스타일 및 시각적 세부 사항을 설명합니다." },
                    { title: "생성 제어 구성", desc: "선택적으로 프롬프트 확장을 활성화하고 미리 만들어진 종횡비를 선택하거나 사용자 정의 크기를 입력하고 일관성을 원한다면 시드를 설정하십시오." },
                    { title: "생성 및 검토", desc: "생성을 시작하고 결과를 검토한 후 이미지를 다운로드하거나 다른 단계에 대한 프롬프트를 조정하세요." }
                ],
                howToCta: "Z Image Turbo AI 이미지 생성기를 사용해 보세요",
                faqTitle: "Z Image Turbo에 대해 자주 묻는 질문",
                faqs: [
                    { q: "Z Image Turbo AI 이미지 생성기란 무엇입니까?", a: "Z Image Turbo는 고해상도 이미지 생성을 위한 텍스트-이미지 모델입니다. Z Image Turbo AI 이미지 생성기는 작성된 프롬프트를 상세한 이미지로 변환하고 Miral에서 브라우저에서 직접 예술, 디자인, 마케팅 및 제품 시각적 제작에 사용할 수 있습니다." },
                    { q: "일관된 제품 이미지 시리즈를 만들려면 어떤 도구를 사용할 수 있나요?", a: "Z Image Turbo는 신속한 확장, 유연한 이미지 크기 및 시드 제어를 결합하여 일관된 제품 사진 또는 마케팅 영상 시리즈를 만드는 데 도움을 줍니다." },
                    { q: "Z Image Turbo AI 이미지 생성기를 무료로 사용할 수 있나요?", a: "그렇습니다. 무료 크레딧을 받으려면 등록하고 Z Image Turbo AI 이미지 생성기를 사용하여 즉시 고품질 이미지 생성을 시작하세요. 이미지 생성에는 해당 크레딧이 사용됩니다." },
                    { q: "Z Image Turbo AI 이미지 생성기를 온라인으로 어떻게 사용합니까?", a: "자세한 텍스트 프롬프트를 입력하고, 선택적으로 프롬프트 확장을 켜고, 미리 만들어진 가로세로 비율을 선택하거나 사용자 정의 크기를 입력하고, 일관된 모양을 원할 경우 시드를 설정하고 생성을 클릭하세요. Z Image Turbo는 마케팅 자료, 제품 사진, 인물 사진 및 포스터 레이아웃에 적합합니다." },
                    { q: "Z Image Turbo의 프롬프트 확장이란 무엇입니까?", a: "프롬프트 확장은 Z Image Turbo가 생성하기 전에 추가 세부 정보로 짧거나 간단한 프롬프트를 자동으로 강화할 수 있게 해주는 옵션 스위치입니다. 이를 통해 전문가가 아닌 프롬프트에서도 수동으로 다시 작성하지 않고도 더욱 완전하고 생생한 이미지를 생성할 수 있습니다." },
                    { q: "Z Image Turbo에서 일관되지 않은 결과를 수정하는 방법은 무엇입니까?", a: "이미지 전체에서 일관된 스타일을 유지하는 데 도움이 되도록 다른 매개변수를 조정하는 동시에 동일한 시드를 재사용합니다. 매번 새로운 무작위 결과를 원하는 경우에만 시드를 0으로 두십시오." },
                    { q: "Z Image Turbo는 어떤 크기와 종횡비를 지원합니까?", a: "Miral에서 Z Image Turbo는 1024×1024, 1280×1280, 864×1536, 1536×864, 720×1280, 1280×720, 1024×1536 및 1536×1536과 같은 미리 만들어진 비율과 512×512에서 최대 512×512까지의 사용자 정의 크기를 제공합니다. 2048×2048. 여기에는 배너, 포스터, 소셜 게시물 및 썸네일에 대한 가로, 세로 및 정사각형 출력이 포함됩니다." },
                    { q: "최고의 Z Image Turbo 프롬프트 예는 무엇입니까?", a: "효과적인 Z 이미지 터보 프롬프트는 피사체, 설정, 구도, 조명 및 스타일을 명확하게 설명합니다. 짧은 아이디어의 경우 모델이 프롬프트를 자동으로 강화할 수 있도록 프롬프트 확장을 활성화합니다. 이 페이지의 Z Image Turbo 프롬프트 예제를 시작점으로 사용하여 프로젝트에 맞게 사용자 정의하세요." }
                ],
                ctaTitle: "Miral에서 Z Image Turbo를 무료로 사용해 보세요!",
                ctaDesc: "위에 아이디어를 입력하고 신속한 확장, 유연한 크기, 시드 제어 기능을 갖춘 Z Image Turbo AI 이미지 생성기를 사용하여 세련된 비주얼을 만드세요."
            },
            midjourney: {
                title: "Midjourney AI 이미지 생성기 무료 온라인 | 밀알",
                description: "Miral AI에서 Midjourney를 사용하여 온라인으로 AI 아트를 만들어 보세요. 사실적인 스타일이나 애니메이션 스타일을 선택하고, 참조 이미지로 결과를 안내하고, 텍스트 프롬프트를 생생한 시각적 요소로 바꿔보세요.",
                heroHeadline: "Midjourney AI 이미지 생성기",
                heroIntro: "Miral AI에서 Midjourney AI 이미지 생성기를 무료로 사용해 보세요. 무료 크레딧을 받고 사실적 또는 애니메이션 스타일과 선택적 참조 이미지 안내를 통해 고품질 이미지를 즉시 생성하려면 등록하세요.",
                eyebrow: "중간 여정",
                sectionKicker: "중간 여정",
                ctaTag: "미드저니 · 밀랄",
                badges: ["텍스트를 이미지로", "현실감 넘치는 애니메이션 스타일", "참조 이미지 안내", "예술적 방향"],
                previewLabel: "중간 여정",
                previewMeta: ["현실적", "애니메이션", "최대 5개 참조"],
                previewTitle: "생생한 프롬프트부터 영화적이고 예술적인 이미지까지",
                previewDesc: "스타일을 선택하고, 분위기와 조명을 설명하고, Midjourney를 통해 컨셉, 포스터 또는 캐릭터의 예술적인 모습을 만들어 보세요.",
                keyFeaturesTitle: "Midjourney 텍스트-이미지 생성기를 사용하여 예술적인 시각 자료 만들기",
                keyFeaturesIntro: "스타일 전환, 참조 이미지 안내 및 풍부한 예술적 방향을 위한 주요 Midjourney AI 이미지 생성기 기능을 살펴보세요.",
                features: [
                    { name: "현실적이고 애니메이션 스타일", short: "한 번의 탭으로 시각적 스타일을 전환하세요.", desc: "Miral의 Midjourney AI 이미지 생성기는 현실감과 애니메이션이라는 두 가지 기성 스타일을 노출합니다. 사진 같은 디테일, 자연광, 실제와 같은 질감을 원하면 사실적을 선택하고, 양식화된 선, 대담한 색상, 손으로 그린 ​​느낌을 원하면 애니메이션을 선택하세요. 스타일은 패널에서 선택되므로 프롬프트는 장면 자체에 집중할 수 있습니다.", demo: { type: 'table', rows: [
                        { prompt: "일출 때 안개 낀 산등성이 가장자리에 서 있는 고독한 여행자, 체적 조명, 영화 같은 와이드 샷, 고급 패브릭 및 바위 디테일.", image: require('@/assets/images/midjourney/1783505533006329.webp') },
                        { prompt: "황혼녘 옥상에 있는 결단력 있는 젊은 여검사, 흐르는 머리카락, 빛나는 랜턴, 표현력이 풍부한 애니메이션 라인 작업, 생생한 셀 셰이딩.", image: require('@/assets/images/midjourney/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.webp') }
                    ] } },
                    { name: "참조 이미지 안내", short: "모양을 조정하려면 최대 5개의 이미지를 업로드하세요.", desc: "최대 5개의 참조 이미지(PNG, JPG, JPEG 또는 WebP)를 사용하여 Midjourney AI 이미지 생성기를 안내합니다. 이를 사용하여 색상 팔레트, 캐릭터 모양, 제품 모양 또는 전체적인 미학을 전달하여 결과가 텍스트 자체가 아닌 참조 방향에 더 가깝게 유지되도록 합니다.", prompt: "업로드된 레퍼런스의 무드와 팔레트와 어울리는 대리석 받침대 위의 무광 블랙 세라믹 꽃병, 부드러운 스튜디오 조명, 깔끔한 배경의 프리미엄 제품 사진입니다.", image: require('@/assets/images/midjourney/1783506116812275.webp') },
                    { name: "영화 같은 조명과 분위기", short: "극적인 빛, 분위기, 깊이를 렌더링합니다.", desc: "Midjourney는 예술적인 조명과 분위기로 유명합니다. 골든 아워, 네온 불빛, 안개, 림 라이트 또는 촛불을 설명하면 모델은 포스터, 주요 아트 및 컨셉 비주얼에 어울리는 영화 같은 모습을 연출합니다.", demo: { type: 'table', rows: [
                        { prompt: "비에 젖은 밤의 네온 골목, 반사되는 웅덩이, 멀리서 보이는 부드러운 보케, 변덕스러운 영화적 분위기, 우산을 들고 있는 한 인물.", image: require('@/assets/images/midjourney/1783506281563151.webp') },
                        { prompt: "옥상에 있는 음악가의 황금시간 초상화, 따뜻한 백라이트, 렌즈 플레어, 얕은 피사계 심도, 필름 그레인.", image: require('@/assets/images/midjourney/1783506420066100.webp') }
                    ] } },
                    { name: "캐릭터 및 컨셉 아트", short: "표현력이 풍부한 캐릭터와 세계를 구축하세요.", desc: "Midjourney 텍스트-이미지 생성기는 캐릭터 디자인, 판타지 장면 및 컨셉 아트에 매우 적합합니다. 캐릭터의 포즈, 의상, 표정, 설정을 설명하고 스타일을 선택한 다음 원하는 모습이 나올 때까지 반복합니다.", prompt: "여러 겹의 여행 망토를 입고 황동 랜턴과 빛나는 약병, 고대 숲길, 얼룩덜룩한 빛, 복잡한 의상 디테일을 들고 방황하는 연금술사.", image: require('@/assets/images/midjourney/1783506547640511.webp') },
                    { name: "포스터 및 편집 예술", short: "눈에 띄는 레이아웃과 주요 시각적 요소를 제작하세요.", desc: "캠페인 핵심 아트부터 에디토리얼 일러스트레이션까지 Midjourney는 대담한 구성과 세련된 미학을 선보입니다. 명확한 초점 주제와 설명된 분위기를 결합하고 모델이 마케팅 및 편집 용도로 예술적인 시각 효과를 제공하도록 하세요.", prompt: "빛나는 열대 꽃 위를 맴돌고 있는 벌새의 대담한 캠페인 키 비주얼, 포화된 보석 톤, 깔끔한 네거티브 공간, 고대비 스튜디오 조명.", image: require('@/assets/images/midjourney/55889f96-30d2-4032-9340-2d27090394e6.webp') }
                ],
                showcaseKicker: "프롬프트 예시",
                showcaseTitle: "더 나은 AI 이미지를 위한 중간 단계 프롬프트 예",
                showcaseIntro: "이러한 중간 여정 프롬프트 예시를 출발점으로 사용하세요. 장면의 주제, 분위기, 조명 및 스타일을 설명한 다음 패널에서 사실적 또는 애니메이션을 선택하여 생성기로 보냅니다.",
                useCasesKicker: "실제 업무용으로 제작됨",
                useCasesTitle: "인기 있는 중간 사용 사례",
                useCases: [
                    { name: "컨셉 아트를 위한 중간 여정", desc: "예술적인 조명과 분위기로 캐릭터, 판타지 세계, 시각적 방향을 구축해 보세요." },
                    { name: "주요 아트 및 포스터를 위한 중간 여정", desc: "세련된 룩으로 대담한 캠페인 키 비주얼, 포스터, 편집 일러스트레이션을 제작해 보세요." },
                    { name: "제품 및 브랜드 비주얼의 중간 과정", desc: "일관성을 위해 참조 이미지를 바탕으로 프리미엄 제품 컨셉과 브랜드 이미지를 형성하세요." },
                    { name: "초상화를 위한 중간 여정", desc: "자연광, 필름 그레인 또는 스타일화된 애니메이션 음영을 사용하여 영화 같은 인물 사진을 생성합니다." },
                    { name: "애니메이션과 일러스트레이션의 중간 여정", desc: "표현력 있는 선 작업, 대담한 색상 및 손으로 그린 캐릭터를 위해 애니메이션 스타일로 전환하세요." },
                    { name: "소셜 콘텐츠를 위한 중간 여정", desc: "피드, 썸네일, 창의적인 소셜 게시물을 위한 눈에 띄고 공유 가능한 시각적 자료를 제작하세요." }
                ],
                howToKicker: "세 가지 간단한 단계",
                howToTitle: "Midjourney AI 이미지 생성기를 온라인으로 사용하는 방법",
                howToIntro: "Miral에서 온라인으로 Midjourney AI 이미지 생성기를 사용하여 생생한 프롬프트, 선택한 스타일 및 선택적 참조 이미지를 제공합니다.",
                howToSteps: [
                    { title: "장면을 설명하세요", desc: "주제, 설정, 분위기, 조명, 원하는 예술적인 모습을 다루는 생생한 프롬프트를 작성하세요." },
                    { title: "스타일 및 참조 선택", desc: "패널에서 사실적 또는 애니메이션을 선택하고 선택적으로 최대 5개의 참조 이미지를 업로드하여 모양을 안내하세요." },
                    { title: "생성 및 개선", desc: "생성을 시작하고, 결과를 검토하고, 이미지를 다운로드하거나 다른 패스에 대한 프롬프트와 참조를 조정하세요." }
                ],
                howToCta: "Midjourney AI 이미지 생성기를 사용해 보세요",
                faqTitle: "Midjourney에 대해 자주 묻는 질문",
                faqs: [
                    { q: "Midjourney AI 이미지 생성기란 무엇입니까?", a: "Midjourney는 예술 감독의 영화적 영상으로 잘 알려진 텍스트-이미지 변환 모델로 널리 사용됩니다. Miral의 Midjourney AI 이미지 생성기는 서면 프롬프트를 브라우저에서 직접 컨셉 아트, 주요 시각적 요소, 포스터 및 편집 작업을 위한 눈에 띄는 이미지로 변환합니다." },
                    { q: "참조 이미지로 영화 같은 컨셉 아트를 만들려면 어떤 도구를 사용할 수 있나요?", a: "Midjourney는 풍부한 예술적 방향, 극적인 조명, 사실적 및 애니메이션 스타일, 영화적 컨셉 아트, 주요 비주얼 및 브랜드 이미지에 대한 참조 이미지 지침을 결합합니다." },
                    { q: "Midjourney AI 이미지 생성기를 무료로 사용할 수 있나요?", a: "그렇습니다. 무료 크레딧을 받으려면 등록하고 Midjourney AI 이미지 생성기를 사용하여 즉시 고품질 이미지 생성을 시작하세요. 이미지 생성에는 해당 크레딧이 사용됩니다." },
                    { q: "Midjourney AI 이미지 생성기를 온라인으로 어떻게 사용하나요?", a: "피사체, 분위기, 조명 및 스타일을 설명하는 생생한 텍스트 프롬프트를 입력하고 패널에서 사실적 또는 애니메이션을 선택하고 선택적으로 최대 5개의 참조 이미지를 업로드한 다음 생성을 클릭합니다. Midjourney는 컨셉 아트, 주요 비주얼, 포스터, 인물 사진 및 편집 일러스트레이션에 적합합니다." },
                    { q: "현실적 스타일과 애니메이션 스타일의 차이점은 무엇입니까?", a: "사실적(Realistic)은 사진 같은 세부 묘사, 자연광 및 실제와 같은 질감을 선호하는 반면, 애니메이션(Anime)은 양식화된 선, 대담한 색상 및 손으로 그린 룩을 선호합니다. 패널에서 스타일을 선택하면 프롬프트가 장면 자체에 집중될 수 있습니다." },
                    { q: "내 참조와 일치하지 않는 Midjourney 이미지를 수정하는 방법은 무엇입니까?", a: "최대 5개의 명확한 참조 이미지(PNG, JPG, JPEG 또는 WebP)를 업로드하고 결과가 따라야 하는 색상 팔레트, 캐릭터 모양, 제품 모양 또는 전체적인 미학을 설명합니다." },
                    { q: "Midjourney 프롬프트의 가장 좋은 예는 무엇입니까?", a: "효과적인 Midjourney 프롬프트는 주제, 설정, 분위기, 조명 및 예술적 모습을 자세히 설명하고 해당 프롬프트를 패널의 올바른 스타일과 결합합니다. 이 페이지의 Midjourney 프롬프트 예시를 출발점으로 사용하여 프로젝트에 맞게 조정하세요." },
                    { q: "Midjourney vs Stable Diffusion 3.5: 어느 것을 사용해야 합니까?", a: "보편적인 승자가 아닌 작업 흐름을 기준으로 선택하세요. Midjourney는 Miral에서 미리 제작된 사실적 및 애니메이션 스타일을 갖춘 예술 감독 컨셉, 영화 조명 및 참조 안내 비주얼에 매우 적합합니다. Stable Diffusion 3.5는 명시적인 부정적인 프롬프트와 사용자 정의 크기의 유연한 종횡비가 필요한 제작자에게 적합할 수 있습니다." }
                ],
                ctaTitle: "Miral에서 Midjourney를 무료로 사용해 보세요!",
                ctaDesc: "위에 아이디어를 입력하고 사실적 또는 애니메이션 스타일과 참조 이미지 안내가 포함된 Midjourney AI 이미지 생성기를 사용하여 예술적인 비주얼을 만드세요."
            }
        }
  }
}
